export const LOADING = "LOADING";
export const LOADING_PROCESS = "LOADING_PROCESS";
export const NETWORK_ERROR = "NETWORK_ERROR";
export const NETWORK_ERROR_TRANSACTION = "NETWORK_ERROR_TRANSACTION";
export const NETWORK_ERROR_BALANCE = "NETWORK_ERROR_BALANCE";
export const RESET_APP = "RESET_APP";
export const FRONT_IMAGE_SUCCESS = "FRONT_IMAGE_SUCCESS";
export const FRONT_IMAGE_FAILED = "FRONT_IMAGE_FAILED";
export const LOADING_FRONT_IMAGE = "LOADING_FRONT_IMAGE";
export const RESET_FRONT_IMAGE = "RESET_FRONT_IMAGE";

export const BACK_IMAGE_SUCCESS = "BACK_IMAGE_SUCCESS";
export const BACK_IMAGE_FAILED = "BACK_IMAGE_FAILED";
export const LOADING_BACK_IMAGE = "LOADING_BACK_IMAGE";
export const RESET_BACK_IMAGE = "RESET_BACK_IMAGE";

export const UACS_SUCCESS = "UACS_SUCCESS";
export const UACS_FAILED = "UACS_FAILED";
export const LOADING_UACS = "LOADING_UACS";
export const RESET_UACS = "RESET_UACS";

//Login User
export const LOGIN = "LOGIN";
export const RESET_LOGIN = "RESET_LOGIN";
// export const LOGOUT = "LOGOUT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_NOT_AVAILABLE = "LOGIN_NOT_AVAILABLE";
export const LOGIN_APPROVAL_PENDING = "LOGIN_APPROVAL_PENDING";
export const LOGIN_KYC_PENDING = "LOGIN_KYC_PENDING";
export const LOGIN_KYB_PENDING = "LOGIN_KYB_PENDING";
export const LOGIN_DEALER_MISSING = "LOGIN_DEALER_MISSING";

export const LOGIN_INCORRECT_USERNAME_PASSWORD =
  "LOGIN_INCORRECT_USERNAME_PASSWORD";
export const GET_ERRORS = "GET_ERRORS";
export const ACCOUNT_LOCKED = "ACCOUNT_LOCKED";
export const NETWORK_ERROR_LOGIN = "NETWORK_ERROR_LOGIN";
export const LOADING_LOGIN = "LOADING_LOGIN";
export const WALLET_SETTING_SUCCESS = "WALLET_SETTING_SUCCESS";
export const WALLET_SETTING_FAILED = "WALLET_SETTING_FAILED";
export const WALLET_SETTING_INVALID_REQ = "WALLET_SETTING_INVALID_REQ";
export const LOADING_WALLET_SETTING = "LOADING_WALLET_SETTING";
export const RESET_WALLET_SETTING = "RESET_WALLET_SETTING";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILED = "LOGOUT_FAILED";
export const LOGOUT_INVALID_REQUEST = "LOGOUT_INVALID_REQUEST";
export const LOADING_LOGOUT = "LOADING_LOGOUT";
export const NETWORK_ERROR_LOGOUT = "NETWORK_ERROR_LOGOUT";
export const RESET_LOGOUT = "RESET_LOGOUT";

//forgot password
export const LOADING_FORGOT_PASSWORD = "LOADING_FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";
export const FORGOT_PASSWORD_LOCKED = "FORGOT_PASSWORD_LOCKED";
export const FORGOT_PASSWORD_QUESTION = "FORGOT_PASSWORD_QUESTION";
export const FORGOT_PASSWORD_INVALID_DETAILS =
  "FORGOT_PASSWORD_INVALID_DETAILS";
export const RESET_FORGOT_PASSWORD = "RESET_FORGOT_PASSWORD";

//Signup User
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILED = "SIGNUP_FAILED";
export const SIGNUP_INVALID_OTP = "SIGNUP_INVALID_OTP";
export const SIGNUP_ALREADY_REGISTERED = "SIGNUP_ALREADY_REGISTERED";
export const SIGNUP_INVALID_PASSWORD = "SIGNUP_INVALID_PASSWORD";
export const SIGNUP_INVALID_EMAIL = "SIGNUP_INVALID_EMAIL";
export const SIGNUP_INVALID_ADDRDETAILS = "SIGNUP_INVALID_ADDRDETAILS";
export const SIGNUP_INVALID_TELNOCC = "SIGNUP_INVALID_TELNOCC";
export const SIGNUP_INVALID_MOBILENUMBER = "SIGNUP_INVALID_MOBILENUMBER";
export const SIGNUP_INVALID_DOB = "SIGNUP_INVALID_DOB";
export const SIGNUP_INVALID_FIRSTNAME = "SIGNUP_INVALID_FIRSTNAME";
export const SIGNUP_INVALID_LASTNAME = "SIGNUP_INVALID_LASTNAME";
export const SIGNUP_INVALID_COUNTRY = "SIGNUP_INVALID_COUNTRY";
export const SIGNUP_INVALID_ACNTTYPE = "SIGNUP_INVALID_ACNTTYPE";
export const SIGNUP_INVALID_WALLETOWNNERID = "SIGNUP_INVALID_WALLETOWNNERID";
export const SIGNUP_INVALID_PLATFORMID = "SIGNUP_INVALID_PLATFORMID";
export const SIGNUP_INVALID_CURRENCY = "SIGNUP_INVALID_CURRENCY";
export const SIGNUP_INVALID_MOBILEOTP = "SIGNUP_INVALID_MOBILEOTP";
export const SIGNUP_INVALID_EMAILOTP = "SIGNUP_INVALID_EMAILOTP";
export const SIGNUP_INVALID_TERMSCONSENT = "SIGNUP_INVALID_TERMSCONSENT";
export const SIGNUP_INVALID_COUNTRYCODE = "SIGNUP_INVALID_COUNTRYCODE";
export const SIGNUP_INVALID_THANA = "SIGNUP_INVALID_THANA";
export const SIGNUP_INVALID_UNION = "SIGNUP_INVALID_UNION";

export const NETWORK_ERROR_SIGNUP = "NETWORK_ERROR_SIGNUP";
export const LOADING_SIGNUP = "LOADING_SIGNUP";
export const RESET_SIGNUP = "RESET_SIGNUP";

export const GETMAPPEDLIST_SUCCESS = "GETMAPPEDLIST_SUCCESS";
export const GETMAPPEDLIST_FAILED = "GETMAPPEDLIST_FAILED";
export const RESET_GETMAPPEDLIST = "RESET_GETMAPPEDLIST";
export const LOADING_GETMAPPEDLIST = " LOADING_GETMAPPEDLIST";
export const NETWORK_ERROR_GETMAPPEDLIST = "NETWORK_ERROR_GETMAPPEDLIST";

export const WALLET_ROLES_SUCCESS = "WALLET_ROLES_SUCCESS";
export const WALLET_ROLES_FAILED = "WALLET_ROLES_FAILED";
export const WALLET_ROLES_INVALID_WALLET_ID = "WALLET_ROLES_INVALID_WALLET_ID";
export const WALLET_ROLES_INVALID_TOKEN = "WALLET_ROLES_INVALID_TOKEN";
export const LOADING_WALLET_ROLES = "LOADING_WALLET_ROLES";
export const RESET_WALLET_ROLES = "RESET_WALLET_ROLES";

export const GET_DDT_SUCCESS = "GET_DDT_SUCCESS";
export const GET_DDT_FAILED = "GET_DDT_FAILED";
export const GET_DDT_INVALID_WALLET_ID = "GET_DDT_INVALID_WALLET_ID";
export const GET_DDT_INVALID_TOKEN = "GET_DDT_INVALID_TOKEN";
export const GET_DDT_INVALID_REQ = "GET_DDT_INVALID_REQ";
export const LOADING_GET_DDT = "LOADING_GET_DDT";
export const RESET_GET_DDT = "RESET_GET_DDT";

export const GET_BANKLIST_SUCCESS = "GET_BANKLIST_SUCCESS";
export const GET_BANKLIST_FAILED = "GET_BANKLIST_FAILED";
export const GET_BANKLIST_INVALID_WALLET_ID = "GET_BANKLIST_INVALID_WALLET_ID";
export const GET_BANKLIST_INVALID_TOKEN = "GET_BANKLIST_INVALID_TOKEN";
export const GET_BANKLIST_INVALID_REQ = "GET_BANKLIST_INVALID_REQ";
export const LOADING_GET_BANKLIST = "LOADING_GET_BANKLIST";
export const RESET_GET_BANKLIST = "RESET_GET_BANKLIST";

export const GET_BRANCHLIST_SUCCESS = "GET_BRANCHLIST_SUCCESS";
export const GET_BRANCHLIST_FAILED = "GET_BRANCHLIST_FAILED";
export const GET_BRANCHLIST_INVALID_WALLET_ID =
  "GET_BRANCHLIST_INVALID_WALLET_ID";
export const GET_BRANCHLIST_INVALID_TOKEN = "GET_BRANCHLIST_INVALID_TOKEN";
export const GET_BRANCHLIST_INVALID_REQ = "GET_BRANCHLIST_INVALID_REQ";
export const LOADING_GET_BRANCHLIST = "LOADING_GET_BRANCHLIST";
export const RESET_GET_BRANCHLIST = "RESET_GET_BRANCHLIST";

export const GET_POSTALCODES_SUCCESS = "GET_POSTALCODES_SUCCESS";
export const GET_POSTALCODES_FAILED = "GET_POSTALCODES_FAILED";
export const GET_POSTALCODES_INVALID_WALLET_ID =
  "GET_POSTALCODES_INVALID_WALLET_ID";
export const GET_POSTALCODES_INVALID_TOKEN = "GET_POSTALCODES_INVALID_TOKEN";
export const GET_POSTALCODES_INVALID_REQ = "GET_POSTALCODES_INVALID_REQ";
export const LOADING_GET_POSTALCODES = "LOADING_GET_POSTALCODES";
export const RESET_GET_POSTALCODES = "RESET_GET_POSTALCODES";

//Send Money
export const SEND_MONEY_NOT_FOUND = "SEND_MONEY_NOT_FOUND";
export const SEND_MONEY_FAILED = "SEND_MONEY_FAILED";
export const SEND_MONEY_INVALID_REQUEST = "SEND_MONEY_INVALID_REQUEST";
export const SEND_MONEY_CARD_NOT_FOUND = "SEND_MONEY_CARD_NOT_FOUND";
export const SEND_MONEY_SUCCESS = "SEND_MONEY_SUCCESS";
export const SEND_MONEY_OPERATION_NOT_PERMITTED =
  "SEND_MONEY_OPERATION_NOT_PERMITTED";
export const SEND_MONEY_INSUFFICIENT_BALANCE =
  "SEND_MONEY_INSUFFICIENT_BALANCE";
export const RESET_SEND_MONEY = "RESET_SEND_MONEY";
export const LOADING_SEND_MONEY = "LOADING_SEND_MONEY";

//Cashout
export const CASHOUT_NOT_FOUND = "CASHOUT_NOT_FOUND";
export const CASHOUT_FAILED = "CASHOUT_FAILED";
export const CASHOUT_INVALID_REQUEST = "CASHOUT_INVALID_REQUEST";
export const CASHOUT_CARD_NOT_FOUND = "CASHOUT_CARD_NOT_FOUND";
export const CASHOUT_SUCCESS = "CASHOUT_SUCCESS";
export const CASHOUT_INSUFFICIENT_BALANCE = "CASHOUT_INSUFFICIENT_BALANCE";
export const CASHOUT_AUTHENTICATION_FAILED = "CASHOUT_AUTHENTICATION_FAILED";
export const CASHOUT_INVALID_CURRENCY = "CASHOUT_INVALID_CURRENCY";
export const CASHOUT_ACCOUNT_NOT_EXISTS = "CASHOUT_ACCOUNT_NOT_EXISTS";
export const CASHOUT_INVALID_WALLET_OWNER_ID =
  "CASHOUT_INVALID_WALLET_OWNER_ID";
export const CASHOUT_INVALID_ACCOUNTTYPE = "CASHOUT_INVALID_ACCOUNTTYPE";
export const CASHOUT_OPERATION_NOT_PERMITTED =
  "CASHOUT_OPERATION_NOT_PERMITTED";
export const RESET_CASHOUT = "RESET_CASHOUT";
export const LOADING_CASHOUT = "LOADING_CASHOUT";

//Pay Order List
export const PAYORDER_LIST_SUCCESS = "PAYORDER_LIST_SUCCESS";
export const PAYORDER_LIST_FAILED = "PAYORDER_LIST_FAILED";
export const PAYORDER_LIST_INVALID_REQUEST = "PAYORDER_LIST_INVALID_REQUEST";
export const PAYORDER_LIST_NOT_FOUND = "PAYORDER_LIST_NOT_FOUND";
export const PAYORDER_LIST_ACCOUNT_NOT_EXISTS =
  "PAYORDER_LIST_ACCOUNT_NOT_EXISTS";
export const PAYORDER_LIST_INVALID_WALLET_OWNER_ID =
  "PAYORDER_LIST_INVALID_WALLET_OWNER_ID";
export const PAYORDER_LIST_INVALID_CUSTOMER_ID =
  "PAYORDER_LIST_INVALID_CUSTOMER_ID";
export const RESET_PAYORDER_LIST = "RESET_PAYORDER_LIST";
export const LOADING_PAYORDER_LIST = "LOADING_PAYORDER_LIST";

//Pay Order
export const PAY_ORDER_SUCCESS = "PAY_ORDER_SUCCESS";
export const PAY_ORDER_FAILED = "PAY_ORDER_FAILED";
export const PAY_ORDER_INVALID_REQUEST = "PAY_ORDER_INVALID_REQUEST";
export const PAY_ORDER_INVALID_CUSTOMER_ID = "PAY_ORDER_INVALID_CUSTOMER_ID";
export const PAY_ORDER_INVALID_WALLET_OWNER_ID =
  "PAY_ORDER_INVALID_WALLET_OWNER_ID";
export const PAY_ORDER_INVALID_AMOUNT = "PAY_ORDER_INVALID_AMOUNT";
export const PAY_ORDER_ACCOUNT_NOT_EXISTS = "PAY_ORDER_ACCOUNT_NOT_EXISTS";
export const PAY_ORDER_INSUFFICIENT_AMOUNT = "PAY_ORDER_INSUFFICIENT_AMOUNT";
export const PAY_ORDER_INVALID_INTEGRATION = "PAY_ORDER_INVALID_INTEGRATION";
export const PAY_ORDER_INVALID_TELCC = "PAY_ORDER_INVALID_TELCC";
export const PAY_ORDER_INVALID_PHONE = "PAY_ORDER_INVALID_PHONE";
export const PAY_ORDER_INVALID_NAME = "PAY_ORDER_INVALID_NAME";
export const PAY_ORDER_OPERATION_NOT_PERMITTED =
  "PAY_ORDER_OPERATION_NOT_PERMITTED";
export const RESET_PAY_ORDER = "RESET_PAY_ORDER";
export const LOADING_PAY_ORDER = "LOADING_PAY_ORDER";

//Verify Pay Order
export const PAY_ORDER_OTP_SUCCESS = "PAY_ORDER_OTP_SUCCESS";
export const PAY_ORDER_OTP_FAILED = "PAY_ORDER_OTP_FAILED";
export const PAY_ORDER_OTP_INVALID_REQUEST = "PAY_ORDER_OTP_INVALID_REQUEST";
export const PAY_ORDER_OTP_ACCOUNT_NOT_EXISTS =
  "PAY_ORDER_OTP_ACCOUNT_NOT_EXISTS";
export const PAY_ORDER_OTP_INVALID_ACCOUNTTYPE =
  "PAY_ORDER_OTP_INVALID_ACCOUNTTYPE";
export const PAY_ORDER_OTP_INVALID_PHONE = "PAY_ORDER_OTP_INVALID_PHONE";
export const PAY_ORDER_OTP_INVALID_CUSTOMER_ID =
  "PAY_ORDER_OTP_INVALID_CUSTOMER_ID";
export const PAY_ORDER_OTP_NO_OF_REQUEST_EXCEEDED =
  "PAY_ORDER_OTP_NO_OF_REQUEST_EXCEEDED";
export const PAY_ORDER_OTP_INVALID_TELCC = "PAY_ORDER_OTP_INVALID_TELCC";
export const LOADING_PAY_ORDER_OTP = "LOADING_PAY_ORDER_OTP";
export const RESET_PAY_ORDER_OTP = "RESET_PAY_ORDER_OTP";

export const VERIFY_PAYORDER_SUCCESS = "VERIFY_PAYORDER_SUCCESS";
export const VERIFY_PAYORDER_FAILED = "VERIFY_PAYORDER_FAILED";
export const VERIFY_PAYORDER_INVALID_REQUEST =
  "VERIFY_PAYORDER_INVALID_REQUEST";
export const VERIFY_PAYORDER_INVALID_CUSTOMER_ID =
  "VERIFY_PAYORDER_INVALID_CUSTOMER_ID";
export const VERIFY_PAYORDER_INVALID_WALLET_OWNER_ID =
  "VERIFY_PAYORDER_INVALID_WALLET_OWNER_ID";
export const VERIFY_PAYORDER_INVALID_AMOUNT = "VERIFY_PAYORDER_INVALID_AMOUNT";
export const VERIFY_PAYORDER_ACCOUNT_NOT_EXISTS =
  "VERIFY_PAYORDER_ACCOUNT_NOT_EXISTS";
export const VERIFY_PAYORDER_INSUFFICIENT_AMOUNT =
  "VERIFY_PAYORDER_INSUFFICIENT_AMOUNT";
export const VERIFY_PAYORDER_INVALID_INTEGRATION =
  "VERIFY_PAYORDER_INVALID_INTEGRATION";
export const VERIFY_PAYORDER_INVALID_TELCC = "VERIFY_PAYORDER_INVALID_TELCC";
export const VERIFY_PAYORDER_INVALID_PHONE = "VERIFY_PAYORDER_INVALID_PHONE";
export const VERIFY_PAYORDER_INVALID_NAME = "VERIFY_PAYORDER_INVALID_NAME";
export const VERIFY_PAYORDER_INVALID_OTP = "VERIFY_PAYORDER_INVALID_OTP";
export const LOADING_VERIFY_PAYORDER = "LOADING_VERIFY_PAYORDER";
export const RESET_VERIFY_PAYORDER = "RESET_VERIFY_PAYORDER";

export const VERIFY_QR_UNIQUEID_SUCCESS = "VERIFY_QR_UNIQUEID_SUCCESS";
export const VERIFY_QR_UNIQUEID_INVALID_REQUEST =
  "VERIFY_QR_UNIQUEID_INVALID_REQUEST";
export const VERIFY_QR_UNIQUEID_NUMBERNOTREGISTERED =
  "VERIFY_QR_UNIQUEID_NUMBERNOTREGISTERED";
export const LOADING_VERIFY_QR_UNIQUEID = "LOADING_VERIFY_QR_UNIQUEID";
export const RESET_VERIFY_QR_UNIQUEID = "RESET_VERIFY_QR_UNIQUEID";

//Delete Payorder
export const DELETE_PAYORDER_SUCCESS = "DELETE_PAYORDER_SUCCESS";
export const DELETE_PAYORDER_FAILED = "DELETE_PAYORDER_FAILED";
export const DELETE_PAYORDER_INVALID_REQUEST =
  "DELETE_PAYORDER_INVALID_REQUEST";
export const DELETE_PAYORDER_WALLET_ID_NOT_FOUND =
  "DELETE_PAYORDER_WALLET_ID_NOT_FOUND";
export const DELETE_PAYORDER_ACCOUNT_NOT_EXISTS =
  "DELETE_PAYORDER_ACCOUNT_NOT_EXISTS";
export const LOADING_DELETE_PAYORDER = "LOADING_DELETE_PAYORDER";
export const RESET_DELETE_PAYORDER = "RESET_DELETE_PAYORDER";

//Cashin
export const CASHIN_NOT_FOUND = "CASHIN_NOT_FOUND";
export const CASHIN_FAILED = "CASHIN_FAILED";
export const CASHIN_INVALID_REQUEST = "CASHIN_INVALID_REQUEST";
export const CASHIN_CARD_NOT_FOUND = "CASHIN_CARD_NOT_FOUND";
export const CASHIN_SUCCESS = "CASHIN_SUCCESS";
export const CASHIN_INSUFFICIENT_BALANCE = "CASHIN_INSUFFICIENT_BALANCE";
export const CASHIN_AUTHENTICATION_FAILED = "CASHIN_AUTHENTICATION_FAILED";
export const CASHIN_INVALID_CURRENCY = "CASHIN_INVALID_CURRENCY";
export const CASHIN_ACCOUNT_NOT_EXISTS = "CASHIN_ACCOUNT_NOT_EXISTS";
export const CASHIN_INVALID_WALLET_OWNER_ID = "CASHIN_INVALID_WALLET_OWNER_ID";
export const CASHIN_INVALID_ACCOUNTTYPE = "CASHIN_INVALID_ACCOUNTTYPE";
export const CASHIN_OPERATION_NOT_PERMITTED = "CASHIN_OPERATION_NOT_PERMITTED";
export const RESET_CASHIN = "RESET_CASHIN";
export const LOADING_CASHIN = "LOADING_CASHIN";

//Get Receiver Names
export const RECEIVER_SUCCESS = "RECEIVER_SUCCESS";
export const RECEIVER_FAILED = "RECEIVER_FAILED";
export const RECEIVER_NOT_FOUND = "RECEIVER_NOT_FOUND";
export const RECEIVER_INVALID_TOKEN = "RECEIVER_INVALID_TOKEN";
export const RECEIVER_WALLET_OWNER_ID = "RECEIVER_WALLET_OWNER_ID";
export const LOADING_RECEIVER = "LOADING_RECEIVER";
export const RESET_RECEIVER = "RESET_RECEIVER";

//Get User Details

export const GET_USERDETAILS_SUCCESS = "GET_USERDETAILS_SUCCESS";
export const GET_USERDETAILS_FAILED = "GET_USERDETAILS_FAILED";
export const GET_USERDETAILS_NOTFOUND = "GET_USERDETAILS_NOTFOUND";
export const GET_USERDETAILS_INVALIDREQUEST = "GET_USERDETAILS_INVALIDREQUEST";
export const LOADING_USERDETAILS = "LOADING_USERDETAILS";
export const RESET_USERDETAILS = "RESET_USERDETAILS";

//Request Money
export const REQUEST_MONEY_NOT_FOUND = "REQUEST_MONEY_NOT_FOUND";
export const REQUEST_MONEY_FAILED = "REQUEST_MONEY_FAILED";
export const REQUEST_MONEY_INVALID_REQUEST = "REQUEST_MONEY_INVALID_REQUEST";
export const REQUEST_MONEY_CARD_NOT_FOUND = "REQUEST_MONEY_CARD_NOT_FOUND";
export const REQUEST_MONEY_SUCCESS = "REQUEST_MONEY_SUCCESS";
export const NETWORK_ERROR_REQUEST = "NETWORK_ERROR_REQUEST";
export const REQUEST_MONEY_OPERATION_NOT_PERMITTED =
  "REQUEST_MONEY_OPERATION_NOT_PERMITTED";
export const RESET_REQUEST_MONEY = "RESET_REQUEST_MONEY";
export const LOADING_REQUEST_MONEY = "LOADING_REQUEST_MONEY";

//Withdraw Money
export const RESET_WITHDRAW_MONEY = "RESET_WITHDRAW_MONEY";
export const WITHDRAW_MONEY_OVERDUE = "WITHDRAW_MONEY_OVERDUE";
export const WITHDRAW_MONEY_LIMITNOTSET = "WITHDRAW_MONEY_LIMITNOTSET";
export const WITHDRAW_MONEY_FAILED = "WITHDRAW_MONEY_FAILED";
export const WITHDRAW_MONEY_INVALID_REQUEST = "WITHDRAW_MONEY_INVALID_REQUEST";
export const WITHDRAW_MONEY_DECLINED = "WITHDRAW_MONEY_DECLINED";
export const WITHDRAW_MONEY_SUCCESS = "WITHDRAW_MONEY_SUCCESS";
export const WITHDRAW_MONEY_INSUFFICIENT_AMOUNT =
  "WITHDRAW_MONEY_INSUFFICIENT_AMOUNT";
export const LOADING_WITHDRAW = "LOADING_WITHDRAW";

export const GET_WITHDRAW_DETAILS_INVALID_REQUEST =
  "GET_WITHDRAW_DETAILS_INVALID_REQUEST";
export const GET_WITHDRAW_DETAILS_FAILED = "GET_WITHDRAW_DETAILS_FAILED";
export const GET_WITHDRAW_DETAILS_CARD_NOT_FOUND =
  "GET_WITHDRAW_DETAILS_CARD_NOT_FOUND";
export const GET_WITHDRAW_DETAILS_NOT_FOUND = "GET_WITHDRAW_DETAILS_NOT_FOUND";
export const WITHDRAW_OPERATION_NOT_PERMITTED =
  "WITHDRAW_OPERATION_NOT_PERMITTED";
export const WITHDRAW_NOT_SUFFICIENT_LIMIT = "WITHDRAW_NOT_SUFFICIENT_LIMIT";
export const WITHDRAW_TRANSACTION_LIMIT_EXCEEDED =
  "WITHDRAW_TRANSACTION_LIMIT_EXCEEDED";
export const GET_WITHDRAW_DETAILS_SUCCESS = "GET_WITHDRAW_DETAILS_SUCCESS";
export const LOADING_GET_WITHDRAW = "LOADING_GET_WITHDRAW";

//Transaction History
export const TRANSACTION_FAILED = "TRANSACTION_FAILED";
export const TRANSACTION_INVALID_REQUEST = "TRANSACTION_INVALID_REQUEST";
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS";
export const TRANSACTION_NOT_FOUND = "TRANSACTION_NOT_FOUND";
export const RESET_TRANSACTION = "RESET_TRANSACTION";
export const LOADING_TRANSACTION = "LOADING_TRANSACTION";

//Transaction History Report
export const TRANSACTION_REPORT_SUCCESS = "TRANSACTION_REPORT_SUCCESS";
export const TRANSACTION_REPORT_FAILED = "TRANSACTION_REPORT_FAILED";
export const TRANSACTION_REPORT_INVALID_REQUEST =
  "TRANSACTION_REPORT_INVALID_REQUEST";
export const TRANSACTION_REPORT_NOT_FOUND = "TRANSACTION_REPORT_NOT_FOUND";
export const TRANSACTION_REPORT_EMAIL_NOT_FOUND =
  "TRANSACTION_REPORT_EMAIL_NOT_FOUND";
export const LOADING_TRANSACTION_REPORT = "LOADING_TRANSACTION_REPORT";
export const RESET_TRANSACTION_REPORT = "RESET_TRANSACTION_REPORT";

//Show Balance
export const SHOW_BALANCE_SUCCESS = "SHOW_BALANCE_SUCCESS";
export const SHOW_BALANCE_FAILED = "SHOW_BALANCE_FAILED";
export const SHOW_BALANCE_INVALID_HASH = "SHOW_BALANCE_INVALID_HASH";
export const LOADING_BALANCE = "LOADING_BALANCE";
export const RESET_BALANCE = "RESET_BALANCE";
export const SET_SELECTED_CURRENCY = "SET_SELECTED_CURRENCY";

//Profile
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED";
export const UPDATE_PROFILE_INVALID_REQUEST = "UPDATE_PROFILE_INVALID_REQUEST";
export const UPDATE_PROFILE_INVALID_NAME = "UPDATE_PROFILE_INVALID_NAME";
export const UPDATE_PROFILE_INVALID_STATE = "UPDATE_PROFILE_INVALID_STATE";
export const UPDATE_PROFILE_INVALID_CITY = "UPDATE_PROFILE_INVALID_CITY";
export const UPDATE_PROFILE_INVALID_COUNTRY = "UPDATE_PROFILE_INVALID_COUNTRY";
export const UPDATE_PROFILE_INVALID_GENDER = "UPDATE_PROFILE_INVALID_GENDER";
export const UPDATE_PROFILE_INVALID_ADDRESS = "UPDATE_PROFILE_INVALID_ADDRESS";
export const UPDATE_PROFILE_INVALID_ZIP = "UPDATE_PROFILE_INVALID_ZIP";
export const RESET_PROFILE = "RESET_PROFILE";
export const NETWORK_ERROR_PROFILE = "NETWORK_ERROR_PROFILE";
export const LOADING_PROFILE = "LOADING_PROFILE";
export const DELETE_PROFILE_PIC_SUCCESS = "DELETE_PROFILE_PIC_SUCCESS";
export const DELETE_PROFILE_PIC_FAILED = "DELETE_PROFILE_PIC_FAILED";
export const DELETE_PROFILE_PIC_INVALID_REQUEST =
  "DELETE_PROFILE_PIC_INVALID_REQUEST";
export const RESET_DELETE_PROFILE_PIC = "RESET_DELETE_PROFILE_PIC";
export const NETWORK_ERROR_DELETE_PROFILE_PIC =
  "NETWORK_ERROR_DELETE_PROFILE_PIC";
export const LOADING_DELETE_PROFILE_PIC = "LOADING_DELETE_PROFILE_PIC";
export const PROFILE_DETAILS_SUCCESS = "PROFILE_DETAILS_SUCCESS";
export const PROFILE_DETAILS_FAILED = "PROFILE_DETAILS_FAILED";
export const PROFILE_DETAILS_INVALID_REQUEST =
  "PROFILE_DETAILS_INVALID_REQUEST";
export const RESET_PROFILE_DETAILS = "RESET_PROFILE_DETAILS";
export const NETWORK_ERROR_PROFILE_DETAILS = "NETWORK_ERROR_PROFILE_DETAILS";
export const LOADING_PROFILE_DETAILS = "LOADING_PROFILE_DETAILS";
export const ADDUPDATE_BP_SUCCESS = "ADDUPDATE_BP_SUCCESS";
export const ADDUPDATE_BP_FAILED = "ADDUPDATE_BP_FAILED";
export const ADDUPDATE_BP_INVALID_REQUEST = "ADDUPDATE_BP_INVALID_REQUEST";
export const RESET_ADDUPDATE_BP = "RESET_ADDUPDATE_BP";
export const NETWORK_ERROR_ADDUPDATE_BP = "NETWORK_ERROR_ADDUPDATE_BP";
export const LOADING_ADDUPDATE_BP = "LOADING_ADDUPDATE_BP";

//Activity Logs
export const ACTIVITY_LOG_SUCCESS = "ACTIVITY_LOG_SUCCESS";
export const ACTIVITY_LOG_FAILED = "ACTIVITY_LOG_FAILED";
export const ACTIVITY_LOG_INVALID_REQUEST = "ACTIVITY_LOG_INVALID_REQUEST";
export const ACTIVITY_LOG_NOT_FOUND = "ACTIVITY_LOG_NOT_FOUND";
export const NETWORK_ERROR_ACTIVITY_LOG = "NETWORK_ERROR_ACTIVITY_LOG";
export const RESET_ACTIVITY_LOG = "RESET_ACTIVITY_LOG";
export const LOADING_ACTIVITY_LOG = "LOADING_ACTIVITY_LOG";

//Change Password
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const CHANGE_PASSWORD_INVALID_REQUEST =
  "CHANGE_PASSWORD_INVALID_REQUEST";
export const CHANGE_PASSWORD_INVALID_STRENGTH =
  "CHANGE_PASSWORD_INVALID_STRENGTH";
export const NETWORK_ERROR_CPASSWORD = "NETWORK_ERROR_CPASSWORD";
export const RESET_CPASSWORD = "RESET_CPASSWORD";
export const LOADING_PASSWORD = "LOADING_PASSWORD";

//pending list
export const PENDING_LIST_SUCCESS = "PENDING_LIST_SUCCESS";
export const PENDING_LIST_FAILED = "PENDING_LIST_FAILED";
export const PENDING_LIST_INVALID_REQUEST = "PENDING_LIST_INVALID_REQUEST";
export const PENDING_LIST_NOT_FOUND = "PENDING_LIST_NOT_FOUND";
export const NETWORK_ERROR_PENDING_LIST = "NETWORK_ERROR_PENDING_LIST";
export const RESET_PENDING_LIST = "RESET_PENDING_LIST";
export const RESET_SEND_PENDING_LIST = "RESET_SEND_PENDING_LIST";
export const RESET_CANCEL_PENDING_LIST = "RESET_CANCEL_PENDING_LIST";
export const CANCEL_PENDINGLIST_SUCCESS = "CANCEL_PENDINGLIST_SUCCESS";
export const CANCEL_PENDINGLIST_FAILED = "CANCEL_PENDINGLIST_FAILED";
export const CANCEL_PENDINGLIST_INVALID_REQUEST =
  "CANCEL_PENDINGLIST_INVALID_REQUEST";
export const NETWORK_ERROR_CANCEL_PENDING_LIST =
  "NETWORK_ERROR_CANCEL_PENDING_LIST";
export const SEND_PENDINGLIST_SUCCESS = "SEND_PENDINGLIST_SUCCESS";
export const SEND_PENDINGLIST_FAILED = "SEND_PENDINGLIST_FAILED";
export const SEND_PENDINGLIST_INVALID_REQUEST =
  "SEND_PENDINGLIST_INVALID_REQUEST";
export const SEND_PENDINGLIST_NOT_FOUND = "SEND_PENDINGLIST_NOT_FOUND";
export const SEND_PENDINGLIST_INSUFFICIENT_BALANCE =
  "SEND_PENDINGLIST_INSUFFICIENT_BALANCE";
export const NETWORK_ERROR_SEND_PENDING_LIST =
  "NETWORK_ERROR_SEND_PENDING_LIST";
// export const RESET_SEND_PENDING_LIST = "RESET_SEND_PENDING_LIST";
// export const RESET_CANCEL_PENDING_LIST = "RESET_CANCEL_PENDING_LIST";

//Pending List Count
export const PENDINGLIST_COUNT_SUCCESS = "PENDINGLIST_COUNT_SUCCESS";
export const PENDINGLIST_COUNT_FAILED = "PENDINGLIST_COUNT_FAILED";
export const LOADING_PENDINGLIST_COUNT = "LOADING_PENDINGLIST_COUNT";
export const RESET_PENDINGLIST_COUNT = "RESET_PENDINGLIST_COUNT";

//Loyalty Points
export const LOYALTY_POINTS_SUCCESS = "LOYALTY_POINTS_SUCCESS";
export const LOYALTY_POINTS_FAILED = "LOYALTY_POINTS_FAILED";
export const LOYALTY_POINTS_INVALID_REQUEST = "LOYALTY_POINTS_INVALID_REQUEST";
export const NETWORK_ERROR_LOYALTY_POINTS = "NETWORK_ERROR_LOYALTY_POINTS";
export const RESET_LOYALTY_POINTS = "RESET_LOYALTY_POINTS";
export const LOADING_LOYALTY = "LOADING_LOYALTY";

export const REDEEM_LOYALTY_POINTS_SUCCESS = "REDEEM_LOYALTY_POINTS_SUCCESS";
export const REDEEM_LOYALTY_POINTS_FAILED = "REDEEM_LOYALTY_POINTS_FAILED";
export const REDEEM_LOYALTY_POINTS_INVALID_REQ =
  "REDEEM_LOYALTY_POINTS_INVALID_REQ";
export const RESET_REDEEM_LOYALTY_POINTS = "RESET_REDEEM_LOYALTY_POINTS";
export const LOADING_REDEEM = "LOADING_REDEEM";

//Cards
export const SHOW_CARDS_SUCCESS = "SHOW_CARDS_SUCCESS";
export const SHOW_CARDS_FAILED = "SHOW_CARDS_FAILED";
export const SHOW_CARDS_INVALID_REQUEST = "SHOW_CARDS_INVALID_REQUEST";
export const SHOW_CARDS_NOT_FOUND = "SHOW_CARDS_NOT_FOUND";
export const RESET_SHOW_CARDS = "RESET_SHOW_CARDS";
export const LOADING_SHOW_CARDS = "LOADING_SHOW_CARDS";

export const ADD_CARD_SUCCESS = "ADD_CARD_SUCCESS";
export const ADD_CARD_FAILED = "ADD_CARD_FAILED";
export const ADD_CARD_INVALID_REQUEST = "ADD_CARD_INVALID_REQUEST";
export const ADD_CARD_EXIST = "ADD_CARD_EXIST";
export const RESET_ADD_CARD = "RESET_ADD_CARD";
export const LOADING_ADD_CARD = "LOADING_ADD_CARD";

export const DELETE_CARD_SUCCESS = "DELETE_CARD_SUCCESS";
export const DELETE_CARD_FAILED = "DELETE_CARD_FAILED";
export const DELETE_CARD_INVALID_REQUEST = "DELETE_CARD_INVALID_REQUEST";
export const RESET_DELETE_CARD = "RESET_DELETE_CARD";
export const LOADING_DELETE_CARD = "LOADING_DELETE_CARD";

//Add Balance
export const LOAD_PAYMENT_MODE = "LOAD_PAYMENT_MODE";
export const GET_PAYMENT_MODE_FAILED = "GET_PAYMENT_MODE_FAILED";
export const GET_PAYMENT_MODE_NOT_FOUND = "GET_PAYMENT_MODE_NOT_FOUND";
export const GET_PAYMENT_MODE_SUCCESS = "GET_PAYMENT_MODE_SUCCESS";
export const GET_PAYMENT_MODE_INVALID_REQUEST =
  "GET_PAYMENT_MODE_INVALID_REQUEST";
export const RESET_PAYMENT_MODE = "RESET_PAYMENT_MODE";
export const ADD_BALANCE_SUCCESS = "ADD_BALANCE_SUCCESS";
export const ADD_BALANCE_FAILED = "ADD_BALANCE_FAILED";
export const ADD_BALANCE_PENDING = "ADD_BALANCE_PENDING";
export const ADD_BALANCE_DECLINED = "ADD_BALANCE_DECLINED";
export const ADD_BALANCE_OPERATION_NOT_PERMITTED =
  "ADD_BALANCE_OPERATION_NOT_PERMITTED";
export const ADD_BALANCE_TRANSACTION_LIMIT_OVER =
  "ADD_BALANCE_TRANSACTION_LIMIT_OVER";
export const ADD_BALANCE_NOT_SUFFICIENT_LIMIT =
  "ADD_BALANCE_NOT_SUFFICIENT_LIMIT";
export const ADD_BALANCE_TRANSACTION_LIMIT_EXCEEDED =
  "ADD_BALANCE_TRANSACTION_LIMIT_EXCEEDED";
export const RESET_ADD_BALANCE = "RESET_ADD_BALANCE";
export const LOADING_ADD_BALANCE = "LOADING_ADD_BALANCE";

//Upgrade Wallet
export const UPGRADE_WALLET_FAILED = "UPGRADE_WALLET_FAILED";
export const UPGRADE_WALLET_NOT_ALLOWED = "UPGRADE_WALLET_NOT_ALLOWED";
export const UPGRADE_WALLET_SUCCESS = "UPGRADE_WALLET_SUCCESS";
export const UPGRADE_WALLET_IN_REVIEW = "UPGRADE_WALLET_IN_REVIEW";
export const UPGRADE_WALLET_INVALID_REQUEST = "UPGRADE_WALLET_INVALID_REQUEST";
export const RESET_UPGRADE_WALLET = "RESET_UPGRADE_WALLET";
export const NETWORK_ERROR_UPGRADE_WALLET = "NETWORK_ERROR_UPGRADE_WALLET";
export const LOADING_WALLET = "LOADING_WALLET";
export const KYC_DOC_LIST_SUCCESS = "KYC_DOC_LIST_SUCCESS";
export const KYC_DOC_LIST_FAILED = "KYC_DOC_LIST_FAILED";
export const KYC_DOC_LIST_LOADING = "KYC_DOC_LIST_LOADING";
export const KYC_DOC_LIST_INVALID_REQUEST = "KYC_DOC_LIST_INVALID_REQUEST";
export const RESET_KYC_DOC_LIST = "RESET_KYC_DOC_LIST";
export const LOAD_LIMIT_SUCCESS = "LOAD_LIMIT_SUCCESS";
export const LOAD_LIMIT_FAILED = "LOAD_LIMIT_FAILED";
export const LOAD_LIMIT_LOADING = "LOAD_LIMIT_LOADING";
export const LOAD_LIMIT_INVALID_REQUEST = "LOAD_LIMIT_INVALID_REQUEST";
export const RESET_LOAD_LIMIT = "RESET_LOAD_LIMIT";
export const RESET_GET_KYC_DETAILS = "RESET_GET_KYC_DETAILS";
export const GET_KYC_DETAILS_SUCCESS = "GET_KYC_DETAILS_SUCCESS";
export const GET_KYC_DETAILS_FAILED = "GET_KYC_DETAILS_FAILED";
export const GET_KYC_DETAILS_LOADING = "GET_KYC_DETAILS_LOADING";
export const GET_KYC_DETAILS_INVALID_REQUEST =
  "GET_KYC_DETAILS_INVALID_REQUEST";

//Dashboard Details
export const DASHBOARD_DETAILS_SUCCESS = "DASHBOARD_DETAILS_SUCCESS";
export const DASHBOARD_DETAILS_FAILED = "DASHBOARD_DETAILS_FAILED";
export const DASHBOARD_DETAILS_INVALID_REQUEST =
  "DASHBOARD_DETAILS_INVALID_REQUEST";
export const RESET_DASHBOARD_DETAILS = "RESET_DASHBOARD_DETAILS";
export const NETWORK_ERROR_DASHBOARD_DETAILS =
  "NETWORK_ERROR_DASHBOARD_DETAILS";
export const LOADING_DASHBOARD = "LOADING_DASHBOARD";

export const REGENERATE_SECKEY_SUCCESS = "REGENERATE_SECKEY_SUCCESS";
export const REGENERATE_SECKEY_NOT_AVAILABLE =
  "REGENERATE_SECKEY_NOT_AVAILABLE";
export const REGENERATE_SECKEY_INVALID_TOKEN =
  "REGENERATE_SECKEY_INVALID_TOKEN";
export const REGENERATE_SECKEY_WRONG_PASSWORD =
  "REGENERATE_SECKEY_WRONG_PASSWORD";
export const RESET_REGENERATE_SECKEY = "RESET_REGENERATE_SECKEY";
export const NETWORK_ERROR_REGENERATE_SECKEY =
  "NETWORK_ERROR_REGENERATE_SECKEY";

//Currency Conversion
export const CURRENCY_CONVERSION_SUCCESS = "CURRENCY_CONVERSION_SUCCESS";
export const CURRENCY_CONVERSION_INVALID_REQUEST =
  "CURRENCY_CONVERSION_INVALID_REQUEST";
export const RESET_CURRENCY_CONVERSION = "RESET_CURRENCY_CONVERSION";
export const NETWORK_ERROR_CURRENCY_CONVERSION =
  "NETWORK_ERROR_CURRENCY_CONVERSION";


  //partner getcurrency for search transaction
  // Get Transaction Currency List
export const GET_TRANSACTION_CURRENCY_LIST_REQUEST = "GET_TRANSACTION_CURRENCY_LIST_REQUEST";
export const GET_TRANSACTION_CURRENCY_LIST_SUCCESS = "GET_TRANSACTION_CURRENCY_LIST_SUCCESS";
export const GET_TRANSACTION_CURRENCY_LIST_FAILURE = "GET_TRANSACTION_CURRENCY_LIST_FAILURE";
export const RESET_GET_TRANSACTION_CURRENCY_LIST  = "RESET_GET_TRANSACTION_CURRENCY_LIST";

// export const LOADING_PROCESS = "LOADING_PROCESS";

//Operations
export const OPERATIONS_SUCCESS = "OPERATIONS_SUCCESS";
export const OPERATIONS_FAILED = "OPERATIONS_FAILED";
export const OPERATIONS_INVALID_REQUEST = "OPERATIONS_INVALID_REQUEST";
export const OPERATIONS_NOT_FOUND = "OPERATIONS_NOT_FOUND";
export const RESET_OPERATIONS = "RESET_OPERATIONS";
export const NETWORK_ERROR_OPERATIONS = "NETWORK_ERROR_OPERATIONS";
// export const FETCH_MORE_OPERATIONS = "FETCH_MORE_OPERATIONS";
export const LOADING_OPERATION = "LOADING_OPERATION";

//Currency List
export const CURRENCY_LIST_SUCCESS = "CURRENCY_LIST_SUCCESS";
export const CURRENCY_LIST_FAILED = "CURRENCY_LIST_FAILED";
export const CURRENCY_LIST_INVALID_REQUEST = "CURRENCY_LIST_INVALID_REQUEST";
export const CURRENCY_LIST_INVALID_TOKEN = "CURRENCY_LIST_INVALID_TOKEN";
export const RESET_CURRENCY_LIST = "RESET_CURRENCY_LIST";
export const NETWORK_ERROR_CURRENCY_LIST = "NETWORK_ERROR_CURRENCY_LIST";
// export const LOADING_PROCESS = "LOADING_PROCESS";

//Change Language
export const CHANGE_LANGUAGE_SUCCESS = "CHANGE_LANGUAGE_SUCCESS";

//InsertOTP
export const INSERT_OTP_SUCCESS = "INSERT_OTP_SUCCESS";
export const INSERT_OTP_FAILED = "INSERT_OTP_FAILED";
export const INSERT_OTP_ALREADY_REGISTERED = "INSERT_OTP_ALREADY_REGISTERED";
export const INSERT_OTP_INVALID_PASSWORD = "INSERT_OTP_INVALID_PASSWORD";
export const LOADING_INSERT_OTP = "LOADING_INSERT_OTP";
export const RESET_INSERT_OTP = "RESET_INSERT_OTP";

//OTP
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAILED = "SEND_OTP_FAILED";
export const SEND_OTP_INVALID_HASH = "SEND_OTP_INVALID_HASH";
export const SEND_OTP_INVALID_CUSTOMER = "SEND_OTP_INVALID_CUSTOMER";
export const SEND_OTP_INVALID_DETAILS_MOBILE =
  "SEND_OTP_INVALID_DETAILS_MOBILE";
export const SEND_OTP_INVALID_DETAILS_EMAIL = "SEND_OTP_INVALID_DETAILS_EMAIL";
export const LOADING_SEND_OTP = "LOADING_SEND_OTP";
export const RESET_SEND_OTP = "RESET_SEND_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_INVALID_OTP = "VERIFY_OTP_INVALID_OTP";
export const VERIFY_OTP_INVALID_HASH = "VERIFY_OTP_INVALID_HASH";
export const VERIFY_OTP_INVALID_CUSTOMER = "VERIFY_OTP_INVALID_CUSTOMER";
export const VERIFY_OTP_INVALID_DETAILS = "VERIFY_OTP_INVALID_DETAILS";
export const LOADING_VERIFY_OTP = "LOADING_VERIFY_OTP";
export const RESET_VERIFY_OTP = "RESET_SEND_OTP";

//Pay UI
export const PAY_NOT_FOUND = "PAY_NOT_FOUND";
export const PAY_FAILED = "PAY_FAILED";
export const PAY_FAILED_TRANSACTION = "PAY_FAILED_TRANSACTION";
export const PAY_INVALID_REQUEST = "PAY_INVALID_REQUEST";
export const PAY_INVALID_FLAG = "PAY_INVALID_FLAG";
export const PAY_INVALID_CURRENCY = "PAY_INVALID_CURRENCY";
export const PAY_INVALID_ACCOUNT_TYPE = "PAY_INVALID_ACCOUNT_TYPE";
export const PAY_INVALID_CUSTOMER_OPTION = "PAY_INVALID_CUSTOMER_OPTION";
export const PAY_SUCCESS = "PAY_SUCCESS";
export const PAY_INSUFFICIENT_AMOUNT = "PAY_INSUFFICIENT_AMOUNT";
export const PAY_WALLET_OWNER_ID_NOT_FOUND = "PAY_WALLET_OWNER_ID_NOT_FOUND";
export const PAY_OPERATION_NOT_PERMITTED = "PAY_OPERATION_NOT_PERMITTED";
export const RESET_PAY = "RESET_PAY";
export const LOADING_PAY = "LOADING_PAY";

//Default Currency
export const DEFAULT_CURRENCY_LIST_SUCCESS = "DEFAULT_CURRENCY_LIST_SUCCESS";
export const DEFAULT_CURRENCY_LIST_FAILED = "DEFAULT_CURRENCY_LIST_FAILED";
export const DEFAULT_CURRENCY_LIST_INVALID_REQUEST =
  "DEFAULT_CURRENCY_LIST_INVALID_REQUEST";
export const DEFAULT_CURRENCY_LIST_INVALID_TOKEN =
  "DEFAULT_CURRENCY_LIST_INVALID_TOKEN";
export const RESET_DEFAULT_CURRENCY_LIST = "RESET_DEFAULT_CURRENCY_LIST";
export const NETWORK_ERROR_DEFAULT_CURRENCY_LIST =
  "NETWORK_ERROR_DEFAULT_CURRENCY_LIST";
export const LOADING_DEFAULT_CURRENCY_LIST = "LOADING_DEFAULT_CURRENCY_LIST";

//Add/Edit Wallet
export const ADDEDIT_WALLET_SUCCESS = "ADDEDIT_WALLET_SUCCESS";
export const ADDEDIT_WALLET_FAILED = "ADDEDIT_WALLET_FAILED";
export const ADDEDIT_WALLET_INVALID_REQUEST = "ADDEDIT_WALLET_INVALID_REQUEST";
export const ADDEDIT_WALLET_INVALID_NAME = "ADDEDIT_WALLET_INVALID_NAME";
export const ADDEDIT_WALLET_ALREADY_EXIST = "ADDEDIT_WALLET_ALREADY_EXIST";
export const NETWORK_ERROR_ADDEDIT_WALLET = "NETWORK_ERROR_ADDEDIT_WALLET";
export const LOADING_WALLET_ADDEDIT = "LOADING_WALLET_ADDEDIT";
export const RESET_ADDEDIT_WALLET = "RESET_ADDEDIT_WALLET";
export const SHOW_SELECTED_WALLET = "SHOW_SELECTED_WALLET";
export const RESET_SELECTED_WALLET = "RESET_SELECTED_WALLET";

//Prepaid Card

//////Apply Prepaid Card
export const APPLY_PREPAIDCARD_SUCCESS = "APPLY_PREPAIDCARD_SUCCESS";
export const APPLY_PREPAIDCARD_FAILED = "APPLY_PREPAIDCARD_FAILED";
export const APPLY_PREPAIDCARD_INVALID_REQUEST =
  "APPLY_PREPAIDCARD_INVALID_REQUEST";
export const APPLY_PREPAIDCARD_INVALID_CURRENCY =
  "APPLY_PREPAIDCARD_INVALID_CURRENCY";
export const NETWORK_ERROR_APPLY_PREPAIDCARD =
  "NETWORK_ERROR_APPLY_PREPAIDCARD";
export const LOADING_APPLY_PREPAIDCARD = "LOADING_APPLY_PREPAIDCARD";
export const RESET_APPLY_PREPAIDCARD = "RESET_APPLY_PREPAIDCARD";

///// Get Prepaid Card
export const GET_PREPAIDCARD_SUCCESS = "GET_PREPAIDCARD_SUCCESS";
export const GET_PREPAIDCARD_FAILED = "GET_PREPAIDCARD_FAILED";
export const GET_PREPAIDCARD_NOTFOUND = "GET_PREPAIDCARD_NOTFOUND";
export const GET_PREPAIDCARD_INVALID_REQUEST =
  "GET_PREPAIDCARD_INVALID_REQUEST";
export const NETWORK_ERROR_GET_PREPAIDCARD = "NETWORK_ERROR_GET_PREPAIDCARD";
export const LOADING_GET_PREPAIDCARD = "LOADING_GET_PREPAIDCARD";
export const RESET_GET_PREPAIDCARD = "RESET_GET_PREPAIDCARD";

///// Prepaid Card Statement
export const PREPAIDCARD_STATEMENT_FAILED = "PREPAIDCARD_STATEMENT_FAILED";
export const PREPAIDCARD_STATEMENT_SUCCESS = "PREPAIDCARD_STATEMENT_SUCCESS";
export const PREPAIDCARD_STATEMENT_INVALID_REQUEST =
  "PREPAIDCARD_STATEMENT_INVALID_REQUEST";
// export const NETWORK_ERROR_GET_PREPAIDCARD = "NETWORK_ERROR_GET_PREPAIDCARD";
export const LOADING_PREPAIDCARD_STATEMENT = "LOADING_PREPAIDCARD_STATEMENT";
export const RESET_PREPAIDCARD_STATEMENT = "RESET_PREPAIDCARD_STATEMENT";
export const PREPAIDCARD_STATEMENT_NOTFOUND = "PREPAIDCARD_STATEMENT_NOTFOUND";

///// Load Money to Prepaid Card
export const LOADMONEYTO_PREPAIDCARD_SUCCESS =
  "LOADMONEYTO_PREPAIDCARD_SUCCESS";
export const LOADMONEYTO_PREPAIDCARD_FAILED = "LOADMONEYTO_PREPAIDCARD_FAILED";
export const LOADMONEYTO_PREPAIDCARD_INVALID_REQUEST =
  "LOADMONEYTO_PREPAIDCARD_INVALID_REQUEST";
export const NETWORK_ERROR_LOADMONEYTO_PREPAIDCARD =
  "NETWORK_ERROR_LOADMONEYTO_PREPAIDCARD";
export const LOADING_LOADMONEYTO_PREPAIDCARD =
  "LOADING_LOADMONEYTO_PREPAIDCARD";
export const RESET_LOADMONEYTO_PREPAIDCARD = "RESET_LOADMONEYTO_PREPAIDCARD";
export const LOADMONEYTO_PREPAIDCARD_NOTFOUND =
  "LOADMONEYTO_PREPAIDCARD_NOTFOUND";

///// Get Prepaid Card Balance
export const GET_PREPAIDCARDBALANCE_SUCCESS = "GET_PREPAIDCARDBALANCE_SUCCESS";
export const GET_PREPAIDCARDBALANCE_FAILED = "GET_PREPAIDCARDBALANCE_FAILED";
export const GET_PREPAIDCARDBALANCE_INVALID_REQUEST =
  "GET_PREPAIDCARDBALANCE_INVALID_REQUEST";
export const NETWORK_ERROR_GET_PREPAIDCARDBALANCE =
  "NETWORK_ERROR_GET_PREPAIDCARDBALANCE";
export const LOADING_GET_PREPAIDCARDBALANCE = "LOADING_GET_PREPAIDCARDBALANCE";
export const RESET_GET_PREPAIDCARDBALANCE = "RESET_GET_PREPAIDCARDBALANCE";
export const GET_PREPAIDCARDBALANCE_NOTFOUND =
  "GET_PREPAIDCARDBALANCE_NOTFOUND";

///// Activate Prepaid Card
export const ACTIVATE_PREPAIDCARD_SUCCESS = "ACTIVATE_PREPAIDCARD_SUCCESS";
export const ACTIVATE_PREPAIDCARD_FAILED = "ACTIVATE_PREPAIDCARD_FAILED";
export const ACTIVATE_PREPAIDCARD_INVALID_REQUEST =
  "ACTIVATE_PREPAIDCARD_INVALID_REQUEST";
export const NETWORK_ERROR_ACTIVATE_PREPAIDCARD =
  "NETWORK_ERROR_ACTIVATE_PREPAIDCARD";
export const LOADING_ACTIVATE_PREPAIDCARD = "LOADING_ACTIVATE_PREPAIDCARD";
export const RESET_ACTIVATE_PREPAIDCARD = "RESET_ACTIVATE_PREPAIDCARD";
export const ACTIVATE_PREPAIDCARD_NOTFOUND = "ACTIVATE_PREPAIDCARD_NOTFOUND";

///// Send CVV By SMS
export const SENDCVVBYSMS_SUCCESS = "SENDCVVBYSMS_SUCCESS";
export const SENDCVVBYSMS_FAILED = "SENDCVVBYSMS_FAILED";
export const SENDCVVBYSMS_INVALID_REQUEST = "SENDCVVBYSMS_INVALID_REQUEST";
export const NETWORK_ERROR_SENDCVVBYSMS = "NETWORK_ERROR_SENDCVVBYSMS";
export const LOADING_SENDCVVBYSMS = "LOADING_SENDCVVBYSMS";
export const RESET_SENDCVVBYSMS = "RESET_SENDCVVBYSMS";
export const SENDCVVBYSMS_NOTFOUND = "SENDCVVBYSMS_NOTFOUND";

///// Send PIN By SMS
export const SENDPINBYSMS_SUCCESS = "SENDPINBYSMS_SUCCESS";
export const SENDPINBYSMS_FAILED = "SENDPINBYSMS_FAILED";
export const SENDPINBYSMS_INVALID_REQUEST = "SENDPINBYSMS_INVALID_REQUEST";
export const NETWORK_ERROR_SENDPINBYSMS = "NETWORK_ERROR_SENDPINBYSMS";
export const LOADING_SENDPINBYSMS = "LOADING_SENDPINBYSMS";
export const RESET_SENDPINBYSMS = "RESET_SENDPINBYSMS";
export const SENDPINBYSMS_NOTFOUND = "SENDPINBYSMS_NOTFOUND";

///// Send CVV By Email
export const SENDPINBYEMAIL_SUCCESS = "SENDPINBYEMAIL_SUCCESS";
export const SENDPINBYEMAIL_FAILED = "SENDPINBYEMAIL_FAILED";
export const SENDPINBYEMAIL_INVALID_REQUEST = "SENDPINBYEMAIL_INVALID_REQUEST";
export const NETWORK_ERROR_SENDPINBYEMAIL = "NETWORK_ERROR_SENDPINBYEMAIL";
export const LOADING_SENDPINBYEMAIL = "LOADING_SENDPINBYEMAIL";
export const RESET_SENDPINBYEMAIL = "RESET_SENDPINBYEMAIL";
export const SENDPINBYEMAIL_NOTFOUND = "SENDPINBYEMAIL_NOTFOUND";

///// Convert virtual to physical card
export const CONVERTVIRTUAL_TO_PHYSICALCARD_SUCCESS =
  "CONVERTVIRTUAL_TO_PHYSICALCARD_SUCCESS";
export const CONVERTVIRTUAL_TO_PHYSICALCARD_FAILED =
  "CONVERTVIRTUAL_TO_PHYSICALCARD_FAILED";
export const CONVERTVIRTUAL_TO_PHYSICALCARD_INVALID_REQUEST =
  "CONVERTVIRTUAL_TO_PHYSICALCARD_INVALID_REQUEST";
export const NETWORK_ERROR_CONVERTVIRTUAL_TO_PHYSICALCARD =
  "NETWORK_ERROR_CONVERTVIRTUAL_TO_PHYSICALCARD";
export const LOADING_CONVERTVIRTUAL_TO_PHYSICALCARD =
  "LOADING_CONVERTVIRTUAL_TO_PHYSICALCARD";
export const RESET_CONVERTVIRTUAL_TO_PHYSICALCARD =
  "RESET_CONVERTVIRTUAL_TO_PHYSICALCARD";
export const CONVERTVIRTUAL_TO_PHYSICALCARD_NOTFOUND =
  "CONVERTVIRTUAL_TO_PHYSICALCARD_NOTFOUND";

///// Get Card Holder information
export const GETCARDHOLDER_DETAILS_SUCCESS = "GETCARDHOLDER_DETAILS_SUCCESS";
export const GETCARDHOLDER_DETAILS_FAILED = "GETCARDHOLDER_DETAILS_FAILED";
export const GETCARDHOLDER_DETAILS_INVALID_REQUEST =
  "GETCARDHOLDER_DETAILS_INVALID_REQUEST";
export const NETWORK_ERROR_GETCARDHOLDER_DETAILS =
  "NETWORK_ERROR_GETCARDHOLDER_DETAILS";
export const LOADING_GETCARDHOLDER_DETAILS = "LOADING_GETCARDHOLDER_DETAILS";
export const RESET_GETCARDHOLDER_DETAILS = "RESET_GETCARDHOLDER_DETAILS";
export const GETCARDHOLDER_DETAILS_NOTFOUND = "GETCARDHOLDER_DETAILS_NOTFOUND";

///// Update Card Holder information
export const UPDATECARDHOLDER_DETAILS_SUCCESS =
  "UPDATECARDHOLDER_DETAILS_SUCCESS";
export const UPDATECARDHOLDER_DETAILS_FAILED =
  "UPDATECARDHOLDER_DETAILS_FAILED";
export const UPDATECARDHOLDER_DETAILS_INVALID_REQUEST =
  "UPDATECARDHOLDER_DETAILS_INVALID_REQUEST";
export const NETWORK_ERROR_UPDATECARDHOLDER_DETAILS =
  "NETWORK_ERROR_UPDATECARDHOLDER_DETAILS";
export const LOADING_UPDATECARDHOLDER_DETAILS =
  "LOADING_UPDATECARDHOLDER_DETAILS";
export const RESET_UPDATECARDHOLDER_DETAILS = "RESET_UPDATECARDHOLDER_DETAILS";
export const UPDATECARDHOLDER_DETAILS_NOTFOUND =
  "UPDATECARDHOLDER_DETAILS_NOTFOUND";

///// Block Card
export const BLOCK_CARD_SUCCESS = "BLOCK_CARD_SUCCESS";
export const UNBLOCK_CARD_SUCCESS = "UNBLOCK_CARD_SUCCESS";
export const BLOCKUNBLOCK_CARD_FAILED = "BLOCKUNBLOCK_CARD_FAILED";
export const BLOCKUNBLOCK_CARD_NOT_FOUND = "BLOCKUNBLOCK_CARD_NOT_FOUND";
export const BLOCKUNBLOCK_CARD_INVALID_REQUEST =
  "BLOCKUNBLOCK_CARD_INVALID_REQUEST";
export const NETWORK_ERROR_BLOCKUNBLOCK_CARD =
  "NETWORK_ERROR_BLOCKUNBLOCK_CARD";
export const LOADING_BLOCKUNBLOCK_CARD = "LOADING_BLOCKUNBLOCK_CARD";
export const RESET_BLOCKUNBLOCK_CARD = "RESET_BLOCKUNBLOCK_CARD";

//Wallet To Wallet
export const W_TO_W_INVALID_REQUEST = "W_TO_W_INVALID_REQUEST";
export const W_TO_W_FAILED = "W_TO_W_FAILED";
export const W_TO_W_SUCCESS = "W_TO_W_SUCCESS";
export const W_TO_W_INVALID_WALLETID = "W_TO_W_INVALID_WALLETID";
export const W_TO_W_INVALID_AMOUNT = "W_TO_W_INVALID_AMOUNT";
export const W_TO_W_INVALID_WALLETOWNERID = "W_TO_W_INVALID_WALLETOWNERID";
export const W_TO_W_INVALID_CUSTOMERID = "W_TO_W_INVALID_CUSTOMERID";
export const W_TO_W_ACCOUNT_NOT_EXISTS = "W_TO_W_ACCOUNT_NOT_EXISTS";
export const W_TO_W_INVALID_CURRENCY = "W_TO_W_INVALID_CURRENCY";
export const W_TO_W_WALLETID_NOTFOUND = "W_TO_W_WALLETID_NOTFOUND";
export const W_TO_W_INSUF_AMOUNT = "W_TO_W_INSUF_AMOUNT";
export const W_TO_W_OPERATION_NOT_PERMITTED = "W_TO_W_OPERATION_NOT_PERMITTED";
export const LOADING_W_T_W = "LOADING_W_T_W";
export const RESET_W_TO_W = "RESET_W_TO_W";

//Load Money using API (Direct Load)
export const DIRECT_LOAD_SUCCESS = "DIRECT_LOAD_SUCCESS";
export const DIRECT_LOAD_FAILED = "DIRECT_LOAD_FAILED";
export const DIRECT_LOAD_DECLINED = "DIRECT_LOAD_DECLINED";
export const DIRECT_LOAD_INVALID_REQUEST = "DIRECT_LOAD_INVALID_REQUEST";
export const DIRECT_LOAD_INVALID_CVV = "DIRECT_LOAD_INVALID_CVV";
export const DIRECT_LOAD_NO_ACCOUNT = "DIRECT_LOAD_NO_ACCOUNT";
export const DIRECT_LOAD_3D = "DIRECT_LOAD_3D";
export const DIRECT_LOAD_OPERATION_NOT_PERMITTED =
  "DIRECT_LOAD_OPERATION_NOT_PERMITTED";
export const DIRECT_LOAD_TRANSACTION_LIMIT_OVER =
  "DIRECT_LOAD_TRANSACTION_LIMIT_OVER";
export const DIRECT_LOAD_NOT_SUFFICIENT_LIMIT =
  "DIRECT_LOAD_NOT_SUFFICIENT_LIMIT";
export const DIRECT_LOAD_TRANSACTION_LIMIT_EXCEEDED =
  "DIRECT_LOAD_TRANSACTION_LIMIT_EXCEEDED";
export const NETWORK_ERROR_DIRECT_LOAD = "NETWORK_ERROR_DIRECT_LOAD";
export const LOADING_DIRECT_LOAD = "LOADING_DIRECT_LOAD";
export const RESET_DIRECT_LOAD = "RESET_DIRECT_LOAD";

//Bank Transfer
export const BANK_TRANSFER_SUCCESS = "BANK_TRANSFER_SUCCESS";
export const BANK_TRANSFER_FAILED = "BANK_TRANSFER_FAILED";
export const BANK_TRANSFER_INVALID_REQUEST = "BANK_TRANSFER_INVALID_REQUEST";
export const BANK_TRANSFER_ACCOUNT_NOT_EXIST =
  "BANK_TRANSFER_ACCOUNT_NOT_EXIST";
export const BANK_TRANSFER_INVALID_CURRENCY = "BANK_TRANSFER_INVALID_CURRENCY";
export const BANK_TRANSFER_INVALID_AMOUNT = "BANK_TRANSFER_INVALID_AMOUNT";
export const BANK_TRANSFER_INVALID_WALLET_OWNDER_ID =
  "BANK_TRANSFER_INVALID_WALLET_OWNDER_ID";
export const BANK_TRANSFER_INVALID_CUSTOMER_ID =
  "BANK_TRANSFER_INVALID_CUSTOMER_ID";
export const NETWORK_ERROR_BANK_TRANSFER = "NETWORK_ERROR_BANK_TRANSFER";
export const LOADING_BANK_TRANSFER = "LOADING_BANK_TRANSFER";
export const RESET_BANK_TRANSFER = "RESET_BANK_TRANSFER";

//ADD BANKS
export const ADD_BANK_SUCCESS = "ADD_BANK_SUCCESS";
export const ADD_BANK_FAILED = "ADD_BANK_FAILED";
export const ADD_BANK_INVALID_REQUEST = "ADD_BANK_INVALID_REQUEST";
export const NETWORK_ERROR_ADD_BANK = "NETWORK_ERROR_ADD_BANK";
export const LOADING_ADD_BANK = "LOADING_ADD_BANK";
export const RESET_ADD_BANK = "RESET_ADD_BANK";

//GET MY BANKS
export const GET_BANK_SUCCESS = "GET_BANK_SUCCESS";
export const GET_BANK_FAILED = "GET_BANK_FAILED";
export const GET_BANK_INVALID_REQUEST = "GET_BANK_INVALID_REQUEST";
export const GET_BANK_NOT_FOUND = "GET_BANK_NOT_FOUND";
export const NETWORK_ERROR_GET_BANK = "NETWORK_ERROR_GET_BANK";
export const LOADING_GET_BANK = "LOADING_GET_BANK";
export const RESET_GET_BANK = "RESET_GET_BANK";

//MARKET PLACE
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAILED = "PRODUCT_LIST_FAILED";
export const PRODUCT_LIST_INVALID_REQUEST = "PRODUCT_LIST_INVALID_REQUEST";
export const PRODUCT_LIST_NOT_FOUND = "PRODUCT_LIST_NOT_FOUND";
export const LOADING_PRODUCT_LIST = "LOADING_PRODUCT_LIST";
export const RESET_PRODUCT_LIST = "RESET_PRODUCT_LIST";
export const ADDRESS_LIST_FAILED = "ADDRESS_LIST_FAILED";
export const ADDRESS_LIST_SUCCESS = "ADDRESS_LIST_SUCCESS";
export const ADDRESS_LIST_INVALID_REQUEST = "ADDRESS_LIST_INVALID_REQUEST";
export const ADDRESS_LIST_NOT_FOUND = "ADDRESS_LIST_NOT_FOUND";
export const LOADING_ADDRESS_LIST = "LOADING_ADDRESS_LIST";
export const RESET_ADDRESS_LIST = "RESET_ADDRESS_LIST";
export const SAVE_ADDRESS_FAILED = "SAVE_ADDRESS_FAILED";
export const SAVE_ADDRESS_SUCCESS = "SAVE_ADDRESS_SUCCESS";
export const SAVE_ADDRESS_INVALID_REQUEST = "SAVE_ADDRESS_INVALID_REQUEST";
export const SAVE_ADDRESS_NOT_FOUND = "SAVE_ADDRESS_NOT_FOUND";
export const LOADING_SAVE_ADDRESS = "LOADING_SAVE_ADDRESS";
export const RESET_SAVE_ADDRESS = "RESET_SAVE_ADDRESS";
export const DELETE_ADDRESS_FAILED = "DELETE_ADDRESS_FAILED";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_INVALID_REQUEST = "DELETE_ADDRESS_INVALID_REQUEST";
export const DELETE_ADDRESS_NOT_FOUND = "DELETE_ADDRESS_NOT_FOUND";
export const LOADING_DELETE_ADDRESS = "LOADING_DELETE_ADDRESS";
export const RESET_DELETE_ADDRESS = "RESET_DELETE_ADDRESS";
export const ADD_PRODUCT_FAILED = "ADD_PRODUCT_FAILED";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_INVALID_REQUEST = "ADD_PRODUCT_INVALID_REQUEST";
export const ADD_PRODUCT_NOT_FOUND = "ADD_PRODUCT_NOT_FOUND";
export const LOADING_ADD_PRODUCT = "LOADING_ADD_PRODUCT";
export const RESET_ADD_PRODUCT = "RESET_ADD_PRODUCT";
export const CART_LIST_SUCCESS = "CART_LIST_SUCCESS";
export const CART_LIST_FAILED = "CART_LIST_FAILED";
export const CART_LIST_INVALID_REQUEST = "CART_LIST_INVALID_REQUEST";
export const CART_LIST_NOT_FOUND = "CART_LIST_NOT_FOUND";
export const LOADING_CART_LIST = "LOADING_CART_LIST";
export const RESET_CART_LIST = "RESET_CART_LIST";
export const MP_CATEGORIES_SUCCESS = "MP_CATEGORIES_SUCCESS";
export const MP_CATEGORIES_FAILED = "MP_CATEGORIES_FAILED";
export const MP_CATEGORIES_INVALID_REQUEST = "MP_CATEGORIES_INVALID_REQUEST";
export const MP_CATEGORIES_NOT_FOUND = "MP_CATEGORIES_NOT_FOUND";
export const LOADING_MP_CATEGORIES = "LOADING_MP_CATEGORIES";
export const RESET_MP_CATEGORIES = "RESET_MP_CATEGORIES";

export const REMOVE_PRODUCT_FAILED = "REMOVE_PRODUCT_FAILED";
export const REMOVE_PRODUCT_SUCCESS = "REMOVE_PRODUCT_SUCCESS";
export const REMOVE_PRODUCT_INVALID_REQUEST = "REMOVE_PRODUCT_INVALID_REQUEST";
export const REMOVE_PRODUCT_NOT_FOUND = "REMOVE_PRODUCT_NOT_FOUND";
export const LOADING_REMOVE_PRODUCT = "LOADING_REMOVE_PRODUCT";
export const RESET_REMOVE_PRODUCT = "RESET_REMOVE_PRODUCT";

//Bank Payout
export const BANK_PAYOUT_SUCCESS = "BANK_PAYOUT_SUCCESS";
export const BANK_PAYOUT_FAILED = "BANK_PAYOUT_FAILED";
export const BANK_PAYOUT_INVALID_REQUEST = "BANK_PAYOUT_INVALID_REQUEST";
export const BANK_PAYOUT_INVALID_CUSTID = "BANK_PAYOUT_INVALID_CUSTID";
export const BANK_PAYOUT_INVALID_WALLET_OWNER_ID =
  "BANK_PAYOUT_INVALID_WALLET_OWNER_ID";
export const BANK_PAYOUT_INVALID_AMOUNT = "BANK_PAYOUT_INVALID_AMOUNT";
export const BANK_PAYOUT_ACCOUNT_NOT_EXIST = "BANK_PAYOUT_ACCOUNT_NOT_EXIST";
export const BANK_PAYOUT_INSUFF_FUND = "BANK_PAYOUT_INSUFF_FUND";
export const BANK_PAYOUT_INVALID_INTEGRATION =
  "BANK_PAYOUT_INVALID_INTEGRATION";
export const LOADING_BANK_PAYOUT = "LOADING_BANK_PAYOUT";
export const RESET_BANK_PAYOUT = "RESET_BANK_PAYOUT";
export const BUY_PRODUCT_FAILED = "BUY_PRODUCT_FAILED";
export const BUY_PRODUCT_SUCCESS = "BUY_PRODUCT_SUCCESS";
export const BUY_PRODUCT_INVALID_REQUEST = "BUY_PRODUCT_INVALID_REQUEST";
export const BUY_PRODUCT_INVALID_TYPE = "BUY_PRODUCT_INVALID_TYPE";
export const BUY_PRODUCT_NOT_FOUND = "BUY_PRODUCT_NOT_FOUND";
export const LOADING_BUY_PRODUCT = "LOADING_BUY_PRODUCT";
export const BUY_PRODUCT_OPERATION_NOT_PERMITTED =
  "BUY_PRODUCT_OPERATION_NOT_PERMITTED";
export const RESET_BUY_PRODUCT = "RESET_BUY_PRODUCT";
export const BUY_NOW_PRODUCT = "BUY_NOW_PRODUCT";
export const RESET_BUYNOW_PRODUCT = "RESET_BUYNOW_PRODUCT";
export const PROMO_CODE_FAILED = "PROMO_CODE_FAILED";
export const PROMO_CODE_SUCCESS = "PROMO_CODE_SUCCESS";
export const PROMO_CODE_INVALID_REQUEST = "PROMO_CODE_INVALID_REQUEST";
export const PROMO_CODE_NOT_FOUND = "PROMO_CODE_NOT_FOUND";
export const LOADING_PROMO_CODE = "LOADING_PROMO_CODE";
export const RESET_PROMO_CODE = "RESET_PROMO_CODE";
export const DELIVERY_ADDRESS = "DELIVERY_ADDRESS";
export const VENDOR_PRODUCTS_FAILED = "VENDOR_PRODUCTS_FAILED";
export const VENDOR_PRODUCTS_SUCCESS = "VENDOR_PRODUCTS_SUCCESS";
export const VENDOR_PRODUCTS_INVALID_REQUEST =
  "VENDOR_PRODUCTS_INVALID_REQUEST";
export const VENDOR_PRODUCTS_NOT_FOUND = "VENDOR_PRODUCTS_NOT_FOUND";
export const LOADING_VENDOR_PRODUCTS = "LOADING_VENDOR_PRODUCTS";
export const RESET_VENDOR_PRODUCTS = "RESET_VENDOR_PRODUCTS";
export const DELETE_VP_FAILED = "DELETE_VP_FAILED";
export const DELETE_VP_SUCCESS = "DELETE_VP_SUCCESS";
export const DELETE_VP_INVALID_REQUEST = "DELETE_VP_INVALID_REQUEST";
export const DELETE_VP_NOT_FOUND = "DELETE_VP_NOT_FOUND";
export const LOADING_DELETE_VP = "LOADING_DELETE_VP";
export const RESET_DELETE_VP = "RESET_DELETE_VP";
export const UPLOAD_PRODUCT_FAILED = "UPLOAD_PRODUCT_FAILED";
export const UPLOAD_PRODUCT_SUCCESS = "UPLOAD_PRODUCT_SUCCESS";
export const UPLOAD_PRODUCT_INVALID_REQUEST = "UPLOAD_PRODUCT_INVALID_REQUEST";
export const UPLOAD_PRODUCT_NOT_FOUND = "UPLOAD_PRODUCT_NOT_FOUND";
export const LOADING_UPLOAD_PRODUCT = "LOADING_UPLOAD_PRODUCT";
export const RESET_UPLOAD_PRODUCT = "RESET_UPLOAD_PRODUCT";
export const EDIT_VENDOR_PRODUCT = "EDIT_VENDOR_PRODUCT";
export const RESET_EDIT_VENDOR_PRODUCT = "RESET_EDIT_VENDOR_PRODUCT";
export const ORDERS_LIST_FAILED = "ORDERS_LIST_FAILED";
export const ORDERS_LIST_SUCCESS = "ORDERS_LIST_SUCCESS";
export const ORDERS_LIST_INVALID_REQUEST = "ORDERS_LIST_INVALID_REQUEST";
export const ORDERS_LIST_NOT_FOUND = "ORDERS_LIST_NOT_FOUND";
export const LOADING_ORDERS_LIST = "LOADING_ORDERS_LIST";
export const RESET_ORDERS_LIST = "RESET_ORDERS_LIST";
export const ORDERS_SELL_REPORT_FAILED = "ORDERS_SELL_REPORT_FAILED";
export const ORDERS_SELL_REPORT_SUCCESS = "ORDERS_SELL_REPORT_SUCCESS";
export const ORDERS_SELL_REPORT_INVALID_REQUEST =
  "ORDERS_SELL_REPORT_INVALID_REQUEST";
export const ORDERS_SELL_REPORT_NOT_FOUND = "ORDERS_SELL_REPORT_NOT_FOUND";
export const LOADING_ORDERS_SELL_REPORT = "LOADING_ORDERS_SELL_REPORT";
export const RESET_ORDERS_SELL_REPORT = "RESET_ORDERS_SELL_REPORT";
export const CHANGE_STATUS_FAILED = "CHANGE_STATUS_FAILED";
export const CHANGE_STATUS_SUCCESS = "CHANGE_STATUS_SUCCESS";
export const CHANGE_STATUS_INVALID_REQUEST = "CHANGE_STATUS_INVALID_REQUEST";
export const CHANGE_STATUS_NOT_FOUND = "CHANGE_STATUS_NOT_FOUND";
export const LOADING_CHANGE_STATUS = "LOADING_CHANGE_STATUS";
export const RESET_CHANGE_STATUS = "RESET_CHANGE_STATUS";

/*********** CHECKOUT ***********/

// Checkout Payment
export const CHECKOUT_PAYMENT_LOADING = "CHECKOUT_PAYMENT_LOADING";
export const CHECKOUT_PAYMENT_SUCCESS = "CHECKOUT_PAYMENT_SUCCESS";
export const CHECKOUT_PAYMENT_FAILED = "CHECKOUT_PAYMENT_FAILED";
export const CHECKOUT_PAYMENT_NETWORK_ERROR = "CHECKOUT_PAYMENT_NETWORK_ERROR";
export const CHECKOUT_PAYMENT_RESET = "CHECKOUT_PAYMENT_RESET";

//Checkout Login
export const CHK_LOGIN_SUCCESS = "CHK_LOGIN_SUCCESS";
export const CHK_LOGIN_FAILED = "CHK_LOGIN_FAILED";
export const CHK_ACCOUNT_LOCKED = "CHK_ACCOUNT_LOCKED";
export const CHK_NETWORK_ERROR = "CHK_NETWORK_ERROR";
export const CHK_RESET_LOGIN = "CHK_RESET_LOGIN";
export const CHK_LOGIN_LOADING = "CHK_LOGIN_LOADING";
export const CHK_INVALID_CREDENTIALS = "CHK_INVALID_CREDENTIALS";

//Get Payment Details
export const CHK_PAYMENT_DETAILS_SUCCESS = "CHK_PAYMENT_DETAILS_SUCCESS";
export const CHK_PAYMENT_DETAILS_FAILED = "CHK_PAYMENT_DETAILS_FAILED";
export const CHK_NETWORK_ERROR_PAYMENT_DETAILS =
  "CHK_NETWORK_ERROR_PAYMENT_DETAILS";
export const CHK_RESET_PAYMENT_DETAILS = "CHK_RESET_PAYMENT_DETAILS";
export const CHK_PAYMENT_DETAILS_LOADING = "CHK_PAYMENT_DETAILS_LOADING";

//Send Notification
export const SEND_NOTIFICATION_LOADING = "SEND_NOTIFICATION_LOADING";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_FAILED = "SEND_NOTIFICATION_FAILED";
export const SEND_NOTIFICATION_NETWORK_ERROR =
  "SEND_NOTIFICATION_NETWORK_ERROR";
export const SEND_NOTIFICATION_RESET = "SEND_NOTIFICATION_RESET";

export const CHK_SET_OPTION = "CHK_SET_OPTION";
export const CHK_SET_TRACKINGID = "CHK_SET_TRACKINGID";

export const MY_ORDERS_FAILED = "MY_ORDERS_FAILED";
export const MY_ORDERS_SUCCESS = "MY_ORDERS_SUCCESS";
export const MY_ORDERS_INVALID_REQUEST = "MY_ORDERS_INVALID_REQUEST";
export const MY_ORDERS_NOT_FOUND = "MY_ORDERS_NOT_FOUND";
export const LOADING_MY_ORDERS = "LOADING_MY_ORDERS";
export const RESET_MY_ORDERS = "RESET_MY_ORDERS";

export const CANCEL_PURORDER_FAILED = "CANCEL_PURORDER_FAILED";
export const CANCEL_PURORDER_SUCCESS = "CANCEL_PURORDER_SUCCESS";
export const CANCEL_PURORDER_INVALID_REQUEST =
  "CANCEL_PURORDER_INVALID_REQUEST";
export const CANCEL_PURORDER_NOT_FOUND = "CANCEL_PURORDER_NOT_FOUND";
export const LOADING_CANCEL_PURORDER = "LOADING_CANCEL_PURORDER";
export const RESET_CANCEL_PURORDER = "RESET_CANCEL_PURORDER";

//Fee Management
export const GET_FEE_FAILED = "GET_FEE_FAILED";
export const GET_FEE_SUCCESS = "GET_FEE_SUCCESS";
export const GET_FEE_NOT_EXISTS = "GET_FEE_NOT_EXISTS";
export const GET_FEE_INVALID_REQUEST = "GET_FEE_INVALID_REQUEST";
export const GET_FEE_NOT_FOUND = "GET_FEE_NOT_FOUND";
export const LOADING_GET_FEE = "LOADING_GET_FEE";
export const RESET_GET_FEE = "RESET_GET_FEE";

// GET FEE MARKUP LIST
export const GET_FEE_MARKUP_LIST_SUCCESS       = "GET_FEE_MARKUP_LIST_SUCCESS";
export const GET_FEE_MARKUP_LIST_FAILED        = "GET_FEE_MARKUP_LIST_FAILED";
export const RESET_GET_FEE_MARKUP_LIST         = "RESET_GET_FEE_MARKUP_LIST";
export const LOADING_GET_FEE_MARKUP_LIST       = "LOADING_GET_FEE_MARKUP_LIST";
export const NETWORK_ERROR_GET_FEE_MARKUP_LIST = "NETWORK_ERROR_GET_FEE_MARKUP_LIST";
 
// ADD FEE MARKUP
export const ADD_FEE_MARKUP_SUCCESS            = "ADD_FEE_MARKUP_SUCCESS";
export const ADD_FEE_MARKUP_FAILED             = "ADD_FEE_MARKUP_FAILED";
export const RESET_ADD_FEE_MARKUP              = "RESET_ADD_FEE_MARKUP";
export const LOADING_ADD_FEE_MARKUP            = "LOADING_ADD_FEE_MARKUP";
export const NETWORK_ERROR_ADD_FEE_MARKUP      = "NETWORK_ERROR_ADD_FEE_MARKUP";
 
// UPDATE FEE MARKUP
export const UPDATE_FEE_MARKUP_SUCCESS         = "UPDATE_FEE_MARKUP_SUCCESS";
export const UPDATE_FEE_MARKUP_FAILED          = "UPDATE_FEE_MARKUP_FAILED";
export const RESET_UPDATE_FEE_MARKUP           = "RESET_UPDATE_FEE_MARKUP";
export const LOADING_UPDATE_FEE_MARKUP         = "LOADING_UPDATE_FEE_MARKUP";
export const NETWORK_ERROR_UPDATE_FEE_MARKUP   = "NETWORK_ERROR_UPDATE_FEE_MARKUP";
 

//DASHBOARD FEE DETAILS
export const DB_FEE_SUCCESS = "DB_FEE_SUCCESS";
export const DB_FEE_FAILED = "DB_FEE_FAILED";
export const DB_FEE_NETWORK_ERROR = "DB_FEE_NETWORK_ERROR";
export const DB_FEE_RESET = "DB_FEE_RESET";

//VERIFY MOBILE
export const VERIFY_MOBILE_FAILED = "VERIFY_MOBILE_FAILED";
export const VERIFY_MOBILE_SUCCESS = "VERIFY_MOBILE_SUCCESS";
export const VERIFY_MOBILE_NOT_EXISTS = "VERIFY_MOBILE_NOT_EXISTS";
export const VERIFY_MOBILE_INVALID_REQUEST = "VERIFY_MOBILE_INVALID_REQUEST";
export const VERIFY_MOBILE_NOT_FOUND = "VERIFY_MOBILE_NOT_FOUND";
export const LOADING_VERIFY_MOBILE = "LOADING_VERIFY_MOBILE";
export const RESET_VERIFY_MOBILE = "RESET_VERIFY_MOBILE";

//CANCEL CHECKOUT PAYMENT
export const CANCEL_CHK_PAYMENT_LOADING = "CANCEL_CHK_PAYMENT_LOADING";
export const CANCEL_CHK_PAYMENT_SUCCESS = "CANCEL_CHK_PAYMENT_SUCCESS";
export const CANCEL_CHK_PAYMENT_FAILED = "CANCEL_CHK_PAYMENT_FAILED";
export const CANCEL_CHK_PAYMENT_NETWORK_ERROR =
  "CANCEL_CHK_PAYMENT_NETWORK_ERROR";
export const RESET_CANCEL_CHK_PAYMENT = "RESET_CANCEL_CHK_PAYMENT";

//MARKETPLACE BULK PRODUCT UPLOAD
export const LOADING_BULK_UPLOAD = "LOADING_BULK_UPLOAD";
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAILED = "BULK_UPLOAD_FAILED";
export const RESET_BULK_UPLOAD = "RESET_BULK_UPLOAD";
export const NETWORK_ERROR_BULK_UPLOAD = "NETWORK_ERROR_BULK_UPLOAD";

//VOUCHERS

export const VOUCHER_RATE_SUCCESS = "VOUCHER_RATE_SUCCESS";
export const VOUCHER_RATE_FAILED = "VOUCHER_RATE_FAILED";
export const LOADING_VOUCHER_RATE = "LOADING_VOUCHER_RATE";
export const RESET_VOUCHER_RATE = "RESET_VOUCHER_RATE";
export const VOUCHER_TOGGLE = "VOUCHER_TOGGLE";

export const MYVOUCHERS_SUCCESS = "MYVOUCHERS_SUCCESS";
export const MYVOUCHERS_FAILED = "MYVOUCHERS_FAILED";
export const LOADING_MYVOUCHERS = "LOADING_MYVOUCHERS";
export const RESET_MYVOUCHERS = "RESET_MYVOUCHERS";

export const VOUCHER_TRANSACTION_SUCCESS = "VOUCHER_TRANSACTION_SUCCESS";
export const VOUCHER_TRANSACTION_FAILED = "VOUCHER_TRANSACTION_FAILED";
export const RESET_VOUCHER_TRANSACTION = "RESET_VOUCHER_TRANSACTION";
export const LOADING_VOUCHER_TRANSACTION = "LOADING_VOUCHER_TRANSACTION";
export const NETWORK_ERROR_VOUCHER_TRANSACTION =
  "NETWORK_ERROR_VOUCHER_TRANSACTION";

export const VOUCHER_DETAILS_SUCCESS = "VOUCHER_DETAILS_SUCCESS";
export const VOUCHER_DETAILS_FAILED = "VOCUHER_DETAILS_FAILED";
export const RESET_VOUHCER_DETAILS = "RESET_VOCUHER_DETAILS";
export const LOADING_VOUCHER_DETAILS = "LOADING_VOUCHER_DETAILS";
export const NETWORK_ERROR_VOUCHER_DETAILS = "NETWORK_ERROR_VOUCHER_DETAILS";

export const TRANSACTION_DETAILS_SUCCESS = "TRANSACTION_DETAILS_SUCCESS";
export const TRANSACTION_DETAILS_FAILED = " TRANSACTION_DETAILS_FALIED";
export const RESET_TRANSACTION_DETAILS = "RESET_TRANSACTION_DETAILS";
export const LOADING_TRANSACTION_DETAILS = "LOADING_TRANSACTION_DETAILS";
export const NETWORK_ERROR_TRANSACTION_DETAILS =
  "NETWORK_ERROR_TRANSACTION_DETAILS";

export const VOUCHER_DASHBOARD_DETAILS_SUCCESS =
  "VOUCHER_DASHBOARD_DETAILS_SUCCESS";
export const VOUCHER_DASHBOARD_DETAILS_FAILED =
  "VOUCHER_DASHBOARD_DETAILS_FAILED";
export const RESET_VOUCHER_DASHBOARD_DETAILS =
  "RESET_VOUCHER_DASHBOARD_DETAILS";
export const LOADING_VOUCHER_DASHBOARD_DETAILS =
  "LOADING_VOUCHER_DASHBOARD_DETAILS";
export const NETWORK_ERROR_VOUCHER_DASHBOARD_DETAILS =
  "LOADING_VOUCHER_DASHBOARD_DETAILS";

export const MERCHANT_DASHBOARD_DETAILS_SUCCESS =
  "MERCHANT_DASHBOARD_DETAILS_SUCCESS";
export const MERCHANT_DASHBOARD_DETAILS_FAILED =
  "MERCHANT_DASHBOARD_DETAILS_FAILED";
export const RESET_MERCHANT_DASHBOARD_DETAILS =
  "RESET_MERCHANT_DASHBOARD_DETAILS";
export const LOADING_MERCHANT_DASHBOARD_DETAILS =
  "LOADING_MERCHANT_DASHBOARD_DETAILS";
export const NETWORK_ERROR_MERCHANT_DASHBOARD_DETAILS =
  "NETWORK_ERROR_MERCHANT_DASHBOARD_DETAILS";

export const MERCHANT_DASHBOARD_PERCURRENCY_SUCCESS =
  "MERCHANT_DASHBOARD_PERCURRENCY_SUCCESS";
export const MERCHANT_DASHBOARD_PERCURRENCY_FAILED =
  "MERCHANT_DASHBOARD_PERCURRENCY_FAILED";
export const RESET_MERCHANT_DASHBOARD_PERCURRENCY =
  "RESET_MERCHANT_DASHBOARD_PERCURRENCY";
export const LOADING_MERCHANT_DASHBOARD_PERCURRENCY =
  "LOADING_MERCHANT_DASHBOARD_PERCURRENCY";
export const NETWORK_ERROR_MERCHANT_DASHBOARD_PERCURRENCY =
  "LOADING_MERCHANT_DASHBOARD_PERCURRENCY";

export const SETTLEMENT_REPORT_SUCCESS = "SETTLEMENT_REPORT_SUCCESS";
export const SETTLEMENT_REPORT_FAILED = "SETTLEMENT_REPORT_FAILED";
export const RESET_SETTLEMENT_REPORT = " RESET_SETTLEMENT_REPORT";
export const LOADING_SETTLEMENT_REPORT = " LOADING_SETTLEMENT_REPORT";
export const NETWORK_ERROR_SETTLEMENT_REPORT =
  " NETWORK_ERROR_SETTLEMENT_REPORT";

export const SETTLEMENT_DETAILS_SUCCESS = "SETTLEMENT_DETAILS_SUCCESS";
export const SETTLEMENT_DETAILS_FAILED = "SETTLEMENT_DETAILS_FAILED";
export const RESET_SETTLEMENT_DETAILS = " RESET_SETTLEMENT_DETAILS";
export const LOADING_SETTLEMENT_DETAILS = " LOADING_SETTLEMENT_DETAILS";
export const NETWORK_ERROR_SETTLEMENT_DETAILS =
  " NETWORK_ERROR_SETTLEMENT_DETAILS";

export const SETTLEMENT_REPORT_FILE_SUCCESS = "SETTLEMENT_REPORT_FILE_SUCCESS";
export const SETTLEMENT_REPORT_FILE_FAILED = "SETTLEMENT_REPORT_FILE_FAILED";
export const RESET_SETTLEMENT_REPORT_FILE = "RESET_SETTLEMENT_REPORT_FILE";
export const LOADING_SETTLEMENT_REPORT_FILE = "LOADING_SETTLEMENT_REPORT_FILE";
export const NETWORK_ERROR_SETTLEMENT_REPORT_FILE =
  "NETWORK_ERROR_SETTLEMENT_REPORT_FILE";

export const GENERATE_MERCHANT_KEY_SUCCESS = "GENERATE_MERCHANT_KEY_SUCCESS";
export const GENERATE_MERCHANT_KEY_FAILED = "GENERATE_MERCHANT_KEY_FAILED";
export const RESET_GENERATE_MERCHANT_KEY = "RESET_GENERATE_MERCHANT_KEY";
export const LOADING_GENERATE_MERCHANT_KEY = "LOADING_GENERATE_MERCHANT_KEY";
export const NETWORK_ERROR_GENERATE_MERCHANT_KEY =
  "NETWORK_ERROR_GENERATE_MERCHANT_KEY";

export const GET_MERCHANT_KEY_SUCCESS = "GET_MERCHANT_KEY_SUCCESS";
export const GET_MERCHANT_KEY_FAILED = "GET_MERCHANT_KEY_FAILED";
export const RESET_GET_MERCHANT_KEY = "RESET_GET_MERCHANT_KEY";
export const LOADING_GET_MERCHANT_KEY = "LOADING_GET_MERCHANT_KEY";
export const NETWORK_ERROR_GET_MERCHANT_KEY = "NETWORK_ERROR_GET_MERCHANT_KEY";

export const PURCHASE_VOUCHERS_SUCCESS = "PURCHASE_VOUCHERS_SUCCESS";
export const PURCHASE_VOUCHERS_FAILED = "PURCHASE_VOUCHERS_FAILED";
export const RESET_PURCHASE_VOUCHERS = "RESET_PURCHASE_VOUCHERS";
export const LOADING_PURCHASE_VOUCHERS = "LOADING_PURCHASE_VOUCHERS";
export const NETWORK_ERROR_PURCHASE_VOUCHERS =
  "NETWORK_ERROR_PURCHASE_VOUCHERS";
export const VOUCHER_CHECKOUT_RESET = "VOUCHER_CHECKOUT_RESET";
export const VOUCHER_CHECKOUT_LOADING = "VOUCHER_CHECKOUT_LOADING";
export const VOUCHER_CHECKOUT_DECLINED = "VOUCHER_CHECKOUT_DECLINED";
export const VOUCHER_CHECKOUT_SUCCESS = "VOUCHER_CHECKOUT_SUCCESS";
export const VOUCHER_CHECKOUT_FAILED = "VOUCHER_CHECKOUT_FAILED";
export const VOUCHER_CHECKOUT_PENDING = "VOUCHER_CHECKOUT_PENDING";
export const VOUCHER_CHECKOUT_OPERATION_NOT_PERMITTED =
  "VOUCHER_CHECKOUT_OPERATION_NOT_PERMITTED";
export const VOUCHER_CHECKOUT_TRANSACTION_LIMIT_OVER =
  "VOUCHER_CHECKOUT_TRANSACTION_LIMIT_OVER";
export const VOUCHER_CHECKOUT_NOT_SUFFICIENT_LIMIT =
  "VOUCHER_CHECKOUT_NOT_SUFFICIENT_LIMIT";
export const VOUCHER_CHECKOUT_TRANSACTION_LIMIT_EXCEEDED =
  "VOUCHER_CHECKOUT_TRANSACTION_LIMIT_EXCEEDED";

export const TRANSACTION_PASSWORD_SET_SUCCESS =
  "TRANSACTION_PASSWORD_SET_SUCCESS";
export const TRANSACTION_PASSWORD_SET_FAILED =
  "TRANSACTION_PASSWORD_SET_FAILED";
export const RESET_TRANSACTION_PASSWORD_SET = "RESET_TRANSACTION_PASSWORD_SET";
export const LOADING_TRANSACTION_PASSWORD_SET =
  "LOADING_TRANSACTION_PASSWORD_SET";
export const NETWORK_ERROR_TRANSACTION_PASSWORD_SET =
  "NETWORK_ERROR_TRANSACTION_PASSWORD_SET";

export const SET_TRANSACTION_PASSWORD_SUCCESS =
  "SET_TRANSACTION_PASSWORD_SUCCESS";
export const SET_TRANSACTION_PASSWORD_FAILED =
  "SET_TRANSACTION_PASSWORD_FAILED";
export const RESET_SET_TRANSACTION_PASSWORD = "RESET_SET_TRANSACTION_PASSWORD";
export const LOADING_SET_TRANSACTION_PASSWORD =
  "LOADING_SET_TRANSACTION_PASSWORD";
export const NETWORK_ERROR_SET_TRANSACTION_PASSWORD =
  "NETWORK_ERROR_SET_TRANSACTION_PASSWORD";

export const CHANGE_TRANSACTION_PASSWORD_SUCCESS =
  "SET_TRANSACTION_PASSWORD_SUCCESS";
export const CHANGE_TRANSACTION_PASSWORD_FAILED =
  "SET_TRANSACTION_PASSWORD_FAILED";
export const RESET_CHANGE_TRANSACTION_PASSWORD =
  "RESET_SET_TRANSACTION_PASSWORD";
export const LOADING_CHANGE_TRANSACTION_PASSWORD =
  "LOADING_SET_TRANSACTION_PASSWORD";
export const NETWORK_ERROR_CHANGE_TRANSACTION_PASSWORD =
  "NETWORK_ERROR_SET_TRANSACTION_PASSWORD";

export const FORGOT_TRANSACTION_PASSWORD_SUCCESS =
  "SET_TRANSACTION_PASSWORD_SUCCESS";
export const FORGOT_TRANSACTION_PASSWORD_FAILED =
  "SET_TRANSACTION_PASSWORD_FAILED";
export const RESET_FORGOT_TRANSACTION_PASSWORD =
  "RESET_SET_TRANSACTION_PASSWORD";
export const LOADING_FORGOT_TRANSACTION_PASSWORD =
  "LOADING_SET_TRANSACTION_PASSWORD";
export const NETWORK_ERROR_FORGOT_TRANSACTION_PASSWORD =
  "NETWORK_ERROR_SET_TRANSACTION_PASSWORD";

export const TRANSACTION_REFUND_SUCCESS = "TRANSACTION_REFUND_SUCCESS";
export const TRANSACTION_REFUND_FAILED = "TRANSACTION_REFUND_FAILED";
export const RESET_TRANSACTION_REFUND = "RESET_TRANSACTION_REFUND";
export const LOADING_TRANSACTION_REFUND = "LOADING_TRANSACTION_REFUND";
export const NETWORK_ERROR_TRANSACTION_REFUND =
  "NETWORK_ERROR_RESET_TRANSACTION_REFUND";

// Wallet Admin Part

export const LOGIN_ROLE_SUCCESS = "LOGIN_ROLE_SUCCESS";
export const LOGIN_ROLE_FAILED = "LOGIN_ROLE_FAILED";
export const RESET_LOGIN_ROLE = "RESET_LOGIN_ROLE";
export const LOADING_LOGIN_ROLE = "LOADING_LOGIN_ROLE";
export const NETWORK_ERROR_LOGIN_ROLE = "NETWORK_ERROR_LOGIN_ROLE";

export const PARTNER_LOGIN_SUCCESS = "PARTNER_LOGIN_SUCCESS";
export const PARTNER_LOGIN_FAILED = "PARTNER_LOGIN_FAILED";
export const RESET_PARTNER_LOGIN = "RESET_PARTNER_LOGIN";
export const LOADING_PARTNER_LOGIN = "LOADING_PARTNER_LOGIN";
export const NETWORK_ERROR_PARTNER_LOGIN = "NETWORK_ERROR_PARTNER_LOGIN";

export const AUTH_TOKEN_SUCCESS = "AUTH_TOKEN_SUCCESS";
export const AUTH_TOKEN_FAILED = "AUTH_TOKEN_FAILED";
export const RESET_AUTH_TOKEN = "RESET_AUTH_TOKEN";
export const LOADING_AUTH_TOKEN = "LOADING_AUTH_TOKEN";
export const NETWORK_ERROR_AUTH_TOKEN = "NETWORK_ERROR_AUTH_TOKEN";

export const REGENERATE_TOKEN_SUCCESS = "REGENERATE_TOKEN_SUCCESS";
export const REGENERATE_TOKEN_FAILED = "REGENERATE_TOKEN_FAILED";
export const RESET_REGENERATE_TOKEN = "RESET_REGENERATE_TOKEN";
export const LOADING_REGENERATE_TOKEN = "LOADING_REGENERATE_TOKEN";
export const NETWORK_ERROR_REGENERATE_TOKEN = "NETWORK_ERROR_REGENERATE_TOKEN";

export const ADMIN_LOGOUT_SUCCESS = "ADMIN_LOGOUT_SUCCESS";
export const ADMIN_LOGOUT_FAILED = "ADMIN_LOGOUT_FAILED";
export const RESET_ADMIN_LOGOUT = "RESET_ADMIN_LOGOUT";
export const LOADING_ADMIN_LOGOUT = "LOADING_ADMIN_LOGOUT";
export const NETWORK_ERROR_ADMIN_LOGOUT = "NETWORK_ERROR_ADMIN_LOGOUT";

export const MODULES_FOR_PARTNER_SUCCESS = "MODULES_FOR_PARTNER_SUCCESS";
export const MODULES_FOR_PARTNER_FAILED = "MODULES_FOR_PARTNER_FAILED";
export const RESET_MODULES_FOR_PARTNER = "RESET_MODULES_FOR_PARTNER";
export const LOADING_MODULES_FOR_PARTNER = "LOADING_MODULES_FOR_PARTNER";
export const NETWORK_ERROR_MODULES_FOR_PARTNER =
  "NETWORK_ERROR_MODULES_FOR_PARTNER";

export const PARTNER_CHANGE_PASSWORD_SUCCESS =
  "PARTNER_CHANGE_PASSWORD_SUCCESS";
export const PARTNER_CHANGE_PASSWORD_FAILED = "PARTNER_CHANGE_PASSWORD_FAILED";
export const RESET_PARTNER_CHANGE_PASSWORD = "RESET_PARTNER_CHANGE_PASSWORD";
export const LOADING_PARTNER_CHANGE_PASSWORD =
  "LOADING_PARTNER_CHANGE_PASSWORD";
export const NETWORK_ERROR_PARTNER_CHANGE_PASSWORD =
  "NETWORK_ERROR_PARTNER_CHANGE_PASSWORD";

export const PARTNER_FORGOT_PASSWORD_SUCCESS =
  "PARTNER_FORGOT_PASSWORD_SUCCESS";
export const PARTNER_FORGOT_PASSWORD_FAILED = "PARTNER_FORGOT_PASSWORD_FAILED";
export const RESET_PARTNER_FORGOT_PASSWORD = "RESET_PARTNER_FORGOT_PASSWORD";
export const LOADING_PARTNER_FORGOT_PASSWORD =
  "LOADING_PARTNER_FORGOT_PASSWORD";
export const NETWORK_ERROR_PARTNER_FORGOT_PASSWORD =
  "NETWORK_ERROR_PARTNER_FORGOT_PASSWORD";

export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_FAILED = "CUSTOMER_LIST_FAILED";
export const RESET_CUSTOMER_LIST = "RESET_CUSTOMER_LIST";
export const LOADING_CUSTOMER_LIST = "LOADING_CUSTOMER_LIST";
export const NETWORK_ERROR_CUSTOMER_LIST = "NETWORK_ERROR_CUSTOMER_LIST";

export const GET_USERNAME_CONTACT_SUGGESTION_SUCCESS =
  "GET_USERNAME_CONTACT_SUGGESTION_SUCCESS";
export const GET_USERNAME_CONTACT_SUGGESTION_FAILED =
  "GET_USERNAME_CONTACT_SUGGESTION_FAILED";
export const RESET_GET_USERNAME_CONTACT_SUGGESTION =
  "RESET_GET_USERNAME_CONTACT_SUGGESTION";
export const LOADING_GET_USERNAME_CONTACT_SUGGESTION =
  "LOADING_GET_USERNAME_CONTACT_SUGGESTION";
export const NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION =
  "NETWORK_ERROR_GET_USERNAME_CONTACT_SUGGESTION";

export const DIVISION_LIST_PARTNER_SUCCESS = "DIVISION_LIST_PARTNER_SUCCESS";
export const DIVISION_LIST_PARTNER_FAILED = "DIVISION_LIST_PARTNER_FAILED";
export const RESET_DIVISION_LIST_PARTNER = "RESET_DIVISION_LIST_PARTNER";
export const LOADING_DIVISION_LIST_PARTNER = "LOADING_DIVISION_LIST_PARTNER";
export const NETWORK_ERROR_DIVISION_LIST_PARTNER =
  "NETWORK_ERROR_DIVISION_LIST_PARTNER";

export const DISTRCT_LIST_PARTNER_SUCCESS = "DISTRCT_LIST_PARTNER_SUCCESS";
export const DISTRCT_LIST_PARTNER_FAILED = "DISTRCT_LIST_PARTNER_FAILED";
export const RESET_DISTRCT_LIST_PARTNER = "RESET_DISTRCT_LIST_PARTNER";
export const LOADING_DISTRCT_LIST_PARTNER = "LOADING_DISTRCT_LIST_PARTNER";
export const NETWORK_ERROR_DISTRCT_LIST_PARTNER =
  "NETWORK_ERROR_DISTRCT_LIST_PARTNER";

export const THANA_LIST_PARTNER_SUCCESS = "THANA_LIST_PARTNER_SUCCESS";
export const THANA_LIST_PARTNER_FAILED = "THANA_LIST_PARTNER_FAILED";
export const RESET_THANA_LIST_PARTNER = "RESET_THANA_LIST_PARTNER";
export const LOADING_THANA_LIST_PARTNER = "LOADING_THANA_LIST_PARTNER";
export const NETWORK_ERROR_THANA_LIST_PARTNER =
  "NETWORK_ERROR_THANA_LIST_PARTNER";

export const UNION_LIST_PARTNER_SUCESS = "UNION_LIST_PARTNER_SUCESS";
export const UNION_LIST_PARTNER_FAILED = "UNION_LIST_PARTNER_FAILED";
export const RESET_UNION_LIST_PARTNER = "RESET_UNION_LIST_PARTNER";
export const LOADING_UNION_LIST_PARTNER = "LOADING_UNION_LIST_PARTNER";
export const NETWORK_ERROR_UNION_LIST_PARTNER =
  "NETWORK_ERROR_UNION_LIST_PARTNER";

export const PARTNER_WALLET_ROLES_SUCCESS = "PARTNER_WALLET_ROLES_SUCCESS";
export const PARTNER_WALLET_ROLES_FAILED = "PARTNER_WALLET_ROLES_FAILED";
export const RESET_PARTNER_WALLET_ROLES = "RESET_PARTNER_WALLET_ROLES";
export const LOADING_PARTNER_WALLET_ROLES = "LOADING_PARTNER_WALLET_ROLES";
export const NETWORK_ERROR_PARTNER_WALLET_ROLES =
  "NETWORK_ERROR_PARTNER_WALLET_ROLES";

export const GET_MODULE_MASTER_LIST_SUCCESS = "GET_MODULE_MASTER_LIST_SUCCESS";
export const GET_MODULE_MASTER_LIST_FAILED = "GET_MODULE_MASTER_LIST_FAILED";
export const RESET_MODULE_MASTER_LIST = "RESET_MODULE_MASTER_LIST";
export const LOADING_MODULE_MASTER_LIST = "LOADING_MODULE_MASTER_LIST";
export const NETWORK_ERROR_MODULE_MASTER_LIST =
  "NETWORK_ERROR_MODULE_MASTER_LIST";

export const EDIT_ADD_MODULE_MASTER_SUCCESS = "EDIT_ADD_MODULE_MASTER_SUCCESS";
export const EDIT_ADD_MODULE_MASTER_FAILED = "EDIT_ADD_MODULE_MASTER_FAILED";
export const RESET_EDIT_ADD_MODULE_MASTER = "RESET_EDIT_ADD_MODULE_MASTER";
export const LOADING_RESET_EDIT_ADD_MODULE_MASTER =
  "LOADING_RESET_EDIT_ADD_MODULE_MASTER";
export const NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER =
  "NETWORK_ERROR_RESET_EDIT_ADD_MODULE_MASTER";

export const TWO_FA_UPDATE_FLAGS_SUCCESS = "TWO_FA_UPDATE_FLAGS_SUCCESS";
export const TWO_FA_UPDATE_FLAGS_FAILED = "TWO_FA_UPDATE_FLAGS_FAILED";
export const LOADING_TWO_FA_UPDATE_FLAGS = "LOADING_TWO_FA_UPDATE_FLAGS";
export const RESET_TWO_FA_UPDATE_FLAGS = "RESET_TWO_FA_UPDATE_FLAGS";
export const NETWORK_ERROR_TWO_FA_UPDATE_FLAGS =
  "NETWORK_ERROR_TWO_FA_UPDATE_FLAGS";

export const GET_SUB_MODULE_MASTER_SUCCESS = "GET_SUB_MODULE_MASTER_SUCCESS";
export const GET_SUB_MODULE_MASTER_FAILED = "GET_SUB_MODULE_MASTER_FAILED";
export const RESET_GET_SUB_MODULE_MASTER = "RESET_GET_SUB_MODULE_MASTER";
export const LOADING_GET_SUB_MODULE_MASTER = "LOADING_GET_SUB_MODULE_MASTER";
export const NETWORK_ERROR_GET_SUB_MODULE_MASTER =
  "NETWORK_ERROR_GET_SUB_MODULE_MASTER";

export const ADD_UPDATE_SUB_MODULE_MASTER_SUCCESS =
  "ADD_UPDATE_SUB_MODULE_MASTER_SUCCESS";
export const ADD_UPDATE_SUB_MODULE_MASTER_FAILED =
  "ADD_UPDATE_SUB_MODULE_MASTER_FAILED";
export const RESET_ADD_UPDATE_SUB_MODULE_MASTER =
  "RESET_ADD_UPDATE_SUB_MODULE_MASTER";
export const LOADING_ADD_UPDATE_SUB_MODULE_MASTER =
  "LOADING_ADD_UPDATE_SUB_MODULE_MASTER";
export const NETWORK_ERROR_ADD_UPDATE_SUB_MODULE_MASTER =
  "NETWORK_ERROR_ADD_UPDATE_SUB_MODULE_MASTER";

export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS";
export const GET_COUNTRY_LIST_FAILED = "GET_COUNTRY_LIST_FAILED";
export const RESET_GET_COUNTRY_LIST = "RESET_GET_COUNTRY_LIST";
export const LOADING_GET_COUNTRY_LIST = "LOADING_GET_COUNTRY_LIST";
export const NETWORK_ERROR_GET_COUNTRY_LIST = "NETWORK_ERROR_GET_COUNTRY_LIST";

export const ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS =
  "ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS";
export const ADD_OR_UPDATE_NEW_COUNTRY_FAILED =
  "ADD_OR_UPDATE_NEW_COUNTRY_FAILED";
export const RESET_ADD_OR_UPDATE_NEW_COUNTRY =
  "RESET_ADD_OR_UPDATE_NEW_COUNTRY";
export const LOADING_ADD_OR_UPDATE_NEW_COUNTRY =
  "LOADING_ADD_OR_UPDATE_NEW_COUNTRY";
export const NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY =
  "NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY";

export const COUNTRY_MAPPING_LIST_SUCCESS = "COUNTRY_MAPPING_LIST_SUCCESS";
export const COUNTRY_MAPPING_LIST_FAILED = "COUNTRY_MAPPING_LIST_FAILED";
export const RESET_COUNTRY_MAPPING_LIST = "RESET_COUNTRY_MAPPING_LIST";
export const LOADING_COUNTRY_MAPPING_LIST = "LOADING_COUNTRY_MAPPING_LIST";
export const NETWORK_ERROR_COUNTRY_MAPPING_LIST =
  "NETWORK_ERROR_COUNTRY_MAPPING_LIST";

export const COUNTRY_MAPPING_SUCCESS = "COUNTRY_MAPPING_SUCCESS";
export const COUNTRY_MAPPING_FAILED = "COUNTRY_MAPPING_FAILED";
export const RESET_COUNTRY_MAPPING = "RESET_COUNTRY_MAPPING";
export const LOADING_COUNTRY_MAPPING = "LOADING_COUNTRY_MAPPING";
export const NETWORK_ERROR_COUNTRY_MAPPING = "NETWORK_ERROR_COUNTRY_MAPPING";

export const GET_TRANSFER_TYPE_LIST_SUCCESS = "GET_TRANSFER_TYPE_LIST_SUCCESS";
export const GET_TRANSFER_TYPE_LIST_FAILED = "GET_TRANSFER_TYPE_LIST_FAILED";
export const RESET_GET_TRANSFER_TYPE_LIST = "RESET_GET_TRANSFER_TYPE_LIST";
export const LOADING_GET_TRANSFER_TYPE_LIST = "LOADING_GET_TRANSFER_TYPE_LIST";
export const NETWORK_ERROR_GET_TRANSFER_TYPE_LIST =
  "NETWORK_ERROR_GET_TRANSFER_TYPE_LIST";

export const ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS =
  "ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS";
export const ADD_OR_UPDATE_TRANSFER_TYPE_FAILED =
  "ADD_OR_UPDATE_TRANSFER_TYPE_FAILED";
export const RESET_OR_UPDATE_TRANSFER_TYPE = "RESET_OR_UPDATE_TRANSFER_TYPE";
export const LOADING_OR_UPDATE_TRANSFER_TYPE =
  "LOADING_OR_UPDATE_TRANSFER_TYPE";
export const NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE =
  "NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE";

export const ADMIN_TRANSFER_TYPE_MAPPING_SUCCESS =
  "ADMIN_TRANSFER_TYPE_MAPPING_SUCCESS";
export const ADMIN_TRANSFER_TYPE_MAPPING_FAILED =
  "ADMIN_TRANSFER_TYPE_MAPPING_FAILED";
export const RESET_ADMIN_TRANSFER_TYPE_MAPPING =
  "RESET_ADMIN_TRANSFER_TYPE_MAPPING";
export const LOADING_ADMIN_TRANSFER_TYPE_MAPPING =
  "LOADING_ADMIN_TRANSFER_TYPE_MAPPING";
export const NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING =
  "NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING";

export const ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS =
  "ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_SUCCESS";
export const ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED =
  "ADMIN_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED";
export const LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED =
  "LOADING_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED";
export const RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED =
  "RESET_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED";
export const NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED =
  "NETWORK_ERROR_GET_TRANSFER_TYPE_MAPPING_LIST_FAILED";

export const ADMIN_ADD_UPDATE_ACCOUNT_TYPE_SUCCESS =
  "ADMIN_ADD_UPDATE_ACCOUNT_TYPE_SUCCESS";
export const ADMIN_ADD_UPDATE_ACCOUNT_TYPE_FAILED =
  "ADMIN_ADD_UPDATE_ACCOUNT_TYPE_FAILED";
export const LOADING_ADMIN_ADD_UPDATE_ACCOUNT_TYPE =
  "LOADING_ADMIN_ADD_UPDATE_ACCOUNT_TYPE";
export const RESET_ADMIN_ADD_UPDATE_ACCOUNT_TYPE =
  "RESET_ADMIN_ADD_UPDATE_ACCOUNT_TYPE";
export const NETWORK_ERROR_ADMIN_ADD_UPDATE_ACCOUNT_TYPE =
  "NETWORK_ERROR_ADMIN_ADD_UPDATE_ACCOUNT_TYPE";

export const ADMIN_GET_ACCOUNT_TYPE_SUCCESS = "ADMIN_GET_ACCOUNT_TYPE_SUCCESS";
export const ADMIN_GET_ACCOUNT_TYPE_FAILED = "ADMIN_GET_ACCOUNT_TYPE_FAILED";
export const LOADING_ADMIN_GET_ACCOUNT_TYPE = "LOADING_ADMIN_GET_ACCOUNT_TYPE";
export const RESET_ADMIN_GET_ACCOUNT_TYPE = "RESET_ADMIN_GET_ACCOUNT_TYPE";
export const NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE =
  "NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE";

export const ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_SUCCESS =
  "ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_SUCCESS";
export const ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_FAILED =
  "ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING_FAILED";
export const LOADING_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING =
  "LOADING_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING";
export const RESET_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING =
  "RESET_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING";
export const NETWORK_ERROR_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING =
  "NETWORK_ERROR_ADMIN_ACCOUNT_ACCOUNT_TYPE_MAPPING";

export const ADMIN_GET_ACCOUNT_TYPE_MAPPING_SUCCESS =
  "ADMIN_GET_ACCOUNT_TYPE_MAPPING_SUCCESS";
export const ADMIN_GET_ACCOUNT_TYPE_MAPPING_FAILED =
  "ADMIN_GET_ACCOUNT_TYPE_MAPPING_FAILED";
export const RESET_ADMIN_GET_ACCOUNT_TYPE_MAPPING =
  "RESET_ADMIN_GET_ACCOUNT_TYPE_MAPPING";
export const LOADING_ADMIN_GET_ACCOUNT_TYPE_MAPPING =
  "LOADING_ADMIN_GET_ACCOUNT_TYPE_MAPPING";
export const NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE_MAPPING =
  "NETWORK_ERROR_ADMIN_GET_ACCOUNT_TYPE_MAPPING";

export const ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS =
  "ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS";
export const ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED =
  "ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED";
export const LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE =
  "LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE";
export const RESET_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE =
  "RESET_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE";
export const NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE =
  "NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE";

export const ADMIN_DELETE_TRANSFER_TYPE_MAPPING_SUCCESS =
  "ADMIN_DELETE_TRANSFER_TYPE_MAPPING_SUCCESS";
export const ADMIN_DELETE_TRANSFER_TYPE_MAPPING_FAILED =
  "ADMIN_DELETE_TRANSFER_TYPE_MAPPING_FAILED";
export const LOADING_ADMIN_DELETE_TRANSFER_TYPE_MAPPING =
  "LOADING_ADMIN_DELETE_TRANSFER_TYPE_MAPPING";
export const NETWORK_ERROR_ADMIN_DELETE_TRANSFER_TYPE_MAPPING =
  "NETWORK_ERROR_ADMIN_DELETE_TRANSFER_TYPE_MAPPING";
export const RESET_ADMIN_DELETE_TRANSFER_TYPE_MAPPING =
  "RESET_ADMIN_DELETE_TRANSFER_TYPE_MAPPING";

export const ADD_UPDATE_ACCOUNT_TYPE_ADMIN_SUCCESS =
  "ADD_UPDATE_ACCOUNT_TYPE_ADMIN_SUCCESS";
export const ADD_UPDATE_ACCOUNT_TYPE_ADMIN_FAILED =
  "ADD_UPDATE_ACCOUNT_TYPE_ADMIN_FAILED";
export const LOADING_ADD_UPDATE_ACCOUNT_TYPE_ADMIN =
  "LOADING_ADD_UPDATE_ACCOUNT_TYPE_ADMIN";
export const NETWORK_ERROR_ADD_UPDATE_ACCOUNT_TYPE_ADMIN =
  "NETWORK_ERROR_ADD_UPDATE_ACCOUNT_TYPE_ADMIN";
export const RESET_ADD_UPDATE_ACCOUNT_TYPE_ADMIN =
  "RESET_ADD_UPDATE_ACCOUNT_TYPE_ADMIN";

export const GET_ACCOUNT_TYPE_ADMIN_SUCCESS = "GET_ACCOUNT_TYPE_ADMIN_SUCCESS";
export const GET_ACCOUNT_TYPE_ADMIN_FAILED = "GET_ACCOUNT_TYPE_ADMIN_FAILED";
export const LOADING_GET_ACCOUNT_TYPE_ADMIN = "LOADING_GET_ACCOUNT_TYPE_ADMIN";
export const RESET_GET_ACCOUNT_TYPE_ADMIN = "RESET_GET_ACCOUNT_TYPE_ADMIN";
export const NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN =
  "NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN";

export const ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS =
  "ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS";
export const ACCOUNT_TYPE_MAPPING_ADMIN_FAILED =
  "ACCOUNT_TYPE_MAPPING_ADMIN_FAILED";
export const LOADING_ACCOUNT_TYPE_MAPPING_ADMIN =
  "LOADING_ACCOUNT_TYPE_MAPPING_ADMIN";
export const NETWORK_ERROR_TYPE_MAPPING_ADMIN =
  "NETWORK_ERROR_TYPE_MAPPING_ADMIN";
export const RESET_TYPE_MAPPING_ADMIN = "RESET_TYPE_MAPPING_ADMIN";

export const LIST_ACCOUNT_TYPE_MAPPING_SUCCESS =
  "LIST_ACCOUNT_TYPE_MAPPING_SUCCESS";
export const LIST_ACCOUNT_TYPE_MAPPING_FAILED =
  "LIST_ACCOUNT_TYPE_MAPPING_FAILED";
export const LOADING_LIST_ACCOUNT_TYPE_MAPPING =
  "LOADING_LIST_ACCOUNT_TYPE_MAPPING";
export const RESET_LIST_ACCOUNT_TYPE_MAPPING =
  "RESET_LIST_ACCOUNT_TYPE_MAPPING";
export const NETWORK_ERROR_LIST_ACCOUNT_TYPE_MAPPING =
  "NETWORK_ERROR_LIST_ACCOUNT_TYPE_MAPPING";

export const DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS =
  "DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS";
export const DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED =
  "DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED";
export const LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN =
  "LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN";
export const RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN =
  "RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN";
export const NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN =
  "NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN";

export const DELETE_COUNTRY_MAPPING_SUCCESS = "DELETE_COUNTRY_MAPPING_SUCCESS";
export const DELETE_COUNTRY_MAPPING_FAILED = "DELETE_COUNTRY_MAPPING_FAILED";
export const LOADING_DELETE_COUNTRY_MAPPING = "LOADING_DELETE_COUNTRY_MAPPING";
export const RESET_DELETE_COUNTRY_MAPPING = "RESET_DELETE_COUNTRY_MAPPING";
export const NETWORK_ERROR_DELETE_COUNTRY_MAPPING =
  "NETWORK_ERROR_DELETE_COUNTRY_MAPPING";

export const ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS =
  "ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS";
export const ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED =
  "ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED";
export const LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE =
  "LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE";
export const RESET_ADMIN_GET_TRANSACTION_SUB_TYPE =
  "RESET_ADMIN_GET_TRANSACTION_SUB_TYPE";
export const NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE =
  "NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE";

// Wallet Admin

export const WALLET_AC_REQUIRED_SUCCESS = "WALLET_AC_REQUIRED_SUCCESS";
export const WALLET_AC_REQUIRED_FAILED = "WALLET_AC_REQUIRED_FAILED";
export const RESET_WALLET_AC_REQUIRED = "RESET_WALLET_AC_REQUIRED";
export const LOADING_WALLET_AC_REQUIRED = "LOADING_WALLET_AC_REQUIRED";
export const NETWORK_ERROR_WALLET_AC_REQUIRED =
  "NETWORK_ERROR_WALLET_AC_REQUIRED";

export const INDIVIDUAL_ENTITY_SUCCESS = "INDIVIDUAL_ENTITY_SUCCESS";
export const INDIVIDUAL_ENTITY_FAILED = "INDIVIDUAL_ENTITY_FAILED";
export const RESET_INDIVIDUAL_ENTITY = "RESET_INDIVIDUAL_ENTITY";
export const LOADING_INDIVIDUAL_ENTITY = "LOADING_INDIVIDUAL_ENTITY";
export const NETWORK_ERROR_INDIVIDUAL_ENTITY =
  "NETWORK_ERROR_INDIVIDUAL_ENTITY";

export const ORGANIZATION_TYPE_SUCCESS = "ORGANIZATION_TYPE_SUCCESS";
export const ORGANIZATION_TYPE_FAILED = "ORGANIZATION_TYPE_FAILED";
export const RESET_ORGANIZATION_TYPE = "RESET_ORGANIZATION_TYPE";
export const LOADING_ORGANIZATION_TYPE = "LOADING_ORGANIZATION_TYPE";
export const NETWORK_ERROR_ORGANIZATION_TYPE =
  "NETWORK_ERROR_ORGANIZATION_TYPE";

export const BUSINESS_TYPE_SUCCESS = "BUSINESS_TYPE_SUCCESS";
export const BUSINESS_TYPE_FAILED = "BUSINESS_TYPE_FAILED";
export const RESET_BUSINESS_TYPE = "RESET_BUSINESS_TYPE";
export const LOADING_BUSINESS_TYPE = "LOADING_BUSINESS_TYPE";
export const NETWORK_ERROR_BUSINESS_TYPE = "NETWORK_ERROR_ORGANIZATION_TYPE";

export const ADMIN_CURRENCY_LIST_SUCCESS = "ADMIN_CURRENCY_LIST_SUCCESS";
export const ADMIN_CURRENCY_LIST_FAILED = "ADMIN_CURRENCY_LIST_FAILED";
export const RESET_ADMIN_CURRENCY_LIST = "RESET_ADMIN_CURRENCY_LIST";
export const LOADING_ADMIN_CURRENCY_LIST = "LOADING_ADMIN_CURRENCY_LIST";
export const NETWORK_ERROR_ADMIN_CURRENCY_LIST =
  "NETWORK_ERROR_ADMIN_CURRENCY_LIST";

export const LEGAL_ENTITY_SUCCESS = "LEGAL_ENTITY_SUCCESS";
export const LEGAL_ENTITY_FAILED = "LEGAL_ENTITY_FAILED";
export const RESET_LEGAL_ENTITY = "RESET_LEGAL_ENTITY";
export const LOADING_LEGAL_ENTITY = "LOADING_LEGAL_ENTITY";
export const NETWORK_ERROR_LEGAL_ENTITY = "NETWORK_ERROR_LEGAL_ENTITY";

export const ADMIN_AUTH_TOKEN_SUCCESS = "ADMIN_AUTH_TOKEN_SUCCESS";
export const ADMIN_AUTH_TOKEN_FAILED = "ADMIN_AUTH_TOKEN_FAILED";
export const RESET_ADMIN_AUTH_TOKEN = "RESET_ADMIN_AUTH_TOKEN";
export const LOADING_ADMIN_AUTH_TOKEN = "LOADING_ADMIN_AUTH_TOKEN";
export const NETWORK_ERROR_ADMIN_AUTH_TOKEN = "NETWORK_ERROR_ADMIN_AUTH_TOKEN";
//GETMANUALDEPOSITLIST
export const GETMANUALDEPOSITLIST_SUCCESS = "GETMANUALDEPOSITLIST_SUCCESS";
export const GETMANUALDEPOSITLIST_FAILED = "GETMANUALDEPOSITLIST_FAILED";
export const RESET_GETMANUALDEPOSITLIST = "RESET_GETMANUALDEPOSITLIST";
export const LOADING_GETMANUALDEPOSITLIST = "LOADING_GETMANUALDEPOSITLIST";
export const NETWORK_ERROR_GETMANUALDEPOSITLIST =
  "NETWORK_ERROR_GETMANUALDEPOSITLIST";

//ADD_MANUAL_AMOUNT
export const ADD_MANUAL_AMOUNT_SUCCESS = "ADD_MANUAL_AMOUNT_SUCCESS";
export const ADD_MANUAL_AMOUNT_FAILED = "ADD_MANUAL_AMOUNT_FAILED";
export const RESET_ADD_MANUAL_AMOUNT = "RESET_ADD_MANUAL_AMOUNT";
export const LOADING_ADD_MANUAL_AMOUNT = "LOADING_ADD_MANUAL_AMOUNT";
export const NETWORK_ERROR_ADD_MANUAL_AMOUNT =
  "NETWORK_ERROR_ADD_MANUAL_AMOUNT";

//GETCUSTOMERWALLETCURRENCYLIST

export const GETCUSTOMERWALLETCURRENCYLIST_SUCCESS =
  "GETCUSTOMERWALLETCURRENCYLIST_SUCCESS";
export const GETCUSTOMERWALLETCURRENCYLIST_FAILED =
  "GETCUSTOMERWALLETCURRENCYLIST_FAILED";
export const RESET_GETCUSTOMERWALLETCURRENCYLIST =
  "RESET_GETCUSTOMERWALLETCURRENCYLIST";
export const LOADING_GETCUSTOMERWALLETCURRENCYLIST =
  "LOADING_GETCUSTOMERWALLETCURRENCYLIST";
export const NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST =
  "NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST";

//GETLOGINBLOCKLIST - UnLock Customer Account
export const GETLOGINBLOCKLIST_SUCCESS = "GETLOGINBLOCKLIST_SUCCESS";
export const GETLOGINBLOCKLIST_FAILED = "GETLOGINBLOCKLIST_FAILED";
export const RESET_GETLOGINBLOCKLIST = "RESET_GETLOGINBLOCKLIST";
export const LOADING_GETLOGINBLOCKLIST = "LOADING_GETLOGINBLOCKLIST";
export const NETWORK_ERROR_GETLOGINBLOCKLIST =
  "NETWORK_ERROR_GETLOGINBLOCKLIST";

//"UNLOCKACCOUNT"
export const UNLOCKACCOUNT_SUCCESS = "UNLOCKACCOUNT_SUCCESS";
export const UNLOCKACCOUNT_FAILED = "UNLOCKACCOUNT_FAILED";
export const RESET_UNLOCKACCOUNT = "RESET_UNLOCKACCOUNT";
export const LOADING_UNLOCKACCOUNT = "LOADING_UNLOCKACCOUNT";
export const NETWORK_ERROR_UNLOCKACCOUNT = "NETWORK_ERROR_UNLOCKACCOUNT";

//GETCUSTOMERLIST
export const GETCUSTOMERLIST_SUCCESS = "GETCUSTOMERLIST_SUCCESS";
export const GETCUSTOMERLIST_FAILED = "GETCUSTOMERLIST_FAILED";
export const RESET_GETCUSTOMERLIST = "RESET_GETCUSTOMERLIST";
export const LOADING_GETCUSTOMERLIST = "LOADING_GETCUSTOMERLIST";
export const NETWORK_ERROR_GETCUSTOMERLIST = "NETWORK_ERROR_GETCUSTOMERLIST";

//GETCUSTOMERDETAILS
export const GETCUSTOMERDETAILS_SUCCESS = "GETCUSTOMERDETAILS_SUCCESS";
export const GETCUSTOMERDETAILS_FAILED = "GETCUSTOMERDETAILS_FAILED";
export const RESET_GETCUSTOMERDETAILS = "RESET_GETCUSTOMERDETAILS";
export const LOADING_GETCUSTOMERDETAILS = "LOADING_GETCUSTOMERDETAILS";
export const NETWORK_ERROR_GETCUSTOMERDETAILS =
  "NETWORK_ERROR_GETCUSTOMERDETAILS";

//UPDATECUSTOMERDETAILS
export const UPDATECUSTOMERDETAILS_SUCCESS = "UPDATECUSTOMERDETAILS_SUCCESS";
export const UPDATECUSTOMERDETAILS_FAILED = "UPDATECUSTOMERDETAILS_FAILED";
export const RESET_UPDATECUSTOMERDETAILS = "RESET_UPDATECUSTOMERDETAILS";
export const LOADING_UPDATECUSTOMERDETAILS = "LOADING_UPDATECUSTOMERDETAILS";
export const NETWORK_ERROR_UPDATECUSTOMERDETAILS =
  "NETWORK_ERROR_UPDATECUSTOMERDETAILS";

//GETOPERATIONLIST
export const GETOPERATIONLIST_SUCCESS = "GETOPERATIONLIST_SUCCESS";
export const GETOPERATIONLIST_FAILED = "GETOPERATIONLIST_FAILED";
export const RESET_GETOPERATIONLIST = "RESET_GETOPERATIONLIST";
export const LOADING_GETOPERATIONLIST = "LOADING_GETOPERATIONLIST";
export const NETWORK_ERROR_UGETOPERATIONLIST = "NETWORK_ERROR_GETOPERATIONLIST";

//blockCustomerOperations Api
export const BLOCKCUSTOMEROPERATIONSLIST_SUCCESS =
  "BLOCKCUSTOMEROPERATIONSLIST_SUCCESS";
export const BLOCKCUSTOMEROPERATIONSLIST_FAILED =
  "BLOCKCUSTOMEROPERATIONSLIST_FAILED";
export const RESET_BLOCKCUSTOMEROPERATIONSLIST =
  "RESET_BLOCKCUSTOMEROPERATIONSLIST";
export const LOADING_BLOCKCUSTOMEROPERATIONSLIST =
  "LOADING_BLOCKCUSTOMEROPERATIONSLIST";
export const NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST =
  "NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST";

//GETBLOCKCUSTOMEROPERATIONSLIST
export const GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS =
  "GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS";
export const GETBLOCKCUSTOMEROPERATIONSLIST_FAILED =
  "GETBLOCKCUSTOMEROPERATIONSLIST_FAILED";
export const RESET_GETBLOCKCUSTOMEROPERATIONSLIST =
  "RESET_GETBLOCKCUSTOMEROPERATIONSLIST";
export const LOADING_GETBLOCKCUSTOMEROPERATIONSLIST =
  "LOADING_GETBLOCKCUSTOMEROPERATIONSLIST";
export const NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST =
  "NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST";

//UNBLOCKCUSTOMEROPERATION

export const UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS =
  "UNBLOCKCUSTOMEROPERATIONLIST_SUCCESS";
export const UNBLOCKCUSTOMEROPERATIONLIST_FAILED =
  "UNBLOCKCUSTOMEROPERATIONLIST_FAILED";
export const RESET_UNBLOCKCUSTOMEROPERATIONLIST =
  "RESET_UNBLOCKCUSTOMEROPERATIONLIST";
export const LOADING_UNBLOCKCUSTOMEROPERATIONLIST =
  "LOADING_UNBLOCKCUSTOMEROPERATIONLIST";
export const NETWORK_ERROR_UNBLOCKCUSTOMEROPERATIONLIST =
  "NETWORK_ERROR_UNBLOCKCUSTOMEROPERATIONLIST";

//GETMANUALOTPLIST

export const GETMANUALOTPLIST_SUCCESS = "GETMANUALOTPLIST_SUCCESS";
export const GETMANUALOTPLIST_FAILED = "GETMANUALOTPLIST_FAILED";
export const RESET_GETMANUALOTPLIST = "RESET_GETMANUALOTPLIST";
export const LOADING_GETMANUALOTPLIST = "LOADING_GETMANUALOTPLIST";
export const NETWORK_ERROR_GETMANUALOTPLIST = "NETWORK_ERROR_GETMANUALOTPLIST";

//CLOSEDMANUALOTPREQUEST

export const CLOSEDMANUALOTPREQUESTLIST_SUCCESS =
  "CLOSEDMANUALOTPREQUESTLIST_SUCCESS";
export const CLOSEDMANUALOTPREQUESTLIST_FAILED =
  "CLOSEDMANUALOTPREQUESTLIST_FAILED";
export const RESET_CLOSEDMANUALOTPREQUESTLIST =
  "RESET_CLOSEDMANUALOTPREQUESTLIST";
export const LOADING_CLOSEDMANUALOTPREQUESTLIST =
  "LOADING_CLOSEDMANUALOTPREQUESTLIST";
export const NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST =
  "NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST";

//GETKYCACCOUNTTYPELIST

export const GETKYCACCOUNTTYPELIST_SUCCESS = "GETKYCACCOUNTTYPELIST_SUCCESS";
export const GETKYCACCOUNTTYPELIST_FAILED = "GETKYCACCOUNTTYPELIST_FAILED";
export const RESET_GETKYCACCOUNTTYPELIST = "RESET_GETKYCACCOUNTTYPELIST";
export const LOADING_GETKYCACCOUNTTYPELIST = "LOADING_GETKYCACCOUNTTYPELIST";
export const NETWORK_ERROR_GETKYCACCOUNTTYPELIST =
  "NETWORK_ERROR_GETKYCACCOUNTTYPELIST";

//GETMANUALUPGRADEKYCLIST
export const GETMANUALUPGRADEKYCLIST_SUCCESS =
  "GETMANUALUPGRADEKYCLIST_SUCCESS";
export const GETMANUALUPGRADEKYCLIST_FAILED = "GETMANUALUPGRADEKYCLIST_FAILED";
export const RESET_GETMANUALUPGRADEKYCLIST = "RESET_GETMANUALUPGRADEKYCLIST";
export const LOADING_GETMANUALUPGRADEKYCLIST =
  "LOADING_GETMANUALUPGRADEKYCLIST";
export const NETWORK_ERROR_GETMANUALUPGRADEKYCLIST =
  "NETWORK_ERROR_GETMANUALUPGRADEKYCLIST";

//sidebar
export const SIDEBAR_SUCCESS = "SIDEBAR_SUCCESS";
export const RESET_SIDEBAR = "RESET_SIDEBAR";
//APPROVEORREJECTMANUALUPGRADEKYC

export const APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS =
  "APPROVEORREJECTMANUALUPGRADEKYC_SUCCESS";
export const APPROVEORREJECTMANUALUPGRADEKYC_FAILED =
  "APPROVEORREJECTMANUALUPGRADEKYC_FAILED";
export const RESET_APPROVEORREJECTMANUALUPGRADEKYC =
  "RESET_APPROVEORREJECTMANUALUPGRADEKYC";
export const LOADING_APPROVEORREJECTMANUALUPGRADEKYC =
  "LOADING_APPROVEORREJECTMANUALUPGRADEKYC";
export const NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC =
  "NETWORK_ERROR_APPROVEORREJECTMANUALUPGRADEKYC";

// ADDNEWWALLETFORCUSTOMER

export const ADDNEWWALLETFORCUSTOLIST_SUCCESS =
  "ADDNEWWALLETFORCUSTOLIST_SUCCESS";
export const ADDNEWWALLETFORCUSTOLIST_FAILED =
  "ADDNEWWALLETFORCUSTOLIST_FAILED";
export const RESET_ADDNEWWALLETFORCUSTOLIST = "RESET_ADDNEWWALLETFORCUSTOLIST";
export const LOADING_ADDNEWWALLETFORCUSTOLIST =
  "LOADING_ADDNEWWALLETFORCUSTOLIST";
export const NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST =
  "NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST";

export const GETALLWALLETSLIST_SUCCESS = "GETALLWALLETSLIST_SUCCESS";
export const GETALLWALLETSLIST_FAILED = "GETALLWALLETSLIST_FAILED";
export const RESET_GETALLWALLETSLIST = "RESET_GETALLWALLETSLIST";
export const LOADING_GETALLWALLETSLIST = "LOADING_GETALLWALLETSLIST";
export const NETWORK_ERROR_GETALLWALLETSLIST =
  "NETWORK_ERROR_GETALLWALLETSLIST";

export const GETCUSTOMERIDANDNAMELIST_SUCCESS =
  "GETCUSTOMERIDANDNAMELIST_SUCCESS";
export const GETCUSTOMERIDANDNAMELIST_FAILED =
  "GETCUSTOMERIDANDNAMELIST_FAILED";
export const RESET_GETCUSTOMERIDANDNAMELIST = "RESET_GETCUSTOMERIDANDNAMELIST";
export const LOADING_GETCUSTOMERIDANDNAMELIST =
  "LOADING_GETCUSTOMERIDANDNAMELIST";
export const NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST =
  "NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST";

//UPDATECUSTOMERWALLET

export const UPDATECUSTOMERWALLETLIST_SUCCESS =
  "UPDATECUSTOMERWALLETLIST_SUCCESS";
export const UPDATECUSTOMERWALLETLIST_FAILED =
  "UPDATECUSTOMERWALLETLIST_FAILED";
export const RESET_UPDATECUSTOMERWALLETLIST = "RESET_UPDATECUSTOMERWALLETLIST";
export const LOADING_UPDATECUSTOMERWALLETLIST =
  "LOADING_UPDATECUSTOMERWALLETLIST";
export const NETWORK_ERROR_UPDATECUSTOMERWALLETLIST =
  "NETWORK_ERROR_UPDATECUSTOMERWALLETLIST";

export const GETCUSTOMEROWNERDETAILS_SUCCESS =
  "GETCUSTOMEROWNERDETAILS_SUCCESS";
export const GETCUSTOMEROWNERDETAILS_FAILED = "GETCUSTOMEROWNERDETAILS_FAILED";
export const RESET_GETCUSTOMEROWNERDETAILS = "RESET_GETCUSTOMEROWNERDETAILS";
export const LOADING_GETCUSTOMEROWNERDETAILS =
  "LOADING_GETCUSTOMEROWNERDETAILS";
export const NETWORK_ERROR_GETCUSTOMEROWNERDETAILS =
  "NETWORK_ERROR_GETCUSTOMEROWNERDETAILS";

//CREATEFEEWALLET
export const CREATEFEEWALLET_SUCCESS = "CREATEFEEWALLET_SUCCESS";
export const CREATEFEEWALLET_FAILED = "CREATEFEEWALLET_FAILED";
export const RESET_CREATEFEEWALLET = "RESET_CREATEFEEWALLET";
export const LOADING_CREATEFEEWALLET = "LOADING_CREATEFEEWALLET";
export const NETWORK_ERROR_CREATEFEEWALLET = "NETWORK_ERROR_CREATEFEEWALLET";

//GETVOUCHERMAPPINGLIST

export const GETVOUCHERMAPPINGLIST_SUCCESS = "GETVOUCHERMAPPINGLIST_SUCCESS";
export const GETVOUCHERMAPPINGLIST_FAILED = "GETVOUCHERMAPPINGLIST_FAILED";
export const RESET_GETVOUCHERMAPPINGLIST = "RESET_GETVOUCHERMAPPINGLIST";
export const LOADING_GETVOUCHERMAPPINGLIST = "LOADING_GETVOUCHERMAPPINGLIST";
export const NETWORK_ERROR_GETVOUCHERMAPPINGLIST =
  "NETWORK_ERROR_GETVOUCHERMAPPINGLIST";

//DELETEVOUCHERMAPPING
export const DELETEVOUCHERMAPPING_SUCCESS = "DELETEVOUCHERMAPPING_SUCCESS";
export const DELETEVOUCHERMAPPING_FAILED = "DELETEVOUCHERMAPPING_FAILED";
export const RESET_DELETEVOUCHERMAPPING = "RESET_DELETEVOUCHERMAPPING";
export const LOADING_DELETEVOUCHERMAPPING = "LOADING_DELETEVOUCHERMAPPING";
export const NETWORK_ERROR_DELETEVOUCHERMAPPING =
  "NETWORK_ERROR_DELETEVOUCHERMAPPING";

//ADDNEWVOUCHERMAPPING

export const ADDNEWVOUCHERMAPPING_SUCCESS = "ADDNEWVOUCHERMAPPING_SUCCESS";
export const ADDNEWVOUCHERMAPPING_FAILED = "ADDNEWVOUCHERMAPPING_FAILED";
export const RESET_ADDNEWVOUCHERMAPPING = "RESET_ADDNEWVOUCHERMAPPING";
export const LOADING_ADDNEWVOUCHERMAPPING = "LOADING_ADDNEWVOUCHERMAPPING";
export const NETWORK_ERROR_ADDNEWVOUCHERMAPPING =
  "NETWORK_ERROR_ADDNEWVOUCHERMAPPING";

export const GETVOUCHERTRANSACTIONLIST_SUCCESS =
  "GETVOUCHERTRANSACTIONLIST_SUCCESS";
export const GETVOUCHERTRANSACTIONLIST_FAILED =
  "GETVOUCHERTRANSACTIONLIST_FAILED";
export const RESET_GETVOUCHERTRANSACTIONLIST =
  "RESET_GETVOUCHERTRANSACTIONLIST";
export const LOADING_GETVOUCHERTRANSACTIONLIST =
  "LOADING_GETVOUCHERTRANSACTIONLIST";
export const NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST =
  "NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST";

export const GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS =
  "GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS";
export const GETVOUCHERTRANSACTIONDETAILSLIST_FAILED =
  "GETVOUCHERTRANSACTIONDETAILSLIST_FAILED";
export const RESET_GETVOUCHERTRANSACTIONDETAILSLIST =
  "RESET_GETVOUCHERTRANSACTIONDETAILSLIST";
export const LOADING_GETVOUCHERTRANSACTIONDETAILSLIST =
  "LOADING_GETVOUCHERTRANSACTIONDETAILSLIST";
export const NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST =
  "NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST";

//GETVOUCHERLIST
export const GETVOUCHERLIST_SUCCESS = "GETVOUCHERLIST_SUCCESS";
export const GETVOUCHERLIST_FAILED = "GETVOUCHERLIST_FAILED";
export const RESET_GETVOUCHERLIST = "RESET_GETVOUCHERLIST";
export const LOADING_GETVOUCHERLIST = "LOADING_GETVOUCHERLIST";
export const NETWORK_ERROR_GETVOUCHERLIST = "NETWORK_ERROR_GETVOUCHERLIST";

export const GETVOUCHERDETAILS_SUCCESS = "GETVOUCHERDETAILS_SUCCESS";
export const GETVOUCHERDETAILS_FAILED = "GETVOUCHERDETAILS_FAILED";
export const RESET_GETVOUCHERDETAILS = "RESET_GETVOUCHERDETAILS";
export const LOADING_GETVOUCHERDETAILS = "LOADING_GETVOUCHERDETAILS";
export const NETWORK_ERROR_GETVOUCHERDETAILS =
  "NETWORK_ERROR_GETVOUCHERDETAILS";

//GETVOUCHERREDEEMLIST

export const GETVOUCHERREDEEMLIST_SUCCESS = "GETVOUCHERREDEEMLIST_SUCCESS";
export const GETVOUCHERREDEEMLIST_FAILED = "GETVOUCHERREDEEMLIST_FAILED";
export const RESET_GETVOUCHERREDEEMLIST = "RESET_GETVOUCHERREDEEMLIST";
export const LOADING_GETVOUCHERREDEEMLIST = "LOADING_GETVOUCHERREDEEMLIST";
export const NETWORK_ERROR_GETVOUCHERREDEEMLIST =
  "NETWORK_ERROR_GETVOUCHERREDEEMLIST";

export const GETVOUCHERREDEEMDETAILS_SUCCESS =
  "GETVOUCHERREDEEMDETAILS_SUCCESS";
export const GETVOUCHERREDEEMDETAILS_FAILED = "GETVOUCHERREDEEMDETAILS_FAILED";
export const RESET_GETVOUCHERREDEEMDETAILS = "RESET_GETVOUCHERREDEEMDETAILS";
export const LOADING_GETVOUCHERREDEEMDETAILS =
  "LOADING_GETVOUCHERREDEEMDETAILS";
export const NETWORK_ERROR_GETVOUCHERREDEEMDETAILS =
  "NETWORK_ERROR_GETVOUCHERREDEEMDETAILS";
// Fraud and Risk Managenent

export const RISK_RULES_LIST_SUCCESS = "RISK_RULES_LIST_SUCCESS";
export const RISK_RULES_LIST_FAILED = "RISK_RULES_LIST_FAILED";
export const RESET_RISK_RULES_LIST = "RESET_RISK_RULES_LIST";
export const LOADING_RISK_RULES_LIST = "LOADING_RISK_RULES_LIST";
export const NETWORK_ERROR_RISK_RULES_LIST = "NETWORK_ERROR_RISK_RULES_LIST";

export const UPDATE_RISK_LIST_SUCCESS = "UPDATE_RISK_LIST_SUCCESS";
export const UPDATE_RISK_LIST_FAILED = "UPDATE_RISK_LIST_FAILED";
export const RESET_UPDATE_RISK_LIST = "RESET_UPDATE_RISK_LIST";
export const LOADING_UPDATE_RISK_LIST = "LOADING_UPDATE_RISK_LIST";
export const NETWORK_ERROR_UPDATE_RISK_LIST = "NETWORK_ERROR_UPDATE_RISK_LIST";

export const RULES_MAPPING_SUCCESS = "RULES_MAPPING_SUCCESS";
export const RULES_MAPPING_FAILED = "RULES_MAPPING_FAILED";
export const RESET_RULES_MAPPING = "RESET_RULES_MAPPING";
export const LOADING_RULES_MAPPING = "LOADING_RULES_MAPPING";
export const NETWORK_ERROR_RULES_MAPPING = "NETWORK_ERROR_RULES_MAPPING";

export const ALLOW_DISALLOW_COUNTRY_SUCCESS = "ALLOW_DISALLOW_COUNTRY_SUCCESS";
export const ALLOW_DISALLOW_COUNTRY_FAILED = "ALLOW_DISALLOW_COUNTRY_FAILED";
export const RESET_ALLOW_DISALLOW_COUNTRY = "RESET_ALLOW_DISALLOW_COUNTRY";
export const LOADING_RALLOW_DISALLOW_COUNTRY = "LOADING_ALLOW_DISALLOW_COUNTRY";
export const NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY =
  "NETWORK_ERROR_ALLOW_DISALLOW_COUNTRY";

export const GETALLOWCOUNTRYLIST_SUCCESS = "GETALLOWCOUNTRYLIST_SUCCESS";
export const GETALLOWCOUNTRYLIST_FAILED = "GETALLOWCOUNTRYLIST_FAILED";
export const RESET_GETALLOWCOUNTRYLIST = "RESET_GETALLOWCOUNTRYLIST";
export const LOADING_GETALLOWCOUNTRYLIST = "LOADING_GETALLOWCOUNTRYLIST";
export const NETWORK_ERROR_GETALLOWCOUNTRYLIST =
  "NETWORK_ERROR_GETALLOWCOUNTRYLIST";

export const GETBLOCKCOUNTRYLIST_SUCCESS = "GETBLOCKCOUNTRYLIST_SUCCESS";
export const GETBLOCKCOUNTRYLIST_FAILED = "GETBLOCKCOUNTRYLIST_FAILED";
export const RESET_GETBLOCKCOUNTRYLIST = "RESET_GETBLOCKCOUNTRYLIST";
export const LOADING_GETBLOCKCOUNTRYLIST = "LOADING_GETBLOCKCOUNTRYLIST";
export const NETWORK_ERROR_GETBLOCKCOUNTRYLIST =
  "NETWORK_ERROR_GETBLOCKCOUNTRYLIST";

export const BLOCK_UNBLOCK_COUNTRY_SUCCESS = "BLOCK_UNBLOCK_COUNTRY_SUCCESS";
export const BLOCK_UNBLOCK_COUNTRY_FAILED = "BLOCK_UNBLOCK_COUNTRY_FAILED";
export const RESET_BLOCK_UNBLOCK_COUNTRY = "RESET_BLOCK_UNBLOCK_COUNTRY";
export const LOADING_BLOCK_UNBLOCK_COUNTRY = "LOADING_BLOCK_UNBLOCK_COUNTRY";
export const NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY =
  "NETWORK_ERROR_BLOCK_UNBLOCK_COUNTRY";

export const GETCURRENCYMASTERLIST_SUCCESS = "GETCURRENCYMASTERLIST_SUCCESS";
export const GETCURRENCYMASTERLIST_FAILED = "GETCURRENCYMASTERLIST_FAILED";
export const RESET_GETCURRENCYMASTERLIST = "RESET_GETCURRENCYMASTERLIST";
export const LOADING_GETCURRENCYMASTERLIST = "LOADING_GETCURRENCYMASTERLIST";
export const NETWORK_ERROR_GETCURRENCYMASTERLIST =
  "NETWORK_ERROR_GETCURRENCYMASTERLIST";

export const UPDATECURRENCYMASTERLIST_SUCCESS =
  "UPDATECURRENCYMASTERLIST_SUCCESS";
export const UPDATECURRENCYMASTERLIST_FAILED =
  "UPDATECURRENCYMASTERLIST_FAILED";
export const RESET_UPDATECURRENCYMASTERLIST = "RESET_UPDATECURRENCYMASTERLIST";
export const LOADING_UPDATECURRENCYMASTERLIST =
  "LOADING_UPDATECURRENCYMASTERLIST";
export const NETWORK_ERROR_UPDATECURRENCYMASTERLIST =
  "NETWORK_ERROR_UPDATECURRENCYMASTERLIST";

export const UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS =
  "UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS";
export const UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED =
  "UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED";
export const RESET_UPLOADSAMPLEFILEOFCURRENCYRATE =
  "RESET_UPLOADSAMPLEFILEOFCURRENCYRATE";
export const LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE =
  "LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE";
export const NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE =
  "NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE";

export const DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS =
  "DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS";
export const DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED =
  "DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED";
export const RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE =
  "RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE";
export const LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE =
  "LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE";
export const NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE =
  "NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE";

//GETWALLETTRANSACTIONLIST

export const GETWALLETTRANSACTIONLIST_SUCCESS =
  "GETWALLETTRANSACTIONLIST_SUCCESS";
export const GETWALLETTRANSACTIONLIST_FAILED =
  "GETWALLETTRANSACTIONLIST_FAILED";
export const RESET_GETWALLETTRANSACTIONLIST = "RESET_GETWALLETTRANSACTIONLIST";
export const LOADING_GETWALLETTRANSACTIONLIST =
  "LOADING_GETWALLETTRANSACTIONLIST";
export const NETWORK_ERROR_GETWALLETTRANSACTIONLIST =
  "NETWORK_ERROR_GETWALLETTRANSACTIONLIST";

//GETWALLETTRANSACTIONLISTONPARENT

export const GETWALLETTRANSACTIONLISTONPARENT_SUCCESS =
  "GETWALLETTRANSACTIONLISTONPARENT_SUCCESS";
export const GETWALLETTRANSACTIONLISTONPARENT_FAILED =
  "GETWALLETTRANSACTIONLISTONPARENT_FAILED";
export const RESET_GETWALLETTRANSACTIONLISTONPARENT =
  "RESET_GETWALLETTRANSACTIONLISTONPARENT";
export const LOADING_GETWALLETTRANSACTIONLISTONPARENT =
  "LOADING_GETWALLETTRANSACTIONLISTONPARENT";
export const NETWORK_ERROR_GETWALLETTRANSACTIONLISTONPARENT =
  "NETWORK_ERROR_GETWALLETTRANSACTIONLISTONPARENT";

//GETTRANSACTIONTYPELIST

export const GETTRANSACTIONTYPELIST_SUCCESS = "GETTRANSACTIONTYPELIST_SUCCESS";
export const GETTRANSACTIONTYPELIST_FAILED = "GETTRANSACTIONTYPELIST_FAILED";
export const RESET_GETTRANSACTIONTYPELIST = "RESET_GETTRANSACTIONTYPELIST";
export const LOADING_GETTRANSACTIONTYPELIST = "LOADING_GETTRANSACTIONTYPELIST";
export const NETWORK_ERROR_GETTRANSACTIONTYPELIST =
  "NETWORK_ERROR_GETTRANSACTIONTYPELIST";

//GETOPERATIONLOGSLIST

export const GETOPERATIONLOGSLIST_SUCCESS = "GETOPERATIONLOGSLIST_SUCCESS";
export const GETOPERATIONLOGSLIST_FAILED = "GETOPERATIONLOGSLIST_FAILED";
export const RESET_GETOPERATIONLOGSLIST = "RESET_GETOPERATIONLOGSLIST";
export const LOADING_GETOPERATIONLOGSLIST = "LOADING_GETOPERATIONLOGSLIST";
export const NETWORK_ERROR_GETOPERATIONLOGSLIST =
  "NETWORK_ERROR_GETOPERATIONLOGSLIST";

//GATELOYALTYPOINTOPERATIONSLIST

export const GATELOYALTYPOINTOPERATIONSLIST_SUCCESS =
  "GATELOYALTYPOINTOPERATIONSLIST_SUCCESS";
export const GATELOYALTYPOINTOPERATIONSLIST_FAILED =
  "GATELOYALTYPOINTOPERATIONSLIST_FAILED";
export const RESET_GATELOYALTYPOINTOPERATIONSLIST =
  "RESET_GATELOYALTYPOINTOPERATIONSLIST";
export const LOADING_GATELOYALTYPOINTOPERATIONSLIST =
  "LOADING_GATELOYALTYPOINTOPERATIONSLIST";
export const NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST =
  "NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST";

export const GETLOYALTYPOINTSLIST_SUCCESS = "GETLOYALTYPOINTSLIST_SUCCESS";
export const GETLOYALTYPOINTSLIST_FAILED = "GETLOYALTYPOINTSLIST_FAILED";
export const RESET_GETLOYALTYPOINTSLIST = "RESET_GETLOYALTYPOINTSLIST";
export const LOADING_GETLOYALTYPOINTSLIST = "LOADING_GETLOYALTYPOINTSLIST";
export const NETWORK_ERROR_GETLOYALTYPOINTSLIST =
  "NETWORK_ERROR_GETLOYALTYPOINTSLIST";

export const CREATEORUPDATELOYALTYPOINT_SUCCESS =
  "CREATEORUPDATELOYALTYPOINT_SUCCESS";
export const CREATEORUPDATELOYALTYPOINT_FAILED =
  "CREATEORUPDATELOYALTYPOINT_FAILED";
export const RESET_CREATEORUPDATELOYALTYPOINT =
  "RESET_CREATEORUPDATELOYALTYPOINT";
export const LOADING_CREATEORUPDATELOYALTYPOINT =
  "LOADING_CREATEORUPDATELOYALTYPOINT";
export const NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT =
  "NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT";

export const GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS =
  "GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS";
export const GENERATEWALLETTRANSACTIONREPORTFILE_FAILED =
  "GENERATEWALLETTRANSACTIONREPORTFILE_FAILED";
export const RESET_GENERATEWALLETTRANSACTIONREPORTFILE =
  "RESET_GENERATEWALLETTRANSACTIONREPORTFILE";
export const LOADING_GENERATEWALLETTRANSACTIONREPORTFILE =
  "LOADING_GENERATEWALLETTRANSACTIONREPORTFILE";
export const NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE =
  "NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE";

export const GETSUMMERYREPORTLIST_SUCCESS = "GETSUMMERYREPORTLIST_SUCCESS";
export const GETSUMMERYREPORTLIST_FAILED = "GETSUMMERYREPORTLIST_FAILED";
export const RESET_GETSUMMERYREPORTLIST = "RESET_GETSUMMERYREPORTLIST";
export const LOADING_GETSUMMERYREPORTLIST = "LOADING_GETSUMMERYREPORTLIST";
export const NETWORK_ERROR_GETSUMMERYREPORTLIST =
  "NETWORK_ERROR_GETSUMMERYREPORTLIST";

export const GETSUMMERYREPORTFILE_SUCCESS = "GETSUMMERYREPORTFILE_SUCCESS";
export const GETSUMMERYREPORTFILE_FAILED = "GETSUMMERYREPORTFILE_FAILED";
export const RESET_GETSUMMERYREPORTFILE = "RESET_GETSUMMERYREPORTFILE";
export const LOADING_GETSUMMERYREPORTFILE = "LOADING_GETSUMMERYREPORTFILE";
export const NETWORK_ERROR_GETSUMMERYREPORTFILE =
  "NETWORK_ERROR_GETSUMMERYREPORTFILE";

export const GETFEEREPORTLIST_SUCCESS = "GETFEEREPORTLIST_SUCCESS";
export const GETFEEREPORTLIST_FAILED = "GETFEEREPORTLIST_FAILED";
export const RESET_GETFEEREPORTLIST = "RESET_GETFEEREPORTLIST";
export const LOADING_GETFEEREPORTLIST = "LOADING_GETFEEREPORTLIST";
export const NETWORK_ERROR_GETFEEREPORTLIST = "NETWORK_ERROR_GETFEEREPORTLIST";

export const GETFEEREPORTFILE_SUCCESS = "GETFEEREPORTFILE_SUCCESS";
export const GETFEEREPORTFILE_FAILED = "GETFEEREPORTFILE_FAILED";
export const RESET_GETFEEREPORTFILE = "RESET_GETFEEREPORTFILE";
export const LOADING_GETFEEREPORTFILE = "LOADING_GETFEEREPORTFILE";
export const NETWORK_ERROR_GETFEEREPORTFILE = "NETWORK_ERROR_GETFEEREPORTFILE";

export const GETWITHDRAWLIMITLIST_SUCCESS = "GETWITHDRAWLIMITLIST_SUCCESS";
export const GETWITHDRAWLIMITLIST_FAILED = "GETWITHDRAWLIMITLIST_FAILED";
export const RESET_GETWITHDRAWLIMITLIST = "RESET_GETWITHDRAWLIMITLIST";
export const LOADING_GETWITHDRAWLIMITLIST = "LOADING_GETWITHDRAWLIMITLIST";
export const NETWORK_ERROR_GETWITHDRAWLIMITLIST =
  "NETWORK_ERROR_GETWITHDRAWLIMITLIST";

export const ADDNEWWITHDRAWLIMIT_SUCCESS = "ADDNEWWITHDRAWLIMIT_SUCCESS";
export const ADDNEWWITHDRAWLIMIT_FAILED = "ADDNEWWITHDRAWLIMIT_FAILED";
export const RESET_ADDNEWWITHDRAWLIMIT = "RESET_ADDNEWWITHDRAWLIMIT";
export const LOADING_ADDNEWWITHDRAWLIMIT = "LOADING_ADDNEWWITHDRAWLIMIT";
export const NETWORK_ERROR_ADDNEWWITHDRAWLIMIT =
  "NETWORK_ERROR_ADDNEWWITHDRAWLIMIT";

export const GETUSERWITHDRAWLIMITLIST_SUCCESS =
  "GETUSERWITHDRAWLIMITLIST_SUCCESS";
export const GETUSERWITHDRAWLIMITLIST_FAILED =
  "GETUSERWITHDRAWLIMITLIST_FAILED";
export const RESET_GETUSERWITHDRAWLIMITLIST = "RESET_GETUSERWITHDRAWLIMITLIST";
export const LOADING_GETUSERWITHDRAWLIMITLIST =
  "LOADING_GETUSERWITHDRAWLIMITLIST";
export const NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST =
  "NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST";

export const ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS =
  "ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS";
export const ADDORUPDATEUSERWITHDRAWLIMIT_FAILED =
  "ADDORUPDATEUSERWITHDRAWLIMIT_FAILED";
export const RESET_ADDORUPDATEUSERWITHDRAWLIMIT =
  "RESET_ADDORUPDATEUSERWITHDRAWLIMIT";
export const LOADING_ADDORUPDATEUSERWITHDRAWLIMIT =
  "LOADING_ADDORUPDATEUSERWITHDRAWLIMIT";
export const NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT =
  "NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT";

export const GETWITHDRWALCOUNT_SUCCESS = "GETWITHDRWALCOUNT_SUCCESS";
export const GETWITHDRWALCOUNT_FAILED = "GETWITHDRWALCOUNT_FAILED";
export const RESET_GETWITHDRWALCOUNT = "RESET_GETWITHDRWALCOUNT";
export const LOADING_GETWITHDRWALCOUNT = "LOADING_GETWITHDRWALCOUNT";
export const NETWORK_ERROR_GETWITHDRWALCOUNT =
  "NETWORK_ERROR_GETWITHDRWALCOUNT";

export const UPDATEWITHDRWALCOUNT_SUCCESS = "UPDATEWITHDRWALCOUNT_SUCCESS";
export const UPDATEWITHDRWALCOUNT_FAILED = "UPDATEWITHDRWALCOUNT_FAILED";
export const RESET_UPDATEWITHDRWALCOUNT = "RESET_UPDATEWITHDRWALCOUNT";
export const LOADING_UPDATEWITHDRWALCOUNT = "LOADING_UPDATEWITHDRWALCOUNT";
export const NETWORK_ERROR_UPDATEWITHDRWALCOUNT =
  "NETWORK_ERROR_UPDATEWITHDRWALCOUNT";

export const GETUSERWITHDRWALCOUNT_SUCCESS = "GETUSERWITHDRWALCOUNT_SUCCESS";
export const GETUSERWITHDRWALCOUNT_FAILED = "GETUSERWITHDRWALCOUNT_FAILED";
export const RESET_GETUSERWITHDRWALCOUNT = "RESET_GETUSERWITHDRWALCOUNT";
export const LOADING_GETUSERWITHDRWALCOUNT = "LOADING_GETUSERWITHDRWALCOUNT";
export const NETWORK_ERROR_GETUSERWITHDRWALCOUNT =
  "NETWORK_ERROR_GETUSERWITHDRWALCOUNT";

export const UPDATEUSERWITHDRWALCOUNT_SUCCESS =
  "UPDATEUSERWITHDRWALCOUNT_SUCCESS";
export const UPDATEUSERWITHDRWALCOUNT_FAILED =
  "UPDATEUSERWITHDRWALCOUNT_FAILED";
export const RESET_UPDATEUSERWITHDRWALCOUNT = "RESET_UPDATEUSERWITHDRWALCOUNT";
export const LOADING_UPDATEUSERWITHDRWALCOUNT =
  "LOADING_UPDATEUSERWITHDRWALCOUNT";
export const NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT =
  "NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT";

export const GETLOADLIMITLIST_SUCCESS = "GETLOADLIMITLIST_SUCCESS";
export const GETLOADLIMITLIST_FAILED = "GETLOADLIMITLIST_FAILED";
export const RESET_GETLOADLIMITLIST = "RESET_GETLOADLIMITLIST";
export const LOADING_GETLOADLIMITLIST = "LOADING_GETLOADLIMITLIST";
export const NETWORK_ERROR_GETLOADLIMITLIST = "NETWORK_ERROR_GETLOADLIMITLIST";

export const ADDORUPDATELOADLIMIT_SUCCESS = "ADDORUPDATELOADLIMIT_SUCCESS";
export const ADDORUPDATELOADLIMIT_FAILED = "ADDORUPDATELOADLIMIT_FAILED";
export const RESET_ADDORUPDATELOADLIMIT = "RESET_ADDORUPDATELOADLIMIT";
export const LOADING_ADDORUPDATELOADLIMIT = "LOADING_ADDORUPDATELOADLIMIT";
export const NETWORK_ERROR_ADDORUPDATELOADLIMIT =
  "NETWORK_ERROR_ADDORUPDATELOADLIMIT";

export const UPDATELOADCOUNT_SUCCESS = "UPDATELOADCOUNT_SUCCESS";
export const UPDATELOADCOUNT_FAILED = "UPDATELOADCOUNT_FAILED";
export const RESET_UPDATELOADCOUNT = "RESET_UPDATELOADCOUNT";
export const LOADING_UPDATELOADCOUNT = "LOADING_UPDATELOADCOUNT";
export const NETWORK_ERROR_UPDATELOADCOUNT = "NETWORK_ERROR_UPDATELOADCOUNT";

export const GETFEEMANAGEMENTLIST_SUCCESS = "GETFEEMANAGEMENTLIST_SUCCESS";
export const GETFEEMANAGEMENTLIST_FAILED = "GETFEEMANAGEMENTLIST_FAILED";
export const RESET_GETFEEMANAGEMENTLIST = "RESET_GETFEEMANAGEMENTLIST";
export const LOADING_GETFEEMANAGEMENTLIST = "LOADING_GETFEEMANAGEMENTLIST";
export const NETWORK_ERROR_GETFEEMANAGEMENTLIST =
  "NETWORK_ERROR_GETFEEMANAGEMENTLIST";

export const UPDATEFEEMANAGEMENTLIST_SUCCESS =
  "UPDATEFEEMANAGEMENTLIST_SUCCESS";
export const UPDATEFEEMANAGEMENTLIST_FAILED = "UPDATEFEEMANAGEMENTLIST_FAILED";
export const RESET_UPDATEFEEMANAGEMENTLIST = "RESET_UPDATEFEEMANAGEMENTLIST";
export const LOADING_UPDATEFEEMANAGEMENTLIST =
  "LOADING_UPDATEFEEMANAGEMENTLIST";
export const NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST =
  "NETWORK_ERROR_UPDATEFEEMANAGEMENTLIST";

export const GETWALLETDASHBOARD_SUCCESS = "GETWALLETDASHBOARD_SUCCESS";
export const GETWALLETDASHBOARD_FAILED = "GETWALLETDASHBOARD_FAILED";
export const RESET_GETWALLETDASHBOARD = "RESET_GETWALLETDASHBOARD";
export const LOADING_GETWALLETDASHBOARD = "LOADING_GETWALLETDASHBOARD";
export const NETWORK_ERROR_GETWALLETDASHBOARD =
  "NETWORK_ERROR_GETWALLETDASHBOARD";

export const GETWAYTRANSACTIONLIST_SUCCESS = "GETWAYTRANSACTIONLIST_SUCCESS";
export const GETWAYTRANSACTIONLIST_FAILED = "GETWAYTRANSACTIONLIST_FAILED";
export const RESET_GETWAYTRANSACTIONLIST = "RESET_GETWAYTRANSACTIONLIST";
export const LOADING_GETWAYTRANSACTIONLIST = "LOADING_GETWAYTRANSACTIONLIST";
export const NETWORK_ERROR_GETWAYTRANSACTIONLIST =
  "NETWORK_ERROR_GETWAYTRANSACTIONLIST";

export const VIEWTRANSACTIONDETAILS_SUCCESS = "VIEWTRANSACTIONDETAILS_SUCCESS";
export const VIEWTRANSACTIONDETAILS_FAILED = "VIEWTRANSACTIONDETAILS_FAILED";
export const RESET_VIEWTRANSACTIONDETAILS = "RESET_VIEWTRANSACTIONDETAILS";
export const LOADING_VIEWTRANSACTIONDETAILS = "LOADING_VIEWTRANSACTIONDETAILS";
export const NETWORK_ERROR_VIEWTRANSACTIONDETAILS =
  "NETWORK_ERROR_VIEWTRANSACTIONDETAILS";

//Partner Withdraw-E-Money
export const WITHDRAWREQLISTFORPARTNER_SUCCESS =
  "WITHDRAWREQLISTFORPARTNER_SUCCESS";
export const WITHDRAWREQLISTFORPARTNER_FAILED =
  "WITHDRAWREQLISTFORPARTNER_FAILED";
export const RESET_WITHDRAWREQLISTFORPARTNER =
  "RESET_WITHDRAWREQLISTFORPARTNER";
export const LOADING_WITHDRAWREQLISTFORPARTNER =
  "LOADING_WITHDRAWREQLISTFORPARTNER";
export const NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER =
  "NETWORK_ERROR_WITHDRAWREQLISTFORPARTNER";

export const WITHDRAWAPPROVEREJECT_SUCCESS = "WITHDRAWAPPROVEREJECT_SUCCESS";
export const WITHDRAWAPPROVEREJECT_FAILED = "WITHDRAWAPPROVEREJECT_FAILED";
export const RESET_WITHDRAWAPPROVEREJECT = "RESET_WITHDRAWAPPROVEREJECT";
export const LOADING_WITHDRAWAPPROVEREJECT = "LOADING_WITHDRAWAPPROVEREJECT";
export const NETWORK_ERROR_WITHDRAWAPPROVEREJECT =
  "NETWORK_ERROR_WITHDRAWAPPROVEREJECT";

export const CASHLIFTPARTNER_SUCCESS = "CASHLIFTPARTNER_SUCCESS";
export const CASHLIFTPARTNER_FAILED = "CASHLIFTPARTNER_FAILED";
export const RESET_CASHLIFTPARTNER = "RESET_CASHLIFTPARTNER";
export const LOADING_CASHLIFTPARTNER = "LOADING_CASHLIFTPARTNER";
export const NETWORK_ERROR_CASHLIFTPARTNER = "NETWORK_ERROR_CASHLIFTPARTNER";

export const CASHLIFTAPPROVEREJECTPARTNER_SUCCESS =
  "CASHLIFTAPPROVEREJECTPARTNER_SUCCESS";
export const CASHLIFTAPPROVEREJECTPARTNER_FAILED =
  "CASHLIFTAPPROVEREJECTPARTNER_FAILED";
export const RESET_CASHLIFTAPPROVEREJECTPARTNER =
  "RESET_CASHLIFTAPPROVEREJECTPARTNER";
export const LOADING_CASHLIFTAPPROVEREJECTPARTNER =
  "LOADING_CASHLIFTAPPROVEREJECTPARTNER";
export const NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER =
  "NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER";

//Agent Dealer Mapping (PARTNER)
export const GETMAPPINGDEALERLIST_SUCCESS = "GETMAPPINGDEALERLIST_SUCCESS";
export const GETMAPPINGDEALERLIST_FAILED = "GETMAPPINGDEALERLIST_FAILED";
export const RESET_GETMAPPINGDEALERLIST = "RESET_GETMAPPINGDEALERLIST";
export const LOADING_GETMAPPINGDEALERLIST = "LOADING_GETMAPPINGDEALERLIST";
export const NETWORK_ERROR_GETMAPPINGDEALERLIST =
  "NETWORK_ERROR_GETMAPPINGDEALERLIST";

export const DELETEDEALERAGENT_SUCCESS = "DELETEDEALERAGENT_SUCCESS";
export const DELETEDEALERAGENT_FAILED = "DELETEDEALERAGENT_FAILED";
export const RESET_DELETEDEALERAGENT = "RESET_DELETEDEALERAGENT";
export const LOADING_DELETEDEALERAGENT = "LOADING_DELETEDEALERAGENT";
export const NETWORK_ERROR_DELETEDEALERAGENT =
  "NETWORK_ERROR_DELETEDEALERAGENT";

export const DEALERLISTPARTNER_SUCCESS = "DEALERLISTPARTNER_SUCCESS";
export const DEALERLISTPARTNER_FAILED = "DEALERLISTPARTNER_FAILED";
export const RESET_DEALERLISTPARTNER = "RESET_DEALERLISTPARTNER";
export const LOADING_DEALERLISTPARTNER = "LOADING_DEALERLISTPARTNER";
export const NETWORK_ERROR_DEALERLISTPARTNER =
  "NETWORK_ERROR_DEALERLISTPARTNER";

export const EDITDEALERLIST_SUCCESS = "EDITDEALERLIST_SUCCESS";
export const EDITDEALERLIST_FAILED = "EDITDEALERLIST_FAILED";
export const RESET_EDITDEALERLIST = "RESET_EDITDEALERLIST";
export const LOADING_EDITDEALERLIST = "LOADING_EDITDEALERLIST";
export const NETWORK_ERROR_EDITDEALERLIST = "NETWORK_ERROR_EDITDEALERLIST";

export const DIVISIONLISTAGENTFORPARTNER_SUCCESS =
  "DIVISIONLISTAGENTFORPARTNER_SUCCESS";
export const DIVISIONLISTAGENTFORPARTNER_FAILED =
  "DIVISIONLISTAGENTFORPARTNER_FAILED";
export const RESET_DIVISIONLISTAGENTFORPARTNER =
  "RESET_DIVISIONLISTAGENTFORPARTNER";
export const LOADING_DIVISIONLISTAGENTFORPARTNER =
  "LOADING_DIVISIONLISTAGENTFORPARTNER";
export const NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER =
  "NETWORK_ERROR_DIVISIONLISTAGENTFORPARTNER";

export const DISTRICTLISTAGENTFORPARTNER_SUCCESS =
  "DISTRICTLISTAGENTFORPARTNER_SUCCESS";
export const DISTRICTLISTAGENTFORPARTNER_FAILED =
  "DISTRICTLISTAGENTFORPARTNER_FAILED";
export const RESET_DISTRICTLISTAGENTFORPARTNER =
  "RESET_DISTRICTLISTAGENTFORPARTNER";
export const LOADING_DISTRICTLISTAGENTFORPARTNER =
  "LOADING_DISTRICTLISTAGENTFORPARTNER";
export const NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER =
  "NETWORK_ERROR_DISTRICTLISTAGENTFORPARTNER";

export const THANALISTAGENTFORPARTNER_SUCCESS =
  "THANALISTAGENTFORPARTNER_SUCCESS";
export const THANALISTAGENTFORPARTNER_FAILED =
  "THANALISTAGENTFORPARTNER_FAILED";
export const RESET_THANALISTAGENTFORPARTNER = "RESET_THANALISTAGENTFORPARTNER";
export const LOADING_THANALISTAGENTFORPARTNER =
  "LOADING_THANALISTAGENTFORPARTNER";
export const NETWORK_ERROR_THANALISTAGENTFORPARTNER =
  "NETWORK_ERROR_THANALISTAGENTFORPARTNER";

export const UNIONLISTAGENTFORPARTNER_SUCCESS =
  "UNIONLISTAGENTFORPARTNER_SUCCESS";
export const UNIONLISTAGENTFORPARTNER_FAILED =
  "UNIONLISTAGENTFORPARTNER_FAILED";
export const RESET_UNIONLISTAGENTFORPARTNER = "RESET_UNIONLISTAGENTFORPARTNER";
export const LOADING_UNIONLISTAGENTFORPARTNER =
  "LOADING_UNIONLISTAGENTFORPARTNER";
export const NETWORK_ERROR_UNIONLISTAGENTFORPARTNER =
  "NETWORK_ERROR_UNIONLISTAGENTFORPARTNER";

export const GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS =
  "GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS";
export const GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED =
  "GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED";
export const RESET_GETMULTIPLEMAPPINGLISTFORPARTNER =
  "RESET_GETMULTIPLEMAPPINGLISTFORPARTNER";
export const LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER =
  "LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER";
export const NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER =
  "NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER";

export const GETMULTIPLESELECTFORPARTNER_SUCCESS =
  "GETMULTIPLESELECTFORPARTNER_SUCCESS";
export const GETMULTIPLESELECTFORPARTNER_FAILED =
  "GETMULTIPLESELECTFORPARTNER_FAILED";
export const RESET_GETMULTIPLESELECTFORPARTNER =
  "RESET_GETMULTIPLESELECTFORPARTNER";
export const LOADING_GETMULTIPLESELECTFORPARTNER =
  "LOADING_GETMULTIPLESELECTFORPARTNER";
export const NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER =
  "NETWORK_ERROR_GETMULTIPLESELECTFORPARTNER";

export const VIEWDEALERFORPARTNER_SUCCESS = "VIEWDEALERFORPARTNER_SUCCESS";
export const VIEWDEALERFORPARTNER_FAILED = "VIEWDEALERFORPARTNER_FAILED";
export const RESET_VIEWDEALERFORPARTNER = "RESET_VIEWDEALERFORPARTNER";
export const LOADING_VIEWDEALERFORPARTNER = "LOADING_VIEWDEALERFORPARTNER";
export const NETWORK_ERROR_VIEWDEALERFORPARTNER =
  "NETWORK_ERROR_VIEWDEALERFORPARTNER";

export const GETROLEDROPLIST_SUCCESS = "GETROLEDROPLIST_SUCCESS";
export const GETROLEDROPLIST_FAILED = "GETROLEDROPLIST_FAILED";
export const RESET_GETROLEDROPLIST = "RESET_GETROLEDROPLIST";
export const LOADING_GETROLEDROPLIST = "LOADING_GETROLEDROPLIST";
export const NETWORK_ERROR_GETROLEDROPLIST = "NETWORK_ERROR_GETROLEDROPLIST";

export const BANKNAMELISTPARTNER_SUCCESS = "BANKNAMELISTPARTNER_SUCCESS";
export const BANKNAMELISTPARTNER_FAILED = "BANKNAMELISTPARTNER_FAILED";
export const RESET_BANKNAMELISTPARTNER = "RESET_BANKNAMELISTPARTNER";
export const LOADING_BANKNAMELISTPARTNER = "LOADING_BANKNAMELISTPARTNER";
export const NETWORK_ERROR_BANKNAMELISTPARTNER =
  "NETWORK_ERROR_BANKNAMELISTPARTNER";

export const BRANCHNAMELISTPARTNER_SUCCESS = "BRANCHNAMELISTPARTNER_SUCCESS";
export const BRANCHNAMELISTPARTNER_FAILED = "BRANCHNAMELISTPARTNER_FAILED";
export const RESET_BRANCHNAMELISTPARTNER = "RESET_BRANCHNAMELISTPARTNER";
export const LOADING_BRANCHNAMELISTPARTNER = "LOADING_BRANCHNAMELISTPARTNER";
export const NETWORK_ERROR_BRANCHNAMELISTPARTNER =
  "NETWORK_ERROR_BRANCHNAMELISTPARTNER";

// SuperAdmin
export const GETWALLETOWNERLIST_SUCCESS = "GETWALLETOWNERLIST_SUCCESS";
export const GETWALLETOWNERLIST_FAILED = "GETWALLETOWNERLIST_FAILED";
export const RESET_GETWALLETOWNERLIST = "RESET_GETWALLETOWNERLIST";
export const LOADING_GETWALLETOWNERLIST = "LOADING_GETWALLETOWNERLIST";
export const NETWORK_ERROR_GETWALLETOWNERLIST =
  "NETWORK_ERROR_GETWALLETOWNERLIST";

export const DELETEWALLETOWNER_SUCCESS = "DELETEWALLETOWNER_SUCCESS";
export const DELETEWALLETOWNER_FAILED = "DELETEWALLETOWNER_FAILED";
export const RESET_DELETEWALLETOWNER = "RESET_DELETEWALLETOWNER";
export const LOADING_DELETEWALLETOWNER = "LOADING_DELETEWALLETOWNER";
export const NETWORK_ERROR_DELETEWALLETOWNER =
  "NETWORK_ERROR_DELETEWALLETOWNER";

export const CREATEORUPDATEWALLETOWNER_SUCCESS =
  "CREATEORUPDATEWALLETOWNER_SUCCESS";
export const CREATEORUPDATEWALLETOWNER_FAILED =
  "CREATEORUPDATEWALLETOWNER_FAILED";
export const RESET_CREATEORUPDATEWALLETOWNER =
  "RESET_CREATEORUPDATEWALLETOWNER";
export const LOADING_CREATEORUPDATEWALLETOWNER =
  "LOADING_CREATEORUPDATEWALLETOWNER";
export const NETWORK_ERROR_CREATEORUPDATEWALLETOWNER =
  "NETWORK_ERROR_CREATEORUPDATEWALLETOWNER";

export const GETTHEMELIST_SUCCESS = "GETTHEMELIST_SUCCESS";
export const GETTHEMELIST_FAILED = "GETTHEMELIST_FAILED";
export const RESET_GETTHEMELIST = "RESET_GETTHEMELIST";
export const LOADING_GETTHEMELIST = "LOADING_GETTHEMELIST";
export const NETWORK_ERROR_GETTHEMELIST = "NETWORK_ERROR_GETTHEMELIST";

export const GETBUSINESSNATURELIST_SUCCESS = "GETBUSINESSNATURELIST_SUCCESS";
export const GETBUSINESSNATURELIST_FAILED = "GETBUSINESSNATURELIST_FAILED";
export const RESET_GETBUSINESSNATURELIST = "RESET_GETBUSINESSNATURELIST";
export const LOADING_GETBUSINESSNATURELIST = "LOADING_GETBUSINESSNATURELIST";
export const NETWORK_ERROR_GETBUSINESSNATURELIST =
  "NETWORK_ERROR_GETBUSINESSNATURELIST";

export const GETBUSINESSNATUREMAPPINGLIST_SUCCESS =
  "GETBUSINESSNATUREMAPPINGLIST_SUCCESS";
export const GETBUSINESSNATUREMAPPINGLIST_FAILED =
  "GETBUSINESSNATUREMAPPINGLIST_FAILED";
export const RESET_GETBUSINESSNATUREMAPPINGLIST =
  "RESET_GETBUSINESSNATUREMAPPINGLIST";
export const LOADING_GETBUSINESSNATUREMAPPINGLIST =
  "LOADING_GETBUSINESSNATUREMAPPINGLIST";
export const NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST =
  "NETWORK_ERROR_GETBUSINESSNATUREMAPPINGLIST";

export const CREATEBUSINESSNATUREMAPPING_SUCCESS =
  "CREATEBUSINESSNATUREMAPPING_SUCCESS";
export const CREATEBUSINESSNATUREMAPPING_FAILED =
  "CREATEBUSINESSNATUREMAPPING_FAILED";
export const RESET_CREATEBUSINESSNATUREMAPPING =
  "RESET_CREATEBUSINESSNATUREMAPPING";
export const LOADING_CREATEBUSINESSNATUREMAPPING =
  "LOADING_CREATEBUSINESSNATUREMAPPING";
export const NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING =
  "NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING";

export const DELETEBUSINESSNATUREMAPPING_SUCCESS =
  "DELETEBUSINESSNATUREMAPPING_SUCCESS";
export const DELETEBUSINESSNATUREMAPPING_FAILED =
  "DELETEBUSINESSNATUREMAPPING_FAILED";
export const RESET_DELETEBUSINESSNATUREMAPPING =
  "RESET_DELETEBUSINESSNATUREMAPPING";
export const LOADING_DELETEBUSINESSNATUREMAPPING =
  "LOADING_DELETEBUSINESSNATUREMAPPING";
export const NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING =
  "NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING";

export const ADDORUPDATEBUSINESSNATURE_SUCCESS =
  "ADDORUPDATEBUSINESSNATURE_SUCCESS";
export const ADDORUPDATEBUSINESSNATURE_FAILED =
  "ADDORUPDATEBUSINESSNATURE_FAILED";
export const RESET_ADDORUPDATEBUSINESSNATURE =
  "RESET_ADDORUPDATEBUSINESSNATURE";
export const LOADING_ADDORUPDATEBUSINESSNATURE =
  "LOADING_ADDORUPDATEBUSINESSNATURE";
export const NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE =
  "NETWORK_ERROR_ADDORUPDATEBUSINESSNATURE";
export const GETENTITYTYPELIST_SUCCESS = "GETENTITYTYPELIST_SUCCESS";
export const GETENTITYTYPELIST_FAILED = "GETENTITYTYPELIST_FAILED";
export const RESET_GETENTITYTYPELIST = "RESET_GETENTITYTYPELIST";
export const LOADING_GETENTITYTYPELIST = "LOADING_GETENTITYTYPELIST";
export const NETWORK_ERROR_GETENTITYTYPELIST =
  "NETWORK_ERROR_GETENTITYTYPELIST";

export const GETENTITYTYPELISTABLE_SUCCESS = "GETENTITYTYPELISTABLE_SUCCESS";
export const GETENTITYTYPELISTABLE_FAILED = "GETENTITYTYPELISTABLE_FAILED";
export const RESET_GETENTITYTYPELISTABLE = "RESET_GETENTITYTYPELISTABLE";
export const LOADING_GETENTITYTYPELISTABLE = "LOADING_GETENTITYTYPELISTABLE";
export const NETWORK_ERROR_GETENTITYTYPELISTABLE =
  "NETWORK_ERROR_GETENTITYTYPELISTABLE";

export const ADDORUPDATEENTITYTYPELIST_SUCCESS =
  "ADDORUPDATEENTITYTYPELIST_SUCCESS";
export const ADDORUPDATEENTITYTYPELIST_FAILED =
  "ADDORUPDATEENTITYTYPELIST_FAILED";
export const RESET_ADDORUPDATEENTITYTYPELIST =
  "RESET_ADDORUPDATEENTITYTYPELIST";
export const LOADING_ADDORUPDATEENTITYTYPELIST =
  "LOADING_ADDORUPDATEENTITYTYPELIST";
export const NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST =
  "NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST";

export const GETWALLETOWNERIDNAMELIST_SUCCESS =
  "GETWALLETOWNERIDNAMELIST_SUCCESS";
export const GETWALLETOWNERIDNAMELIST_FAILED =
  "GETWALLETOWNERIDNAMELIST_FAILED";
export const RESET_GETWALLETOWNERIDNAMELIST = "RESET_GETWALLETOWNERIDNAMELIST";
export const LOADING_GETWALLETOWNERIDNAMELIST =
  "LOADING_GETWALLETOWNERIDNAMELIST";
export const NETWORK_ERROR_GETWALLETOWNERIDNAMELIST =
  "NETWORK_ERROR_GETWALLETOWNERIDNAMELIST";

export const UPDATEWALLETOWNERSETTING_SUCCESS =
  "UPDATEWALLETOWNERSETTING_SUCCESS";
export const UPDATEWALLETOWNERSETTING_FAILED =
  "UPDATEWALLETOWNERSETTING_FAILED";
export const RESET_UPDATEWALLETOWNERSETTING = "RESET_UPDATEWALLETOWNERSETTING";
export const LOADING_UPDATEWALLETOWNERSETTING =
  "LOADING_UPDATEWALLETOWNERSETTING";
export const NETWORK_ERROR_UPDATEWALLETOWNERSETTING =
  "NETWORK_ERROR_UPDATEWALLETOWNERSETTING";

export const GETWALLETOWNERSETTING_SUCCESS = "GETWALLETOWNERSETTING_SUCCESS";
export const GETWALLETOWNERSETTING_FAILED = "GETWALLETOWNERSETTING_FAILED";
export const RESET_GETALLWALLETOWNERSETTING = "RESET_GETALLWALLETOWNERSETTING";
export const LOADING_GETWALLETOWNERSETTING = "LOADING_GETWALLETOWNERSETTING";
export const NETWORK_ERROR_GETWALLETOWNERSETTING =
  "NETWORK_ERROR_GETWALLETOWNERSETTING";

export const GETENTITYMAPPINGLIST_SUCCESS = "GETENTITYMAPPINGLIST_SUCCESS";
export const GETENTITYMAPPINGLIST_FAILED = "GETENTITYMAPPINGLIST_FAILED";
export const RESET_GETENTITYMAPPINGLIST = "RESET_GETENTITYMAPPINGLIST";
export const LOADING_GETENTITYMAPPINGLIST = "LOADING_GETENTITYMAPPINGLIST";
export const NETWORK_ERROR_GETENTITYMAPPINGLIST =
  "NETWORK_ERROR_GETENTITYMAPPINGLIST";

export const CREATEENTITYMAPPING_SUCCESS = "CREATEENTITYMAPPING_SUCCESS";
export const CREATEENTITYMAPPING_FAILED = "CREATEENTITYMAPPING_FAILED";
export const RESET_CREATEENTITYMAPPING = "RESET_CREATEENTITYMAPPING";
export const LOADING_CREATEENTITYMAPPING = "LOADING_CREATEENTITYMAPPING";
export const NETWORK_ERROR_CREATEENTITYMAPPING =
  "NETWORK_ERROR_CREATEENTITYMAPPING";

export const DELETEENTITYMAPPING_SUCCESS = "DELETEENTITYMAPPING_SUCCESS";
export const DELETEENTITYMAPPING_FAILED = "DELETEENTITYMAPPING_FAILED";
export const RESET_DELETEENTITYMAPPING = "RESET_DELETEENTITYMAPPING";
export const LOADING_DELETEENTITYMAPPING = "LOADING_DELETEENTITYMAPPING";
export const NETWORK_ERROR_DELETEENTITYMAPPING =
  "NETWORK_ERROR_DELETEENTITYMAPPING";

export const GETROLELLIST_SUCCESS = "GETROLELLIST_SUCCESS";
export const GETROLELLIST_FAILED = "GETROLELLIST_FAILED";
export const RESET_GETROLELLIST = "RESET_GETROLELLIST";
export const LOADING_GETROLELLIST = "LOADING_GETROLELLIST";
export const NETWORK_ERROR_GETROLELLIST = "NETWORK_ERROR_GETROLELLIST";

export const GETMAPPINGROLELIST_SUCCESS = "GETMAPPINGROLELIST_SUCCESS";
export const GETMAPPINGROLELIST_FAILED = "GETMAPPINGROLELIST_FAILED";
export const RESET_GETMAPPINGROLELIST = "RESET_GETMAPPINGROLELIST";
export const LOADING_GETMAPPINGROLELIST = "LOADING_GETMAPPINGROLELIST";
export const NETWORK_ERROR_GETMAPPINGROLELIST =
  "NETWORK_ERROR_GETMAPPINGROLELIST";

export const ADDORUPDATEROLE_SUCCESS = "ADDORUPDATEROLE_SUCCESS";
export const ADDORUPDATEROLE_FAILED = "ADDORUPDATEROLE_FAILED";
export const RESET_ADDORUPDATEROLE = "RESET_ADDORUPDATEROLE";
export const LOADING_ADDORUPDATEROLE = " LOADING_ADDORUPDATEROLE";
export const NETWORK_ERROR_ADDORUPDATEROLE = "NETWORK_ERROR_ADDORUPDATEROLE";

export const CREATEROLEMAPPING_SUCCESS = "CREATEROLEMAPPING_SUCCESS";
export const CREATEROLEMAPPING_FAILED = "CREATEROLEMAPPING_FAILED";
export const RESET_CREATEROLEMAPPING = "RESET_CREATEROLEMAPPING";
export const LOADING_CREATEROLEMAPPING = " LOADING_CREATEROLEMAPPING";
export const NETWORK_ERROR_CREATEROLEMAPPING =
  "NETWORK_ERROR_CREATEROLEMAPPING";

export const DELETEROLEMAPPING_SUCCESS = "DELETEROLEMAPPING_SUCCESS";
export const DELETEROLEMAPPING_FAILED = "DELETEROLEMAPPING_FAILED";
export const RESET_DELETEROLEMAPPING = "RESET_DELETEROLEMAPPING";
export const LOADING_DELETEROLEMAPPING = " LOADING_DELETEROLEMAPPING";
export const NETWORK_ERROR_DELETEROLEMAPPING =
  "NETWORK_ERROR_DELETEROLEMAPPING";

export const GETROLELISTABLE_SUCCESS = "GETROLELISTABLE_SUCCESS";
export const GETROLELISTABLE_FAILED = "GETROLELISTABLE_FAILED";
export const RESET_GETROLELISTABLE = "RESET_GETROLELISTABLE";
export const LOADING_GETROLELISTABLE = "LOADING_GETROLELISTABLE";
export const NETWORK_ERROR_GETROLELISTABLE = "NETWORK_ERROR_GETROLELISTABLE";

export const GETPARENTROLELIST_SUCCESS = "GETPARENTROLELIST_SUCCESS";
export const GETPARENTROLELIST_FAILED = "GETPARENTROLELIST_FAILED";
export const RESET_GETPARENTROLELIST = "RESET_GETPARENTROLELIST";
export const LOADING_GETPARENTROLELIST = " LOADING_GETPARENTROLELIST";
export const NETWORK_ERROR_GETPARENTROLELIST =
  "NETWORK_ERROR_GETPARENTROLELIST";

export const GETROLELISTV1_SUCCESS = "GETROLELISTV1_SUCCESS";
export const GETROLELISTV1_FAILED = "GETROLELISTV1_FAILED";
export const RESET_GETROLELISTV1 = "RESET_GETROLELISTV1";
export const LOADING_GETROLELISTV1 = " LOADING_GETROLELISTV1";
export const NETWORK_ERROR_GETROLELISTV1 = "NETWORK_ERROR_GETROLELISTV1";

export const GETKYCREPORTLIST_SUCCESS = "GETKYCREPORTLIST_SUCCESS";
export const GETKYCREPORTLIST_FAILED = "GETKYCREPORTLIST_FAILED";
export const RESET_GETKYCREPORTLIST = "RESET_GETKYCREPORTLIST";
export const LOADING_GETKYCREPORTLIST = " LOADING_GETKYCREPORTLIST";
export const NETWORK_ERROR_GETKYCREPORTLIST = "NETWORK_ERROR_GETKYCREPORTLIST";

export const VIEWKYCDETAILS_SUCCESS = "VIEWKYCDETAILS_SUCCESS";
export const VIEWKYCDETAILS_FAILED = "VIEWKYCDETAILS_FAILED";
export const RESET_VIEWKYCDETAILS = "RESET_VIEWKYCDETAILS";
export const LOADING_VIEWKYCDETAILS = " LOADING_VIEWKYCDETAILS";
export const NETWORK_ERROR_VIEWKYCDETAILS = "NETWORK_ERROR_VIEWKYCDETAILS";

export const ADMINGETINTEGRATIONTYPELIST_SUCCESS =
  "ADMINGETINTEGRATIONTYPELIST_SUCCESS";
export const ADMINGETINTEGRATIONTYPELIST_FAILED =
  "ADMINGETINTEGRATIONTYPELIST_FAILED";
export const RESET_ADMINGETINTEGRATIONTYPELIST =
  "RESET_ADMINGETINTEGRATIONTYPELIST";
export const LOADING_ADMINGETINTEGRATIONTYPELIST =
  " LOADING_ADMINGETINTEGRATIONTYPELIST";
export const NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST =
  "NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST";

export const ADMINGETINTEGRATIONLIST_SUCCESS =
  "ADMINGETINTEGRATIONLIST_SUCCESS";
export const ADMINGETINTEGRATIONLIST_FAILED = "ADMINGETINTEGRATIONLIST_FAILED";
export const RESET_ADMINGETINTEGRATIONLIST = "RESET_ADMINGETINTEGRATIONLIST";
export const LOADING_ADMINGETINTEGRATIONLIST =
  " LOADING_ADMINGETINTEGRATIONLIST";
export const NETWORK_ERROR_ADMINGETINTEGRATIONLIST =
  "NETWORK_ERROR_ADMINGETINTEGRATIONLIST";

export const ADMINDELETEINTEGRATION_SUCCESS = "ADMINDELETEINTEGRATION_SUCCESS";
export const ADMINDELETEINTEGRATION_FAILED = "ADMINDELETEINTEGRATION_FAILED";
export const RESET_ADMINDELETEINTEGRATION = "RESET_ADMINDELETEINTEGRATION";
export const LOADING_ADMINDELETEINTEGRATION = " LOADING_ADMINDELETEINTEGRATION";
export const NETWORK_ERROR_ADMINDELETEINTEGRATION =
  "NETWORK_ERROR_ADMINDELETEINTEGRATION";

export const ADMINADDINTEGRATION_SUCCESS = "ADMINADDINTEGRATION_SUCCESS";
export const ADMINADDINTEGRATION_FAILED = "ADMINADDINTEGRATION_FAILED";
export const RESET_ADMINADDINTEGRATION = "RESET_ADMINADDINTEGRATION";
export const LOADING_ADMINADDINTEGRATION = " LOADING_ADMINADDINTEGRATION";
export const NETWORK_ERROR_ADMINADDINTEGRATION =
  "NETWORK_ERROR_ADMINADDINTEGRATION";

export const ADMINGETRISKRULELIST_SUCCESS = "ADMINGETRISKRULELIST_SUCCESS";
export const ADMINGETRISKRULELIST_FAILED = "ADMINGETRISKRULELIST_FAILED";
export const RESET_ADMINGETRISKRULELIST = "RESET_ADMINGETRISKRULELIST";
export const LOADING_ADMINGETRISKRULELIST = " LOADING_ADMINGETRISKRULELIST";
export const NETWORK_ERROR_ADMINGETRISKRULELIST =
  "NETWORK_ERROR_ADMINGETRISKRULELIST";

export const ADMINADDRISKRULELIST_SUCCESS = "ADMINADDRISKRULELIST_SUCCESS";
export const ADMINADDRISKRULELIST_FAILED = "ADMINADDRISKRULELIST_FAILED";
export const RESET_ADMINADDRISKRULELIST = "RESET_ADMINADDRISKRULELIST";
export const LOADING_ADMINADDRISKRULELIST = " LOADING_ADMINADDRISKRULELIST";
export const NETWORK_ERROR_ADMINADDRISKRULELIST =
  "NETWORK_ERROR_ADMINADDRISKRULELIST";

export const ADMINGETRISKRULEMAPPING_SUCCESS =
  "ADMINGETRISKRULEMAPPING_SUCCESS";
export const ADMINGETRISKRULEMAPPING_FAILED = "ADMINGETRISKRULEMAPPING_FAILED";
export const RESET_ADMINGETRISKRULEMAPPING = "RESET_ADMINGETRISKRULEMAPPING";
export const LOADING_ADMINGETRISKRULEMAPPING =
  " LOADING_ADMINGETRISKRULEMAPPING";
export const NETWORK_ERROR_ADMINGETRISKRULEMAPPING =
  "NETWORK_ERROR_ADMINGETRISKRULEMAPPING";

export const ADMINCREATERISKRULEMAPPING_SUCCESS =
  "ADMINCREATERISKRULEMAPPING_SUCCESS";
export const ADMINCREATERISKRULEMAPPING_FAILED =
  "ADMINCREATERISKRULEMAPPING_FAILED";
export const RESET_ADMINCREATERISKRULEMAPPING =
  "RESET_ADMINCREATERISKRULEMAPPING";
export const LOADING_ADMINCREATERISKRULEMAPPING =
  " LOADING_ADMINCREATERISKRULEMAPPING";
export const NETWORK_ERROR_ADMINCREATERISKRULEMAPPING =
  "NETWORK_ERROR_ADMINCREATERISKRULEMAPPING";

export const ADMINGETCURRENCYMASTER_SUCCESS = "ADMINGETCURRENCYMASTER_SUCCESS";
export const ADMINGETCURRENCYMASTER_FAILED = "ADMINGETCURRENCYMASTER_FAILED";
export const RESET_ADMINGETCURRENCYMASTER = "RESET_ADMINGETCURRENCYMASTER";
export const LOADING_ADMINGETCURRENCYMASTER = " LOADING_ADMINGETCURRENCYMASTER";
export const NETWORK_ERROR_ADMINGETCURRENCYMASTER =
  "NETWORK_ERROR_ADMINGETCURRENCYMASTER";

export const ADMINADDORUPDATECURRENCY_SUCCESS =
  "ADMINADDORUPDATECURRENCY_SUCCESS";
export const ADMINADDORUPDATECURRENCY_FAILED =
  "ADMINADDORUPDATECURRENCY_FAILED";
export const RESET_ADMINADDORUPDATECURRENCY = "RESET_ADMINADDORUPDATECURRENCY";
export const LOADING_ADMINADDORUPDATECURRENCY =
  " LOADING_ADMINADDORUPDATECURRENCY";
export const NETWORK_ERROR_ADMINADDORUPDATECURRENCY =
  "NETWORK_ERROR_ADMINADDORUPDATECURRENCY";

export const ADMINCREATECURRENCYMAPPING_SUCCESS =
  "ADMINCREATECURRENCYMAPPING_SUCCESS";
export const ADMINCREATECURRENCYMAPPING_FAILED =
  "ADMINCREATECURRENCYMAPPING_FAILED";
export const RESET_ADMINCREATECURRENCYMAPPING =
  "RESET_ADMINCREATECURRENCYMAPPING";
export const LOADING_ADMINCREATECURRENCYMAPPING =
  " LOADING_ADMINCREATECURRENCYMAPPING";
export const NETWORK_ERROR_ADMINCREATECURRENCYMAPPING =
  "NETWORK_ERROR_ADMINCREATECURRENCYMAPPING";

export const ADMINGETCURRENCYMAPPING_SUCCESS =
  "ADMINGETCURRENCYMAPPING_SUCCESS";
export const ADMINGETCURRENCYMAPPING_FAILED = "ADMINGETCURRENCYMAPPING_FAILED";
export const RESET_ADMINGETCURRENCYMAPPING = "RESET_ADMINGETCURRENCYMAPPING";
export const LOADING_ADMINGETCURRENCYMAPPING =
  " LOADING_ADMINGETCURRENCYMAPPING";
export const NETWORK_ERROR_ADMINGETCURRENCYMAPPING =
  "NETWORK_ERROR_ADMINGETCURRENCYMAPPING";

export const ADMINDELETECURRENCYMAPPING_SUCCESS =
  "ADMINDELETECURRENCYMAPPING_SUCCESS";
export const ADMINDELETECURRENCYMAPPING_FAILED =
  "ADMINDELETECURRENCYMAPPING_FAILED";
export const RESET_ADMINDELETECURRENCYMAPPING =
  "RESET_ADMINDELETECURRENCYMAPPING";
export const LOADING_ADMINDELETECURRENCYMAPPING =
  " LOADING_ADMINDELETECURRENCYMAPPING";
export const NETWORK_ERROR_ADMINDELETECURRENCYMAPPING =
  "NETWORK_ERROR_ADMINDELETECURRENCYMAPPING";

export const ADMINGETKYCACTIONTYPE_SUCCESS = "ADMINGETKYCACTIONTYPE_SUCCESS";
export const ADMINGETKYCACTIONTYPE_FAILED = "ADMINGETKYCACTIONTYPE_FAILED";
export const RESET_ADMINGETKYCACTIONTYPE = "RESET_ADMINGETKYCACTIONTYPE";
export const LOADING_ADMINGETKYCACTIONTYPE = " LOADING_ADMINGETKYCACTIONTYPE";
export const NETWORK_ERROR_ADMINGETKYCACTIONTYPE =
  "NETWORK_ERROR_ADMINGETKYCACTIONTYPE";

export const ADMINGETKYCPROOFLIST_SUCCESS = "ADMINGETKYCPROOFLIST_SUCCESS";
export const ADMINGETKYCPROOFLIST_FAILED = "ADMINGETKYCPROOFLIST_FAILED";
export const RESET_ADMINGETKYCPROOFLIST = "RESET_ADMINGETKYCPROOFLIST";
export const LOADING_ADMINGETKYCPROOFLIST = " LOADING_ADMINGETKYCPROOFLIST";
export const NETWORK_ERROR_ADMINGETKYCPROOFLIST =
  "NETWORK_ERROR_ADMINGETKYCPROOFLIST";

export const ADMINADDORUPDATEKYCPROOF_SUCCESS =
  "ADMINADDORUPDATEKYCPROOF_SUCCESS";
export const ADMINADDORUPDATEKYCPROOF_FAILED =
  "ADMINADDORUPDATEKYCPROOF_FAILED";
export const RESET_ADMINADDORUPDATEKYCPROOF = "RESET_ADMINADDORUPDATEKYCPROOF";
export const LOADING_ADMINADDORUPDATEKYCPROOF =
  " LOADING_ADMINADDORUPDATEKYCPROOF";
export const NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF =
  "NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF";

export const ADMINGETKYCDOCUMENTLIST_SUCCESS =
  "ADMINGETKYCDOCUMENTLIST_SUCCESS";
export const ADMINGETKYCDOCUMENTLIST_FAILED = "ADMINGETKYCDOCUMENTLIST_FAILED";
export const RESET_ADMINGETKYCDOCUMENTLIST = "RESET_ADMINGETKYCDOCUMENTLIST";
export const LOADING_ADMINGETKYCDOCUMENTLIST =
  " LOADING_ADMINGETKYCDOCUMENTLIST";
export const NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST =
  "NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST";

export const ADMINADDORUPDATEKYCDOCUMENT_SUCCESS =
  "ADMINADDORUPDATEKYCDOCUMENT_SUCCESS";
export const ADMINADDORUPDATEKYCDOCUMENT_FAILED =
  "ADMINADDORUPDATEKYCDOCUMENT_FAILED";
export const RESET_ADMINADDORUPDATEKYCDOCUMENT =
  "RESET_ADMINADDORUPDATEKYCDOCUMENT";
export const LOADING_ADMINADDORUPDATEKYCDOCUMENT =
  " LOADING_ADMINADDORUPDATEKYCDOCUMENT";
export const NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT =
  "NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT";

export const ADMINGETFEEMASTERLIST_SUCCESS = "ADMINGETFEEMASTERLIST_SUCCESS";
export const ADMINGETFEEMASTERLIST_FAILED = "ADMINGETFEEMASTERLIST_FAILED";
export const RESET_ADMINGETFEEMASTERLIST = "RESET_ADMINGETFEEMASTERLIST";
export const LOADING_ADMINGETFEEMASTERLIST = " LOADING_ADMINGETFEEMASTERLIST";
export const NETWORK_ERROR_ADMINGETFEEMASTERLIST =
  "NETWORK_ERROR_ADMINGETFEEMASTERLIST";

export const ADMINGETFEEDEFAULTVALUES_SUCCESS =
  "ADMINGETFEEDEFAULTVALUES_SUCCESS";
export const ADMINGETFEEDEFAULTVALUES_FAILED =
  "ADMINGETFEEDEFAULTVALUES_FAILED";
export const RESET_ADMINGETFEEDEFAULTVALUES = "RESET_ADMINGETFEEDEFAULTVALUES";
export const LOADING_ADMINGETFEEDEFAULTVALUES =
  " LOADING_ADMINGETFEEDEFAULTVALUES";
export const NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES =
  "NETWORK_ERROR_ADMINGETFEEDEFAULTVALUES";

export const ADMINGETFEEOPERATIONTYPE_SUCCESS =
  "ADMINGETFEEOPERATIONTYPE_SUCCESS";
export const ADMINGETFEEOPERATIONTYPE_FAILED =
  "ADMINGETFEEOPERATIONTYPE_FAILED";
export const RESET_ADMINGETFEEOPERATIONTYPE = "RESET_ADMINGETFEEOPERATIONTYPE";
export const LOADING_ADMINGETFEEOPERATIONTYPE =
  " LOADING_ADMINGETFEEOPERATIONTYPE";
export const NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE =
  "NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE";

export const ADMINADDORUPDATEFEE_SUCCESS = "ADMINADDORUPDATEFEE_SUCCESS";
export const ADMINADDORUPDATEFEE_FAILED = "ADMINADDORUPDATEFEE_FAILED";
export const RESET_ADMINADDORUPDATEFEE = "RESET_ADMINADDORUPDATEFEE";
export const LOADING_ADMINADDORUPDATEFEE = " LOADING_ADMINADDORUPDATEFEE";
export const NETWORK_ERROR_ADMINADDORUPDATEFEE =
  "NETWORK_ERROR_ADMINADDORUPDATEFEE";

export const ADMINCREATEFEEMAPPING_SUCCESS = "ADMINCREATEFEEMAPPING_SUCCESS";
export const ADMINCREATEFEEMAPPING_FAILED = "ADMINCREATEFEEMAPPING_FAILED";
export const RESET_ADMINCREATEFEEMAPPING = "RESET_ADMINCREATEFEEMAPPING";
export const LOADING_ADMINCREATEFEEMAPPING = " LOADING_ADMINCREATEFEEMAPPING";
export const NETWORK_ERROR_ADMINCREATEFEEMAPPING =
  "NETWORK_ERROR_ADMINCREATEFEEMAPPING";

export const ADMINGETFEEMAPPING_SUCCESS = "ADMINGETFEEMAPPING_SUCCESS";
export const ADMINGETFEEMAPPING_FAILED = "ADMINGETFEEMAPPING_FAILED";
export const RESET_ADMINGETFEEMAPPING = "RESET_ADMINGETFEEMAPPING";
export const LOADING_ADMINGETFEEMAPPING = " LOADING_ADMINGETFEEMAPPING";
export const NETWORK_ERROR_ADMINGETFEEMAPPING =
  "NETWORK_ERROR_ADMINGETFEEMAPPING";

export const ADMINADDORUPDATEKYCMAPPING_SUCCESS =
  "ADMINADDORUPDATEKYCMAPPING_SUCCESS";
export const ADMINADDORUPDATEKYCMAPPING_FAILED =
  "ADMINADDORUPDATEKYCMAPPING_FAILED";
export const RESET_ADMINADDORUPDATEKYCMAPPING =
  "RESET_ADMINADDORUPDATEKYCMAPPING";
export const LOADING_ADMINADDORUPDATEKYCMAPPING =
  " LOADING_ADMINADDORUPDATEKYCMAPPING";
export const NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING =
  "NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING";

export const ADMINGENERATEKEY_SUCCESS = "ADMINGENERATEKEY_SUCCESS";
export const ADMINGENERATEKEY_FAILED = "ADMINGENERATEKEY_FAILED";
export const RESET_ADMINGENERATEKEY = "RESET_ADMINGENERATEKEY";
export const LOADING_ADMINGENERATEKEY = " LOADING_ADMINGENERATEKEY";
export const NETWORK_ERROR_ADMINGENERATEKEY = "NETWORK_ERROR_ADMINGENERATEKEY";

//getKybReportList
export const GETKYBREPORTLIST_SUCCESS = "GETKYBREPORTLIST_SUCCESS";
export const GETKYBREPORTLIST_FAILED = "GETKYBREPORTLIST_FAILED";
export const RESET_GETKYBREPORTLIST = "RESET_GETKYBREPORTLIST";
export const LOADING_GETKYBREPORTLIST = " LOADING_GETKYBREPORTLIST";
export const NETWORK_ERROR_GETKYBREPORTLIST = "NETWORK_ERROR_GETKYBREPORTLIST";

export const GETKYBDETAILSLIST_SUCCESS = "GETKYBDETAILSLIST_SUCCESS";
export const GETKYBDETAILSLIST_FAILED = "GETKYBDETAILSLIST_FAILED";
export const RESET_GETKYBDETAILSLIST = "RESET_GETKYBDETAILSLIST";
export const LOADING_GETKYBDETAILSLIST = " LOADING_GETKYBDETAILSLIST";
export const NETWORK_ERROR_GETKYBDETAILSLIST =
  "NETWORK_ERROR_GETKYBDETAILSLIST";

export const GETKYBAPPROVEREJECT_SUCCESS = "GETKYBAPPROVEREJECT_SUCCESS";
export const GETKYBAPPROVEREJECT_FAILED = "GETKYBAPPROVEREJECT_FAILED";
export const RESET_GETKYBAPPROVEREJECT = "RESET_GETKYBAPPROVEREJECT";
export const LOADING_GETKYBAPPROVEREJECT = " LOADING_GETKYBAPPROVEREJECT";
export const NETWORK_ERROR_GETKYBAPPROVEREJECT =
  "NETWORK_ERROR_GETKYBAPPROVEREJECT";

export const ADMINKYCMAPPINGLIST_SUCCESS = "ADMINKYCMAPPINGLIST_SUCCESS";
export const ADMINKYCMAPPINGLIST_FAILED = "ADMINKYCMAPPINGLIST_FAILED";
export const RESET_ADMINKYCMAPPINGLIST = "RESET_ADMINKYCMAPPINGLIST";
export const LOADING_ADMINKYCMAPPINGLIST = " LOADING_ADMINKYCMAPPINGLIST";
export const NETWORK_ERROR_ADMINKYCMAPPINGLIST =
  "NETWORK_ERROR_ADMINKYCMAPPINGLIST";

export const ADMINLOYALTYPOINTOPERATION_SUCCESS =
  "ADMINLOYALTYPOINTOPERATION_SUCCESS";
export const ADMINLOYALTYPOINTOPERATION_FAILED =
  "ADMINLOYALTYPOINTOPERATION_FAILED";
export const RESET_ADMINLOYALTYPOINTOPERATION =
  "RESET_ADMINLOYALTYPOINTOPERATION";
export const LOADING_ADMINLOYALTYPOINTOPERATION =
  " LOADING_ADMINLOYALTYPOINTOPERATION";
export const NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION =
  "NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION";

export const ADMINGETLOYALTYPOINT_SUCCESS = "ADMINGETLOYALTYPOINT_SUCCESS";
export const ADMINGETLOYALTYPOINT_FAILED = "ADMINGETLOYALTYPOINT_FAILED";
export const RESET_ADMINGETLOYALTYPOINT = "RESET_ADMINGETLOYALTYPOINT";
export const LOADING_ADMINGETLOYALTYPOINT = " LOADING_ADMINGETLOYALTYPOINT";
export const NETWORK_ERROR_ADMINGETLOYALTYPOINT =
  "NETWORK_ERROR_ADMINGETLOYALTYPOINT";

export const ADMINADDORUPDATELOYALTYPOINT_SUCCESS =
  "ADMINADDORUPDATELOYALTYPOINT_SUCCESS";
export const ADMINADDORUPDATELOYALTYPOINT_FAILED =
  "ADMINADDORUPDATELOYALTYPOINT_FAILED";
export const RESET_ADMINADDORUPDATELOYALTYPOINT =
  "RESET_ADMINADDORUPDATELOYALTYPOINT";
export const LOADING_ADMINADDORUPDATELOYALTYPOINT =
  " LOADING_ADMINADDORUPDATELOYALTYPOINT";
export const NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT =
  "NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT";

export const GET_STORE_LIST_SUCCESS = "GET_STORE_LIST_SUCCESS";
export const GET_STORE_LIST_FAILED = "GET_STORE_LIST_FAILED";
export const RESET_GET_STORE_LIST = "RESET_GET_STORE_LIST";
export const LOADING_GET_STORE_LIST = " LOADING_GET_STORE_LIST";
export const NETWORK_ERROR_GET_STORE_LIST = "NETWORK_ERROR_GET_STORE_LIST";

export const GETBUSINESSNATURETABLELIST_SUCCESS =
  "GETBUSINESSNATURETABLELIST_SUCCESS";
export const GETBUSINESSNATURETABLELIST_FAILED =
  "GETBUSINESSNATURETABLELIST_FAILED";
export const RESET_GETBUSINESSNATURETABLELIST =
  "RESET_GETBUSINESSNATURETABLELIST";
export const LOADING_GETBUSINESSNATURETABLELIST =
  " LOADING_GETBUSINESSNATURETABLELIST";
export const NETWORK_ERROR_GETBUSINESSNATURETABLELIST =
  "NETWORK_ERROR_GETBUSINESSNATURETABLELIST";

export const ADMINMODULEALLOCATION_SUCCESS = "ADMINMODULEALLOCATION_SUCCESS";
export const ADMINMODULEALLOCATION_FAILED = "ADMINMODULEALLOCATION_FAILED";
export const RESET_ADMINMODULEALLOCATION = "RESET_ADMINMODULEALLOCATION";
export const LOADING_ADMINMODULEALLOCATION = " LOADING_ADMINMODULEALLOCATION";
export const NETWORK_ERROR_ADMINMODULEALLOCATION =
  "NETWORK_ERROR_ADMINMODULEALLOCATION";

export const ADMINALLOCATEDMODULE_SUCCESS = "ADMINALLOCATEDMODULE_SUCCESS";
export const ADMINALLOCATEDMODULE_FAILED = "ADMINALLOCATEDMODULE_FAILED";
export const RESET_ADMINALLOCATEDMODULE = "RESET_ADMINALLOCATEDMODULE";
export const LOADING_ADMINALLOCATEDMODULE = " LOADING_ADMINALLOCATEDMODULE";
export const NETWORK_ERROR_ADMINALLOCATEDMODULE =
  "NETWORK_ERROR_ADMINALLOCATEDMODULE";

export const ADMINUPDATEMODULEALLOCATION_SUCCESS =
  "ADMINUPDATEMODULEALLOCATION_SUCCESS";
export const ADMINUPDATEMODULEALLOCATION_FAILED =
  "ADMINUPDATEMODULEALLOCATION_FAILED";
export const RESET_ADMINUPDATEMODULEALLOCATION =
  "RESET_ADMINUPDATEMODULEALLOCATION";
export const LOADING_ADMINUPDATEMODULEALLOCATION =
  " LOADING_ADMINUPDATEMODULEALLOCATION";
export const NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION =
  "NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION";

export const ADMINCURRENCYCODE_SUCCESS = "ADMINCURRENCYCODE_SUCCESS";
export const ADMINCURRENCYCODE_FAILED = "ADMINCURRENCYCODE_FAILED";
export const RESET_ADMINCURRENCYCODE = "RESET_ADMINCURRENCYCODE";
export const LOADING_ADMINCURRENCYCODE = " LOADING_ADMINCURRENCYCODE";
export const NETWORK_ERROR_ADMINCURRENCYCODE =
  "NETWORK_ERROR_ADMINCURRENCYCODE";

export const GETWALLETOWNERIDNAMELISTAPI_SUCCESS =
  "GETWALLETOWNERIDNAMELISTAPI_SUCCESS";
export const GETWALLETOWNERIDNAMELISTAPI_FAILED =
  "GETWALLETOWNERIDNAMELISTAPI_FAILED";
export const RESET_GETWALLETOWNERIDNAMELISTAPI =
  "RESET_GETWALLETOWNERIDNAMELISTAPI";
export const LOADING_GETWALLETOWNERIDNAMELISTAPI =
  " LOADING_GETWALLETOWNERIDNAMELISTAPI";
export const NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI =
  "NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI";

export const GET_FEE_MANAGEMENT_OPERATIONSLIST_SUCCESS =
  "GET_FEE_MANAGEMENT_OPERATIONSLIST_SUCCESS";
export const GET_FEE_MANAGEMENT_OPERATIONSLIST_FAILED =
  "GET_FEE_MANAGEMENT_OPERATIONSLIST_FAILED";
export const RESET_GET_FEE_MANAGEMENT_OPERATIONSLIST =
  "RESET_GET_FEE_MANAGEMENT_OPERATIONSLIST";
export const LOADING_GET_FEE_MANAGEMENT_OPERATIONSLIST =
  " LOADING_GET_FEE_MANAGEMENT_OPERATIONSLIST";
export const NETWORK_ERROR_GET_FEE_MANAGEMENT_OPERATIONSLIST =
  "NETWORK_ERROR_GET_FEE_MANAGEMENT_OPERATIONSLIST";

export const GETKYCCONFIGURATIONLIST_SUCCESS =
  "GETKYCCONFIGURATIONLIST_SUCCESS";
export const GETKYCCONFIGURATIONLIST_FAILED = "GETKYCCONFIGURATIONLIST_FAILED";
export const RESET_GETKYCCONFIGURATIONLIST = "RESET_GETKYCCONFIGURATIONLIST";
export const LOADING_GETKYCCONFIGURATIONLIST =
  " LOADING_GETKYCCONFIGURATIONLIST";
export const NETWORK_ERROR_GETKYCCONFIGURATIONLIST =
  "NETWORK_ERROR_GETKYCCONFIGURATIONLIST";

export const DELETE_KYCCONFIGURATIONRECORD_SUCCESS =
  "DELETE_KYCCONFIGURATIONRECORD_SUCCESS";
export const DELETE_KYCCONFIGURATIONRECORD_FAILED =
  "DELETE_KYCCONFIGURATIONRECORD_FAILED";
export const RESET_DELETE_KYCCONFIGURATIONRECORD =
  "RESET_DELETE_KYCCONFIGURATIONRECORD";
export const LOADING_DELETE_KYCCONFIGURATIONRECORD =
  " LOADING_DELETE_KYCCONFIGURATIONRECORD";
export const NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD =
  "NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD";

//Admin-- (Bank Master)
export const ADMINADDNEWBANK_SUCCESS = "ADMINADDNEWBANK_SUCCESS";
export const ADMINADDNEWBANK_FAILED = "ADMINADDNEWBANK_FAILED";
export const RESET_ADMINADDNEWBANK = "RESET_ADMINADDNEWBANK";
export const LOADING_ADMINADDNEWBANK = "LOADING_ADMINADDNEWBANK";
export const NETWORK_ERROR_ADMINADDNEWBANK = "NETWORK_ERROR_ADMINADDNEWBANK";

export const ADMINGETBANK_SUCCESS = "ADMINGETBANK_SUCCESS";
export const ADMINGETBANK_FAILED = "ADMINGETBANK_FAILED";
export const RESET_ADMINGETBANK = "RESET_ADMINGETBANK";
export const LOADING_ADMINGETBANK = "LOADING_ADMINGETBANK";
export const NETWORK_ERROR_ADMINGETBANK = "NETWORK_ERROR_ADMINGETBANK";

export const ADMINGETBANKNAMELIST_SUCCESS = "ADMINGETBANKNAMELIST_SUCCESS";
export const ADMINGETBANKNAMELIST_FAILED = "ADMINGETBANKNAMELIST_FAILED";
export const RESET_ADMINGETBANKNAMELIST = "RESET_ADMINGETBANKNAMELIST";
export const LOADING_ADMINGETBANKNAMELIST = "LOADING_ADMINGETBANKNAMELIST";
export const NETWORK_ERROR_ADMINGETBANKNAMELIST =
  "NETWORK_ERROR_ADMINGETBANKNAMELIST";

export const ADMINGETMAPPINGBANKLIST_SUCCESS =
  "ADMINGETMAPPINGBANKLIST_SUCCESS";
export const ADMINGETMAPPINGBANKLIST_FAILED = "ADMINGETMAPPINGBANKLIST_FAILED";
export const RESET_ADMINGETMAPPINGBANKLIST = "RESET_ADMINGETMAPPINGBANKLIST";
export const LOADING_ADMINGETMAPPINGBANKLIST =
  "LOADING_ADMINGETMAPPINGBANKLIST";
export const NETWORK_ERROR_ADMINGETMAPPINGBANKLIST =
  "NETWORK_ERROR_ADMINGETMAPPINGBANKLIST";

export const ADMINGETMAPPINGBANK_SUCCESS = "ADMINGETMAPPINGBANK_SUCCESS";
export const ADMINGETMAPPINGBANK_FAILED = "ADMINGETMAPPINGBANK_FAILED";
export const RESET_ADMINGETMAPPINGBANK = "RESET_ADMINGETMAPPINGBANK";
export const LOADING_ADMINGETMAPPINGBANK = "LOADING_ADMINGETMAPPINGBANK";
export const NETWORK_ERROR_ADMINGETMAPPINGBANK =
  "NETWORK_ERROR_ADMINGETMAPPINGBANK";

export const ADMINDELETEBANKMAPPING_SUCCESS = "ADMINDELETEBANKMAPPING_SUCCESS";
export const ADMINDELETEBANKMAPPING_FAILED = "ADMINDELETEBANKMAPPING_FAILED";
export const RESET_ADMINDELETEBANKMAPPING = "RESET_ADMINDELETEBANKMAPPING";
export const LOADING_ADMINDELETEBANKMAPPING = "LOADING_ADMINDELETEBANKMAPPING";
export const NETWORK_ERROR_ADMINDELETEBANKMAPPING =
  "NETWORK_ERROR_ADMINDELETEBANKMAPPING";

export const ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS =
  "ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS";
export const ADMINGETMAPPINGBANKLISTCOMPARE_FAILED =
  "ADMINGETMAPPINGBANKLISTCOMPARE_FAILED";
export const RESET_ADMINGETMAPPINGBANKLISTCOMPARE =
  "RESET_ADMINGETMAPPINGBANKLISTCOMPARE";
export const LOADING_ADMINGETMAPPINGBANKLISTCOMPARE =
  "LOADING_ADMINGETMAPPINGBANKLISTCOMPARE";
export const NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE =
  "NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE";

//Admin-- (Language Master)
export const ADMINADDLANGUAGE_SUCCESS = "ADMINADDLANGUAGE_SUCCESS";
export const ADMINADDLANGUAGE_FAILED = "ADMINADDLANGUAGE_FAILED";
export const RESET_ADMINADDLANGUAGE = "RESET_ADMINADDLANGUAGE";
export const LOADING_ADMINADDLANGUAGE = "LOADING_ADMINADDLANGUAGE";
export const NETWORK_ERROR_ADMINADDLANGUAGE = "NETWORK_ERROR_ADMINADDLANGUAGE";

export const ADMINGETLANGUAGELIST_SUCCESS = "ADMINGETLANGUAGELIST_SUCCESS";
export const ADMINGETLANGUAGELIST_FAILED = "ADMINGETLANGUAGELIST_FAILED";
export const RESET_ADMINGETLANGUAGELIST = "RESET_ADMINGETLANGUAGELIST";
export const LOADING_ADMINGETLANGUAGELIST = "LOADING_ADMINGETLANGUAGELIST";
export const NETWORK_ERROR_ADMINGETLANGUAGELIST =
  "NETWORK_ERROR_ADMINGETLANGUAGELIST";

export const ADMINGETLANGUAGEMAPPINGLIST_SUCCESS =
  "ADMINGETLANGUAGEMAPPINGLIST_SUCCESS";
export const ADMINGETLANGUAGEMAPPINGLIST_FAILED =
  "ADMINGETLANGUAGEMAPPINGLIST_FAILED";
export const RESET_ADMINGETLANGUAGEMAPPINGLIST =
  "RESET_ADMINGETLANGUAGEMAPPINGLIST";
export const LOADING_ADMINGETLANGUAGEMAPPINGLIST =
  "LOADING_ADMINGETLANGUAGEMAPPINGLIST";
export const NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST =
  "NETWORK_ERROR_ADMINGETLANGUAGEMAPPINGLIST";

export const ADMINMAPPINGLANGUAGE_SUCCESS = "ADMINMAPPINGLANGUAGE_SUCCESS";
export const ADMINMAPPINGLANGUAGE_FAILED = "ADMINMAPPINGLANGUAGE_FAILED";
export const RESET_ADMINMAPPINGLANGUAGE = "RESET_ADMINMAPPINGLANGUAGE";
export const LOADING_ADMINMAPPINGLANGUAGE = "LOADING_ADMINMAPPINGLANGUAGE";
export const NETWORK_ERROR_ADMINMAPPINGLANGUAGE =
  "NETWORK_ERROR_ADMINMAPPINGLANGUAGE";

export const ADMINGETLANGUAGEDROPLIST_SUCCESS =
  "ADMINGETLANGUAGEDROPLIST_SUCCESS";
export const ADMINGETLANGUAGEDROPLIST_FAILED =
  "ADMINGETLANGUAGEDROPLIST_FAILED";
export const RESET_ADMINGETLANGUAGEDROPLIST = "RESET_ADMINGETLANGUAGEDROPLIST";
export const LOADING_ADMINGETLANGUAGEDROPLIST =
  "LOADING_ADMINGETLANGUAGEDROPLIST";
export const NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST =
  "NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST";

export const ADMINDELETELANGUAGEMAPPING_SUCCESS =
  "ADMINDELETELANGUAGEMAPPING_SUCCESS";
export const ADMINDELETELANGUAGEMAPPING_FAILED =
  "ADMINDELETELANGUAGEMAPPING_FAILED";
export const RESET_ADMINDELETELANGUAGEMAPPING =
  "RESET_ADMINDELETELANGUAGEMAPPING";
export const LOADING_ADMINDELETELANGUAGEMAPPING =
  "LOADING_ADMINDELETELANGUAGEMAPPING";
export const NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING =
  "NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING";

//getWalletOwnerBankDetails

export const GETWALLETOWNERBANKDETAILSLIST_SUCCESS =
  "GETWALLETOWNERBANKDETAILSLIST_SUCCESS";
export const GETWALLETOWNERBANKDETAILSLIST_FAILED =
  "GETWALLETOWNERBANKDETAILSLIST_FAILED";
export const RESET_GETWALLETOWNERBANKDETAILSLIST =
  "RESET_GETWALLETOWNERBANKDETAILSLIST";
export const LOADING_GETWALLETOWNERBANKDETAILSLIST =
  " LOADING_GETWALLETOWNERBANKDETAILSLIST";
export const NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST =
  "NETWORK_ERROR_GETWALLETOWNERBANKDETAILSLIST";

//GETVIEWWALLETOWNERBANKDETAILS
export const GETVIEWWALLETOWNERBANKDETAILS_SUCCESS =
  "GETVIEWWALLETOWNERBANKDETAILS_SUCCESS";
export const GETVIEWWALLETOWNERBANKDETAILS_FAILED =
  "GETVIEWWALLETOWNERBANKDETAILS_FAILED";
export const RESET_GETVIEWWALLETOWNERBANKDETAILS =
  "RESET_GETVIEWWALLETOWNERBANKDETAILS";
export const LOADING_GETVIEWWALLETOWNERBANKDETAILS =
  " LOADING_GETVIEWWALLETOWNERBANKDETAILS";
export const NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS =
  "NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS";

export const UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS =
  "UPDATEORADDWALLETOWNERBANKDETAILS_SUCCESS";
export const UPDATEORADDWALLETOWNERBANKDETAILS_FAILED =
  "UPDATEORADDWALLETOWNERBANKDETAILS_FAILED";
export const RESET_UPDATEORADDWALLETOWNERBANKDETAILS =
  "RESET_UPDATEORADDWALLETOWNERBANKDETAILS";
export const LOADING_UPDATEORADDWALLETOWNERBANKDETAILS =
  " LOADING_UPDATEORADDWALLETOWNERBANKDETAILS";
export const NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS =
  "NETWORK_ERROR_UPDATEORADDWALLETOWNERBANKDETAILS";

export const GETVIEWCONGIGURATIONLIST_SUCCESS =
  "GETVIEWCONGIGURATIONLIST_SUCCESS";
export const GETVIEWCONGIGURATIONLIST_FAILED =
  "GETVIEWCONGIGURATIONLIST_FAILED";
export const RESET_GETVIEWCONGIGURATIONLIST = "RESET_GETVIEWCONGIGURATIONLIST";
export const LOADING_GETVIEWCONGIGURATIONLIST =
  " LOADING_GETVIEWCONGIGURATIONLIST";
export const NETWORK_ERROR_GETVIEWCONGIGURATIONLIST =
  "NETWORK_ERROR_GETVIEWCONGIGURATIONLIST";

export const GETWALLETOWNERCONFIGURATIONLIST_SUCCESS =
  "GETWALLETOWNERCONFIGURATIONLIST_SUCCESS";
export const GETWALLETOWNERCONFIGURATIONLIST_FAILED =
  "GETWALLETOWNERCONFIGURATIONLIST_FAILED";
export const RESET_GETWALLETOWNERCONFIGURATIONLIST =
  "RESET_GETWALLETOWNERCONFIGURATIONLIST";
export const LOADING_GETWALLETOWNERCONFIGURATIONLIST =
  " LOADING_GETWALLETOWNERCONFIGURATIONLIST";
export const NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST =
  "NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST";

export const GET_FEE_NAME_LIST_SUCCESS = "GET_FEE_NAME_LIST_SUCCESS";
export const GET_FEE_NAME_LIST_FAILED = "GET_FEE_NAME_LIST_FAILED";
export const RESET_GET_FEE_NAME_LIST = "RESET_GET_FEE_NAME_LIST";
export const LOADING_GET_FEE_NAME_LIST = " LOADING_GET_FEE_NAME_LIST";
export const NETWORK_ERROR_GET_FEE_NAME_LIST =
  "NETWORK_ERROR_GET_FEE_NAME_LIST";

export const GET_SMS_PROVIDER_SUCCESS = "GET_SMS_PROVIDER_SUCCESS";
export const GET_SMS_PROVIDER_FAILED = "GET_SMS_PROVIDER_FAILED";
export const RESET_GET_SMS_PROVIDER = "RESET_GET_SMS_PROVIDER";
export const LOADING_GET_SMS_PROVIDER = " LOADING_GET_SMS_PROVIDER";
export const NETWORK_ERROR_GET_SMS_PROVIDER = "NETWORK_ERROR_GET_SMS_PROVIDER";

export const GETKYCAPPROVEREJECT_SUCCESS = "GETKYCAPPROVEREJECT_SUCCESS";
export const GETKYCAPPROVEREJECT_FAILED = "GETKYCAPPROVEREJECT_FAILED";
export const RESET_GETKYCAPPROVEREJECT = "RESET_GETKYCAPPROVEREJECT";
export const LOADING_GETKYCAPPROVEREJECT = " LOADING_GETKYCAPPROVEREJECT";
export const NETWORK_ERROR_GETKYCAPPROVEREJECT =
  "NETWORK_ERROR_GETKYCAPPROVEREJECT";

export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_FAILED = "GET_INVOICE_FAILED";
export const RESET_GET_INVOICE = "RESET_GET_INVOICE";
export const LOADING_GET_INVOICE = " LOADING_GET_INVOICE";
export const NETWORK_ERROR_GET_INVOICE = "NETWORK_ERROR_GET_INVOICE";

export const GETUPDATECONFIGURATION_SUCCESS = "GETUPDATECONFIGURATION_SUCCESS";
export const GETUPDATECONFIGURATION_FAILED = "GETUPDATECONFIGURATION_FAILED";
export const RESET_GETUPDATECONFIGURATION = "RESET_GETUPDATECONFIGURATION";
export const LOADING_GETUPDATECONFIGURATION = " LOADING_GETUPDATECONFIGURATION";
export const NETWORK_ERROR_GETUPDATECONFIGURATION =
  "NETWORK_ERROR_GETUPDATECONFIGURATION";

export const COMMONCONFIGURADETAILS_SUCCESS = "COMMONCONFIGURADETAILS_SUCCESS";
export const COMMONCONFIGURADETAILS_FAILED = "COMMONCONFIGURADETAILS_FAILED";
export const RESET_COMMONCONFIGURADETAILS = "RESET_COMMONCONFIGURADETAILS";
export const LOADING_COMMONCONFIGURADETAILS = " LOADING_COMMONCONFIGURADETAILS";
export const NETWORK_ERROR_COMMONCONFIGURADETAILS =
  "NETWORK_ERROR_COMMONCONFIGURADETAILS";

export const GETUPDATECOMMOMCONFDETAILS_SUCCESS =
  "GETUPDATECOMMOMCONFDETAILS_SUCCESS";
export const GETUPDATECOMMOMCONFDETAILS_FAILED =
  "GETUPDATECOMMOMCONFDETAILS_FAILED";
export const RESET_GETUPDATECOMMOMCONFDETAILS =
  "RESET_GETUPDATECOMMOMCONFDETAILS";
export const LOADING_GETUPDATECOMMOMCONFDETAILS =
  " LOADING_GETUPDATECOMMOMCONFDETAILS";
export const NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS =
  "NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS";
export const GET_UPDATE_INVOICE_CONFIG_SUCCESS =
  "GET_UPDATE_INVOICE_CONFIG_SUCCESS";
export const GET_UPDATE_INVOICE_CONFIG_FAILED =
  "GET_UPDATE_INVOICE_CONFIG_FAILED";
export const RESET_GET_UPDATE_INVOICE_CONFIG =
  "RESET_GET_UPDATE_INVOICE_CONFIG";
export const LOADING_GET_UPDATE_INVOICE_CONFIG =
  " LOADING_GET_UPDATE_INVOICE_CONFIG";
export const NETWORK_ERROR_GET_UPDATE_INVOICE_CONFIG =
  "NETWORK_ERROR_GET_UPDATE_INVOICE_CONFIG";

export const PARTNER_MODULE_ALLOCATION_SUCCESS =
  "PARTNER_MODULE_ALLOCATION_SUCCESS";
export const PARTNER_MODULE_ALLOCATION_FAILED =
  "PARTNER_MODULE_ALLOCATION_FAILED";
export const RESET_PARTNER_MODULE_ALLOCATION =
  "RESET_PARTNER_MODULE_ALLOCATION";
export const LOADING_PARTNER_MODULE_ALLOCATION =
  " LOADING_PARTNER_MODULE_ALLOCATION";
export const NETWORK_ERROR_PARTNER_MODULE_ALLOCATION =
  "NETWORK_ERROR_PARTNER_MODULE_ALLOCATION";

export const INVOICE_REGENERATION_SUCCESS = "INVOICE_REGENERATION_SUCCESS";
export const INVOICE_REGENERATION_FAILED = "INVOICE_REGENERATION_FAILED";
export const RESET_INVOICE_REGENERATION = "RESET_INVOICE_REGENERATION";
export const LOADING_INVOICE_REGENERATION = " LOADING_INVOICE_REGENERATION";
export const NETWORK_ERROR_INVOICE_REGENERATION =
  "NETWORK_ERROR_INVOICE_REGENERATION";

export const GET_INVOICE_CONFIG_SUCCESS = "GET_INVOICE_CONFIG_SUCCESS";
export const GET_INVOICE_CONFIG_FAILED = "GET_INVOICE_CONFIG_FAILED";
export const RESET_GET_INVOICE_CONFIG = "RESET_GET_INVOICE_CONFIG";
export const LOADING_GET_INVOICE_CONFIG = " LOADING_GET_INVOICE_CONFIG";
export const NETWORK_ERROR_GET_INVOICE_CONFIG =
  "NETWORK_ERROR_GET_INVOICE_CONFIG";

export const GETORDERID_SUCCESS = "GETORDERID_SUCCESS";
export const GETORDERID_FAILED = "GETORDERID_FAILED";
export const RESET_GETORDERID = "RESET_GETORDERID";
export const LOADING_GETORDERID = " LOADING_GETORDERID";
export const NETWORK_ERROR_GETORDERID = "NETWORK_ERROR_GETORDERID";

export const GETRULEMAPPINGCHECK_SUCCESS = "GETRULEMAPPINGCHECK_SUCCESS";
export const GETRULEMAPPINGCHECK_FAILED = "GETRULEMAPPINGCHECK_FAILED";
export const RESET_GETRULEMAPPINGCHECK = "RESET_GETRULEMAPPINGCHECK";
export const LOADING_GETRULEMAPPINGCHECK = " LOADING_GETRULEMAPPINGCHECK";
export const NETWORK_ERROR_GETRULEMAPPINGCHECK =
  "NETWORK_ERROR_GETRULEMAPPINGCHECK";

export const ADDUPDATEKYCCONF_SUCCESS = "ADDUPDATEKYCCONF_SUCCESS";
export const ADDUPDATEKYCCONF_FAILED = "ADDUPDATEKYCCONF_FAILED";
export const RESET_ADDUPDATEKYCCONF = "RESET_ADDUPDATEKYCCONF";
export const LOADING_ADDUPDATEKYCCONF = " LOADING_ADDUPDATEKYCCONF";
export const NETWORK_ERROR_ADDUPDATEKYCCONF = "NETWORK_ERROR_ADDUPDATEKYCCONF";

export const GETKYCCONFIGURATIONID_SUCCESS = "GETKYCCONFIGURATIONID_SUCCESS";
export const GETKYCCONFIGURATIONID_FAILED = "GETKYCCONFIGURATIONID_FAILED";
export const RESET_GETKYCCONFIGURATIONID = "RESET_GETKYCCONFIGURATIONID";
export const LOADING_GETKYCCONFIGURATIONID = " LOADING_GETKYCCONFIGURATIONID";
export const NETWORK_ERROR_GETKYCCONFIGURATIONID =
  "NETWORK_ERROR_GETKYCCONFIGURATIONID";

export const GETKYCCONFIGURATIONDETAILS_SUCCESS =
  "GETKYCCONFIGURATIONDETAILS_SUCCESS";
export const GETKYCCONFIGURATIONDETAILS_FAILED =
  "GETKYCCONFIGURATIONDETAILS_FAILED";
export const RESET_GETKYCCONFIGURATIONDETAILS =
  "RESET_GETKYCCONFIGURATIONDETAILS";
export const LOADING_GETKYCCONFIGURATIONDETAILS =
  " LOADING_GETKYCCONFIGURATIONDETAILS";
export const NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS =
  "NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS";

export const USER_MANAGEMENT_SUCCESS = "USER_MANAGEMENT_SUCCESS";
export const USER_MANAGEMENT_FAILED = "USER_MANAGEMENT_FAILED";
export const RESET_USER_MANAGEMENT = "RESET_USER_MANAGEMENT";
export const LOADING_USER_MANAGEMENT = "LOADING_USER_MANAGEMENT";
export const NETWORK_ERROR_USER_MANAGEMENT = "NETWORK_ERROR_USER_MANAGEMENT";

export const VIEW_USER_MANAGEMENT_SUCCESS = "VIEW_USER_MANAGEMENT_SUCCESS";
export const VIEW_USER_MANAGEMENT_FAILED = "VIEW_USER_MANAGEMENT_FAILED";
export const RESET_VIEW_USER_MANAGEMENT = "RESET_VIEW_USER_MANAGEMENT";
export const LOADING_VIEW_USER_MANAGEMENT = "LOADING_VIEW_USER_MANAGEMENT";
export const NETWORK_ERROR_VIEW_USER_MANAGEMENT =
  "NETWORK_ERROR_VIEW_USER_MANAGEMENT";

export const ADD_USER_MANAGEMENT_SUCCESS = "ADD_USER_MANAGEMENT_SUCCESS";
export const ADD_USER_MANAGEMENT_FAILED = "ADD_USER_MANAGEMENT_FAILED";
export const RESET_ADD_USER_MANAGEMENT = "RESET_ADD_USER_MANAGEMENT";
export const LOADING_ADD_USER_MANAGEMENT = "LOADING_ADD_USER_MANAGEMENT";
export const NETWORK_ERROR_ADD_USER_MANAGEMENT =
  "NETWORK_ERROR_ADD_USER_MANAGEMENT";

export const DELETE_USER_MANAGEMENT_SUCCESS = "DELETE_USER_MANAGEMENT_SUCCESS";
export const DELETE_USER_MANAGEMENT_FAILED = "DELETE_USER_MANAGEMENT_FAILED";
export const RESET_DELETE_USER_MANAGEMENT = "RESET_DELETE_USER_MANAGEMENT";
export const LOADING_DELETE_USER_MANAGEMENT = "LOADING_DELETE_USER_MANAGEMENT";
export const NETWORK_ERROR_DELETE_USER_MANAGEMENT =
  "NETWORK_ERROR_DELETE_USER_MANAGEMENT";

export const CREATEGATEWAYMAPPING_SUCCESS = "CREATEGATEWAYMAPPING_SUCCESS";
export const CREATEGATEWAYMAPPING_FAILED = "CREATEGATEWAYMAPPING_FAILED";
export const RESET_CREATEGATEWAYMAPPING = "RESET_CREATEGATEWAYMAPPING";
export const LOADING_CREATEGATEWAYMAPPING = "LOADING_CREATEGATEWAYMAPPING";
export const NETWORK_ERROR_CREATEGATEWAYMAPPING =
  "NETWORK_ERROR_CREATEGATEWAYMAPPING";

export const GETALLGATEWAYMAPPINGLIST_SUCCESS =
  "GETALLGATEWAYMAPPINGLIST_SUCCESS";
export const GETALLGATEWAYMAPPINGLIST_FAILED =
  "GETALLGATEWAYMAPPINGLIST_FAILED";
export const RESET_GETALLGATEWAYMAPPINGLIST = "RESET_GETALLGATEWAYMAPPINGLIST";
export const LOADING_GETALLGATEWAYMAPPINGLIST =
  "LOADING_GETALLGATEWAYMAPPINGLIST";
export const NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST =
  "NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST";

export const DELETEGATEWAYMAPPING_SUCCESS = "DELETEGATEWAYMAPPING_SUCCESS";
export const DELETEGATEWAYMAPPING_FAILED = "DELETEGATEWAYMAPPING_FAILED";
export const RESET_DELETEGATEWAYMAPPING = "RESET_DELETEGATEWAYMAPPING";
export const LOADING_DELETEGATEWAYMAPPING = "LOADING_DELETEGATEWAYMAPPING";
export const NETWORK_ERROR_DELETEGATEWAYMAPPING =
  "NETWORK_ERROR_DELETEGATEWAYMAPPING";

export const PAYMENTBRANDLIST_SUCCESS = "PAYMENTBRANDLIST_SUCCESS";
export const PAYMENTBRANDLIST_FAILED = "PAYMENTBRANDLIST_FAILED";
export const RESET_PAYMENTBRANDLIST = "RESET_PAYMENTBRANDLIST";
export const LOADING_PAYMENTBRANDLIST = "LOADING_PAYMENTBRANDLIST";
export const NETWORK_ERROR_PAYMENTBRANDLIST = "NETWORK_ERROR_PAYMENTBRANDLIST";

export const GETPAYMENTMODELIST_SUCCESS = "GETPAYMENTMODELIST_SUCCESS";
export const GETPAYMENTMODELIST_FAILED = "GETPAYMENTMODELIST_FAILED";
export const RESET_GETPAYMENTMODELIST = "RESET_GETPAYMENTMODELIST";
export const LOADING_GETPAYMENTMODELIST = "LOADING_GETPAYMENTMODELIST";
export const NETWORK_ERROR_GETPAYMENTMODELIST =
  "NETWORK_ERROR_GETPAYMENTMODELIST";

export const GETWAYLIST_SUCCESS = "GETWAYLIST_SUCCESS";
export const GETWAYLIST_FAILED = "GETWAYLIST_FAILED";
export const RESET_GETWAYLIST = "RESET_GETWAYLIST";
export const LOADING_GETWAYLIST = "LOADING_GETWAYLIST";
export const NETWORK_ERROR_GETWAYLIST = "NETWORK_ERROR_GETWAYLIST";

export const DEALETGETLISTDSRMASTER_SUCCESS = "DEALETGETLISTDSRMASTER_SUCCESS";
export const DEALETGETLISTDSRMASTER_FAILED = "DEALETGETLISTDSRMASTER_FAILED";
export const RESET_DEALETGETLISTDSRMASTER = "RESET_DEALETGETLISTDSRMASTER";
export const LOADING_DEALETGETLISTDSRMASTER = "LOADING_DEALETGETLISTDSRMASTER";
export const NETWORK_ERROR_DEALETGETLISTDSRMASTER =
  "NETWORK_ERROR_DEALETGETLISTDSRMASTER";

export const DEALERSETDSRLIMITS_SUCCESS = "DEALERSETDSRLIMITS_SUCCESS";
export const DEALERSETDSRLIMITS_FAILED = "DEALERSETDSRLIMITS_FAILED";
export const RESET_DEALERSETDSRLIMITS = "RESET_DEALERSETDSRLIMITS";
export const LOADING_DEALERSETDSRLIMITS = "LOADING_DEALERSETDSRLIMITS";
export const NETWORK_ERROR_DEALERSETDSRLIMITS =
  "NETWORK_ERROR_DEALERSETDSRLIMITS";

export const DEALERDSRLIST_SUCCESS = "DEALERDSRLIST_SUCCESS";
export const DEALERDSRLIST_FAILED = "DEALERDSRLIST_FAILED";
export const RESET_DEALERDSRLIST = "RESET_DEALERDSRLIST";
export const LOADING_DEALERDSRLIST = "LOADING_DEALERDSRLIST";
export const NETWORK_ERROR_DEALERDSRLIST = "NETWORK_ERROR_DEALERDSRLIST";

export const DEALERVIEWDSRLIST_SUCCESS = "DEALERVIEWDSRLIST_SUCCESS";
export const DEALERVIEWDSRLIST_FAILED = "DEALERVIEWDSRLIST_FAILED";
export const RESET_DEALERVIEWDSRLIST = "RESET_DEALERVIEWDSRLIST";
export const LOADING_DEALERVIEWDSRLIST = "LOADING_DEALERVIEWDSRLIST";
export const NETWORK_ERROR_DEALERVIEWDSRLIST =
  "NETWORK_ERROR_DEALERVIEWDSRLIST";

export const UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS =
  "UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS";
export const UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED =
  "UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED";
export const RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT =
  "RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT";
export const LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT =
  "LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT";
export const NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT =
  "NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT";

export const DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT_SUCCESS =
  "DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT_SUCCESS";
export const DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT_FAILED =
  "DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT_FAILED";
export const RESET_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT =
  "RESET_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT";
export const LOADING_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT =
  "LOADING_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT";
export const NETWORK_ERROR_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT =
  "NETWORK_ERROR_DEALERDOWNLOADSAMPLEFILEOFDSRLIMIT";

export const DEALERSAMPLEFILE_SUCCESS = "DEALERSAMPLEFILE_SUCCESS";
export const DEALERSAMPLEFILE_FAILED = "DEALERSAMPLEFILE_FAILED";
export const RESET_DEALERSAMPLEFILE = "RESET_DEALERSAMPLEFILE";
export const LOADING_DEALERSAMPLEFILE = "LOADING_DEALERSAMPLEFILE";
export const NETWORK_ERROR_DEALERSAMPLEFILE = "NETWORK_ERROR_DEALERSAMPLEFILE";

export const DEALERCHANGEDSRMASTERPASSWORD_SUCCESS =
  "DEALERCHANGEDSRMASTERPASSWORD_SUCCESS";
export const DEALERCHANGEDSRMASTERPASSWORD_FAILED =
  "DEALERCHANGEDSRMASTERPASSWORD_FAILED";
export const RESET_DEALERCHANGEDSRMASTERPASSWORD =
  "RESET_DEALERCHANGEDSRMASTERPASSWORD";
export const LOADING_DEALERCHANGEDSRMASTERPASSWORD =
  "LOADING_DEALERCHANGEDSRMASTERPASSWORD";
export const NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD =
  "NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD";

export const DEALERBLOCKDSRMASTER_SUCCESS = "DEALERBLOCKDSRMASTER_SUCCESS";
export const DEALERBLOCKDSRMASTER_FAILED = "DEALERBLOCKDSRMASTER_FAILED";
export const RESET_DEALERBLOCKDSRMASTER = "RESET_DEALERBLOCKDSRMASTER";
export const LOADING_DEALERBLOCKDSRMASTER = "LOADING_DEALERBLOCKDSRMASTER";
export const NETWORK_ERROR_DEALERBLOCKDSRMASTER =
  "NETWORK_ERROR_DEALERBLOCKDSRMASTER";

export const DEALERADDUPDATEDSRLIMITS_SUCCESS =
  "DEALERADDUPDATEDSRLIMITS_SUCCESS";
export const DEALERADDUPDATEDSRLIMITS_FAILED =
  "DEALERADDUPDATEDSRLIMITS_FAILED";
export const RESET_DEALERADDUPDATEDSRLIMITS = "RESET_DEALERADDUPDATEDSRLIMITS";
export const LOADING_DEALERADDUPDATEDSRLIMITS =
  "LOADING_DEALERADDUPDATEDSRLIMITS";
export const NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS =
  "NETWORK_ERROR_DEALERADDUPDATEDSRLIMITS";

export const DEALERADDUPDATEDIVISONLIST_SUCCESS =
  "DEALERADDUPDATEDIVISONLIST_SUCCESS";
export const DEALERADDUPDATEDIVISONLIST_FAILED =
  "DEALERADDUPDATEDIVISONLIST_FAILED";
export const RESET_DEALERADDUPDATEDIVISONLIST =
  "RESET_DEALERADDUPDATEDIVISONLIST";
export const LOADING_DEALERADDUPDATEDIVISONLIST =
  "LOADING_DEALERADDUPDATEDIVISONLIST";
export const NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST =
  "NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST";

export const DEALERADDUPDATEDISTRICTLIST_SUCCESS =
  "DEALERADDUPDATEDISTRICTLIST_SUCCESS";
export const DEALERADDUPDATEDISTRICTLIST_FAILED =
  "DEALERADDUPDATEDISTRICTLIST_FAILED";
export const RESET_DEALERADDUPDATEDISTRICTLIST =
  "RESET_DEALERADDUPDATEDISTRICTLIST";
export const LOADING_DEALERADDUPDATEDISTRICTLIST =
  "LOADING_DEALERADDUPDATEDISTRICTLIST";
export const NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST =
  "NETWORK_ERROR_DEALERADDUPDATEDISTRICTLIST";

export const DEALERADDUPDATETHANALIST_SUCCESS =
  "DEALERADDUPDATETHANALIST_SUCCESS";
export const DEALERADDUPDATETHANALIST_FAILED =
  "DEALERADDUPDATETHANALIST_FAILED";
export const RESET_DEALERADDUPDATETHANALIST = "RESET_DEALERADDUPDATETHANALIST";
export const LOADING_DEALERADDUPDATETHANALIST =
  "LOADING_DEALERADDUPDATETHANALIST";
export const NETWORK_ERROR_DEALERADDUPDATETHANALIST =
  "NETWORK_ERROR_DEALERADDUPDATETHANALIST";

export const DEALERADDUPDATEUNIONLIST_SUCCESS =
  "DEALERADDUPDATEUNIONLIST_SUCCESS";
export const DEALERADDUPDATEUNIONLIST_FAILED =
  "DEALERADDUPDATEUNIONLIST_FAILED";
export const RESET_DEALERADDUPDATEUNIONLIST = "RESET_DEALERADDUPDATEUNIONLIST";
export const LOADING_DEALERADDUPDATEUNIONLIST =
  "LOADING_DEALERADDUPDATEUNIONLIST";
export const NETWORK_ERROR_DEALERADDUPDATEUNIONLIST =
  "NETWORK_ERROR_DEALERADDUPDATEUNIONLIST";

export const DEALERGETDEFAULTCURRENCYLISTDEALER_SUCCESS =
  "DEALERGETDEFAULTCURRENCYLISTDEALER";
export const DEALERGETDEFAULTCURRENCYLISTDEALER_FAILED =
  "DEALERGETDEFAULTCURRENCYLISTDEALER_FAILED";
export const RESET_DEALERGETDEFAULTCURRENCYLISTDEALER =
  "RESET_DEALERGETDEFAULTCURRENCYLISTDEALER";
export const LOADING_DEALERGETDEFAULTCURRENCYLISTDEALER =
  "LOADING_DEALERGETDEFAULTCURRENCYLISTDEALER";
export const NETWORK_ERROR_DEALERGETDEFAULTCURRENCYLISTDEALER =
  "NETWORK_ERROR_DEALERGETDEFAULTCURRENCYLISTDEALER";

export const DEALERADDORUPDATEDSRLIST_SUCCESS =
  "DEALERADDORUPDATEDSRLIST_SUCCESS";
export const DEALERADDORUPDATEDSRLIST_FAILED =
  "DEALERADDORUPDATEDSRLIST_FAILED";
export const RESET_DEALERADDORUPDATEDSRLIST = "RESET_DEALERADDORUPDATEDSRLIST";
export const LOADING_DEALERADDORUPDATEDSRLIST =
  "LOADING_DEALERADDORUPDATEDSRLIST";
export const NETWORK_ERROR_DEALERADDORUPDATEDSRLIST =
  "NETWORK_ERROR_DEALERADDORUPDATEDSRLIST";

export const DEALERAPPROVEREJECTDSR_SUCCESS = "DEALERAPPROVEREJECTDSR_SUCCESS";
export const DEALERAPPROVEREJECTDSR_FAILED = "DEALERAPPROVEREJECTDSR_FAILED";
export const RESET_DEALERAPPROVEREJECTDSR = "RESET_DEALERAPPROVEREJECTDSR";
export const LOADING_DEALERAPPROVEREJECTDSR = "LOADING_DEALERAPPROVEREJECTDSR";
export const NETWORK_ERROR_DEALERAPPROVEREJECTDSR =
  "NETWORK_ERROR_DEALERAPPROVEREJECTDSR";

export const DEALERGETLISTDSRTRANSACTION_SUCCESS =
  "DEALERGETLISTDSRTRANSACTION_SUCCESS";
export const DEALERGETLISTDSRTRANSACTION_FAILED =
  "DEALERGETLISTDSRTRANSACTION_FAILED";
export const RESET_DEALERGETLISTDSRTRANSACTION =
  "RESET_DEALERGETLISTDSRTRANSACTION";
export const LOADING_DEALERGETLISTDSRTRANSACTION =
  "LOADING_DEALERGETLISTDSRTRANSACTION";
export const NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION =
  "NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION";

export const DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS =
  "DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS";
export const DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED =
  "DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED";
export const RESET_DEALERDSRTRANSACTIONEXCELPDFFILE =
  "RESET_DEALERDSRTRANSACTIONEXCELPDFFILE";
export const LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE =
  "LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE";
export const NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE =
  "NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE";

export const DEALERPENDINGREQUESTLIST_SUCCESS =
  "DEALERPENDINGREQUESTLIST_SUCCESS";
export const DEALERPENDINGREQUESTLIST_FAILED =
  "DEALERPENDINGREQUESTLIST_FAILED";
export const RESET_DEALERPENDINGREQUESTLIST = "RESET_DEALERPENDINGREQUESTLIST";
export const LOADING_DEALERPENDINGREQUESTLIST =
  "LOADING_DEALERPENDINGREQUESTLIST";
export const NETWORK_ERROR_DEALERPENDINGREQUESTLIST =
  "NETWORK_ERROR_DEALERPENDINGREQUESTLIST";

export const DEALERGETTRANSACTIONMASTERLIST_SUCCESS =
  "DEALERGETTRANSACTIONMASTERLIST_SUCCESS";
export const DEALERGETTRANSACTIONMASTERLIST_FAILED =
  "DEALERGETTRANSACTIONMASTERLIST_FAILED";
export const RESET_DEALERGETTRANSACTIONMASTERLIST =
  "RESET_DEALERGETTRANSACTIONMASTERLIST";
export const LOADING_DEALERGETTRANSACTIONMASTERLIST =
  "LOADING_DEALERGETTRANSACTIONMASTERLIST";
export const NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST =
  "NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST";

export const DEALERGETFEEREPORTLIST_SUCCESS = "DEALERGETFEEREPORTLIST_SUCCESS";
export const DEALERGETFEEREPORTLIST_FAILED = "DEALERGETFEEREPORTLIST_FAILED";
export const RESET_DEALERGETFEEREPORTLIST = "RESET_DEALERGETFEEREPORTLIST";
export const LOADING_DEALERGETFEEREPORTLIST = "LOADING_DEALERGETFEEREPORTLIST";
export const NETWORK_ERROR_DEALERGETFEEREPORTLIST =
  "NETWORK_ERROR_DEALERGETFEEREPORTLIST";

export const DEALERGETSUMMARYMASTERLIST_SUCCESS =
  "DEALERGETSUMMARYMASTERLIST_SUCCESS";
export const DEALERGETSUMMARYMASTERLIST_FAILED =
  "DEALERGETSUMMARYMASTERLIST_FAILED";
export const RESET_DEALERGETSUMMARYMASTERLIST =
  "RESET_DEALERGETSUMMARYMASTERLIST";
export const LOADING_DEALERGETSUMMARYMASTERLIST =
  "LOADING_DEALERGETSUMMARYMASTERLIST";
export const NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST =
  "NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST";

export const DEALERPROFILE_SUCCESS = "DEALERPROFILE_SUCCESS";
export const DEALERPROFILE_FAILED = "DEALERPROFILE_FAILED";
export const RESET_DEALERPROFILE = "RESET_DEALERPROFILE";
export const LOADING_DEALERPROFILE = "LOADING_DEALERPROFILE";
export const NETWORK_ERROR_DEALERPROFILE = "NETWORK_ERROR_DEALERPROFILE";

export const DEALERSENDINCASHIN_SUCCESS = "DEALERSENDINCASHIN_SUCCESS";
export const DEALERSENDINCASHIN_FAILED = "DEALERSENDINCASHIN_FAILED";
export const RESET_DEALERSENDINCASHIN = "RESET_DEALERSENDINCASHIN";
export const LOADING_DEALERSENDINCASHIN = "LOADING_DEALERSENDINCASHIN";
export const NETWORK_ERROR_DEALERSENDINCASHIN =
  "NETWORK_ERROR_DEALERSENDINCASHIN";

export const DEALERWALLETEXCELPDFFILE_SUCCESS =
  "DEALERWALLETEXCELPDFFILE_SUCCESS";
export const DEALERWALLETEXCELPDFFILE_FAILED =
  "DEALERWALLETEXCELPDFFILE_FAILED";
export const RESET_DEALERWALLETEXCELPDFFILE = "RESET_DEALERWALLETEXCELPDFFILE";
export const LOADING_DEALERWALLETEXCELPDFFILE =
  "LOADING_DEALERWALLETEXCELPDFFILE";
export const NETWORK_ERROR_DEALERWALLETEXCELPDFFILE =
  "NETWORK_ERROR_DEALERWALLETEXCELPDFFILE";

export const DEALERFEEEXCELPDFFILE_SUCCESS = "DEALERFEEEXCELPDFFILE_SUCCESS";
export const DEALERFEEEXCELPDFFILE_FAILED = "DEALERFEEEXCELPDFFILE_FAILED";
export const RESET_DEALERFEEEXCELPDFFILE = "RESET_DEALERFEEEXCELPDFFILE";
export const LOADING_DEALERFEEEXCELPDFFILE = "LOADING_DEALERFEEEXCELPDFFILE";
export const NETWORK_ERROR_DEALERFEEEXCELPDFFILE =
  "NETWORK_ERROR_DEALERFEEEXCELPDFFILE";

export const DEALERSUMMARYEXCELPDFFILE_SUCCESS =
  "DEALERSUMMARYEXCELPDFFILE_SUCCESS";
export const DEALERSUMMARYEXCELPDFFILE_FAILED =
  "DEALERSUMMARYEXCELPDFFILE_FAILED";
export const RESET_DEALERSUMMARYEXCELPDFFILE =
  "RESET_DEALERSUMMARYEXCELPDFFILE";
export const LOADING_DEALERSUMMARYEXCELPDFFILE =
  "LOADING_DEALERSUMMARYEXCELPDFFILE";
export const NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE =
  "NETWORK_ERROR_DEALERSUMMARYEXCELPDFFILE";

export const DEALERDSRMAPPINGLIST_SUCCESS = "DEALERDSRMAPPINGLIST_SUCCESS";
export const DEALERDSRMAPPINGLIST_FAILED = "DEALERDSRMAPPINGLIST_FAILED";
export const RESET_DEALERDSRMAPPINGLIST = "RESET_DEALERDSRMAPPINGLIST";
export const LOADING_DEALERDSRMAPPINGLIST = "LOADING_DEALERDSRMAPPINGLIST";
export const NETWORK_ERROR_DEALERDSRMAPPINGLIST =
  "NETWORK_ERROR_DEALERDSRMAPPINGLIST";

export const DEALERDELETEDSR_SUCCESS = "DEALERDELETEDSR_SUCCESS";
export const DEALERDELETEDSR_FAILED = "DEALERDELETEDSR_FAILED";
export const RESET_DEALERDELETEDSR = "RESET_DEALERDELETEDSR";
export const LOADING_DEALERDELETEDSR = "LOADING_DEALERDELETEDSR";
export const NETWORK_ERROR_DEALERDELETEDSR = "NETWORK_ERROR_DEALERDELETEDSR";

export const DEALERADDEDITDSR_SUCCESS = "DEALERADDEDITDSR_SUCCESS";
export const DEALERADDEDITDSR_FAILED = "DEALERADDEDITDSR_FAILED";
export const RESET_DEALERADDEDITDSR = "RESET_DEALERADDEDITDSR";
export const LOADING_DEALERADDEDITDSR = "LOADING_DEALERADDEDITDSR";
export const NETWORK_ERROR_DEALERADDEDITDSR = "NETWORK_ERROR_DEALERADDEDITDSR";

export const DEALERMULTIPLEMAPPINGLIST_SUCCESS =
  "DEALERMULTIPLEMAPPINGLIST_SUCCESS";
export const DEALERMULTIPLEMAPPINGLIST_FAILED =
  "DEALERMULTIPLEMAPPINGLIST_FAILED";
export const RESET_DEALERMULTIPLEMAPPINGLIST =
  "RESET_DEALERMULTIPLEMAPPINGLIST";
export const LOADING_DEALERMULTIPLEMAPPINGLIST =
  "LOADING_DEALERMULTIPLEMAPPINGLIST";
export const NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST =
  "NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST";

export const DEALERCHECKLIST_SUCCESS = "DEALERCHECKLIST_SUCCESS";
export const DEALERCHECKLIST_FAILED = "DEALERCHECKLIST_FAILED";
export const RESET_DEALERCHECKLIST = "RESET_DEALERCHECKLIST";
export const LOADING_DEALERCHECKLIST = "LOADING_DEALERCHECKLIST";
export const NETWORK_ERROR_DEALERCHECKLIST = "NETWORK_ERROR_DEALERCHECKLIST";

export const DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS =
  "DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS";
export const DEALERAGENTDOWNLOADSAMPLEFILE_FAILED =
  "DEALERAGENTDOWNLOADSAMPLEFILE_FAILED";
export const RESET_DEALERAGENTDOWNLOADSAMPLEFILE =
  "RESET_DEALERAGENTDOWNLOADSAMPLEFILE";
export const LOADING_DEALERAGENTDOWNLOADSAMPLEFILE =
  "LOADING_DEALERAGENTDOWNLOADSAMPLEFILE";
export const NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE =
  "NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE";

export const DEALERUPLOADAGENTFILE_SUCCESS = "DEALERUPLOADAGENTFILE_SUCCESS";
export const DEALERUPLOADAGENTFILE_FAILED = "DEALERUPLOADAGENTFILE_FAILED";
export const RESET_DEALERUPLOADAGENTFILE = "RESET_DEALERUPLOADAGENTFILE";
export const LOADING_DEALERUPLOADAGENTFILE = "LOADING_DEALERUPLOADAGENTFILE";
export const NETWORK_ERROR_DEALERUPLOADAGENTFILE =
  "NETWORK_ERROR_DEALERUPLOADAGENTFILE";

export const DEALERAGENTPROFILE_SUCCESS = "DEALERAGENTPROFILE_SUCCESS";
export const DEALERAGENTPROFILE_FAILED = "DEALERAGENTPROFILE_FAILED";
export const RESET_DEALERAGENTPROFILE = "RESET_DEALERAGENTPROFILE";
export const LOADING_DEALERAGENTPROFILE = "LOADING_DEALERAGENTPROFILE";
export const NETWORK_ERROR_DEALERAGENTPROFILE =
  "NETWORK_ERROR_DEALERAGENTPROFILE";

//Dealer--> Agent Master
export const GETROLEDROPLISTFORDEALER_SUCCESS =
  "GETROLEDROPLISTFORDEALER_SUCCESS";
export const GETROLEDROPLISTFORDEALER_FAILED =
  "GETROLEDROPLISTFORDEALER_FAILED";
export const RESET_GETROLEDROPLISTFORDEALER = "RESET_GETROLEDROPLISTFORDEALER";
export const LOADING_GETROLEDROPLISTFORDEALER =
  "LOADING_GETROLEDROPLISTFORDEALER";
export const NETWORK_ERROR_GETROLEDROPLISTFORDEALER =
  "NETWORK_ERROR_GETROLEDROPLISTFORDEALER";

export const GETMERCHANTWIRELIST_SUCCESS = "GETMERCHANTWIRELIST_SUCCESS";
export const GETMERCHANTWIRELIST_FAILED = "GETMERCHANTWIRELIST_FAILED";
export const RESET_GETMERCHANTWIRELIST = "RESET_GETMERCHANTWIRELIST";
export const LOADING_GETMERCHANTWIRELIST = "LOADING_GETMERCHANTWIRELIST";
export const NETWORK_ERROR_GETMERCHANTWIRELIST =
  "NETWORK_ERROR_GETMERCHANTWIRELIST";

export const EDITMERCHANTWIRE_SUCCESS = "EDITMERCHANTWIRE_SUCCESS";
export const EDITMERCHANTWIRE_FAILED = "EDITMERCHANTWIRE_FAILED";
export const RESET_EDITMERCHANTWIRE = "RESET_EDITMERCHANTWIRE";
export const LOADING_EDITMERCHANTWIRE = "LOADING_EDITMERCHANTWIRE";
export const NETWORK_ERROR_EDITMERCHANTWIRE = "NETWORK_ERROR_EDITMERCHANTWIRE";

export const GETMANUALSETTLEMENT_SUCCESS = "GETMANUALSETTLEMENT_SUCCESS";
export const GETMANUALSETTLEMENT_FAILED = "GETMANUALSETTLEMENT_FAILED";
export const RESET_GETMANUALSETTLEMENT = "RESET_GETMANUALSETTLEMENT";
export const LOADING_GETMANUALSETTLEMENT = "LOADING_GETMANUALSETTLEMENT";
export const NETWORK_ERROR_GETMANUALSETTLEMENT =
  "NETWORK_ERROR_GETMANUALSETTLEMENT";

export const GETCHARGEMASTERLIST_SUCCESS = "GETCHARGEMASTERLIST_SUCCESS";
export const GETCHARGEMASTERLIST_FAILED = "GETCHARGEMASTERLIST_FAILED";
export const RESET_GETCHARGEMASTERLIST = "RESET_GETCHARGEMASTERLIST";
export const LOADING_GETCHARGEMASTERLIST = "LOADING_GETCHARGEMASTERLIST";
export const NETWORK_ERROR_GETCHARGEMASTERLIST =
  "NETWORK_ERROR_GETCHARGEMASTERLIST";

export const GETMERCHANTCHARGELIST_SUCCESS = "GETMERCHANTCHARGELIST_SUCCESS";
export const GETMERCHANTCHARGELIST_FAILED = "GETMERCHANTCHARGELIST_FAILED";
export const RESET_GETMERCHANTCHARGELIST = "RESET_GETMERCHANTCHARGELIST";
export const LOADING_GETMERCHANTCHARGELIST = "LOADING_GETMERCHANTCHARGELIST";
export const NETWORK_ERROR_GETMERCHANTCHARGELIST =
  "NETWORK_ERROR_GETMERCHANTCHARGELIST";

export const MERCHANTHISTORY_SUCCESS = "MERCHANTHISTORY_SUCCESS";
export const MERCHANTHISTORY_FAILED = "MERCHANTHISTORY_FAILED";
export const RESET_MERCHANTHISTORY = "RESET_MERCHANTHISTORY";
export const LOADING_MERCHANTHISTORY = "LOADING_MERCHANTHISTORY";
export const NETWORK_ERROR_MERCHANTHISTORY = "NETWORK_ERROR_MERCHANTHISTORY";

export const MODIFYMERCHANT_SUCCESS = "MODIFYMERCHANT_SUCCESS";
export const MODIFYMERCHANT_FAILED = "MODIFYMERCHANT_FAILED";
export const RESET_MODIFYMERCHANT = "RESET_MODIFYMERCHANT";
export const LOADING_MODIFYMERCHANT = "LOADING_MODIFYMERCHANT";
export const NETWORK_ERROR_MODIFYMERCHANT = "NETWORK_ERROR_MODIFYMERCHANT";

export const GETACCOUNTID_SUCCESS = "GETACCOUNTID_SUCCESS";
export const GETACCOUNTID_FAILED = "GETACCOUNTID_FAILED";
export const RESET_GETACCOUNTID = "RESET_GETACCOUNTID";
export const LOADING_GETACCOUNTID = "LOADING_GETACCOUNTID";
export const NETWORK_ERROR_GETACCOUNTID = "NETWORK_ERROR_GETACCOUNTID";

export const GETCHARGENAME_SUCCESS = "GETCHARGENAME_SUCCESS";
export const GETCHARGENAME_FAILED = "GETCHARGENAME_FAILED";
export const RESET_GETCHARGENAME = "RESET_GETCHARGENAME";
export const LOADING_GETCHARGENAME = "LOADING_GETCHARGENAME";
export const NETWORK_ERROR_GETCHARGENAME = "NETWORK_ERROR_GETCHARGENAME";

export const BLOCKUNBLOCKUSER_SUCCESS = "BLOCKUNBLOCKUSER_SUCCESS";
export const BLOCKUNBLOCKUSER_FAILED = "BLOCKUNBLOCKUSER_FAILED";
export const RESET_BLOCKUNBLOCKUSER = "RESET_BLOCKUNBLOCKUSER";
export const LOADING_BLOCKUNBLOCKUSER = "LOADING_BLOCKUNBLOCKUSER";
export const NETWORK_ERROR_BLOCKUNBLOCKUSER = "NETWORK_ERROR_BLOCKUNBLOCKUSER";

export const ADDEDITUSER_SUCCESS = "ADDEDITUSER_SUCCESS";
export const ADDEDITUSER_FAILED = "ADDEDITUSER_FAILED";
export const RESET_ADDEDITUSER = "RESET_ADDEDITUSER";
export const LOADING_ADDEDITUSER = "LOADING_ADDEDITUSER";
export const NETWORK_ERROR_ADDEDITUSER = "NETWORK_ERROR_ADDEDITUSER";

export const DELETEUSER_SUCCESS = "DELETEUSER_SUCCESS";
export const DELETEUSER_FAILED = "DELETEUSER_FAILED";
export const RESET_DELETEUSER = "RESET_DELETEUSER";
export const LOADING_DELETEUSER = "LOADING_DELETEUSER";
export const NETWORK_ERROR_DELETEUSER = "NETWORK_ERROR_DELETEUSER";

export const ADDMERCHANTCHARGE_SUCCESS = "ADDMERCHANTCHARGE_SUCCESS";
export const ADDMERCHANTCHARGE_FAILED = "ADDMERCHANTCHARGE_FAILED";
export const RESET_ADDMERCHANTCHARGE = "RESET_ADDMERCHANTCHARGE";
export const LOADING_ADDMERCHANTCHARGE = "LOADING_ADDMERCHANTCHARGE";
export const NETWORK_ERROR_ADDMERCHANTCHARGE =
  "NETWORK_ERROR_ADDMERCHANTCHARGE";

export const GENERATEMERCHANTWIRELIST_SUCCESS =
  "GENERATEMERCHANTWIRELIST_SUCCESS";
export const GENERATEMERCHANTWIRELIST_FAILED =
  "GENERATEMERCHANTWIRELIST_FAILED";
export const RESET_GENERATEMERCHANTWIRELIST = "RESET_GENERATEMERCHANTWIRELIST";
export const LOADING_GENERATEMERCHANTWIRELIST =
  "LOADING_GENERATEMERCHANTWIRELIST";
export const NETWORK_ERROR_GENERATEMERCHANTWIRELIST =
  "NETWORK_ERROR_GENERATEMERCHANTWIRELIST";

export const GETGATEWAYACCOUNT_SUCCESS = "GETGATEWAYACCOUNT_SUCCESS";
export const GETGATEWAYACCOUNT_FAILED = "GETGATEWAYACCOUNT_FAILED";
export const RESET_GETGATEWAYACCOUNT = "RESET_GETGATEWAYACCOUNT";
export const LOADING_GETGATEWAYACCOUNT = "LOADING_GETGATEWAYACCOUNT";
export const NETWORK_ERROR_GETGATEWAYACCOUNT =
  "NETWORK_ERROR_GETGATEWAYACCOUNT";

export const GATEWAYHISTORY_SUCCESS = "GATEWAYHISTORY_SUCCESS";
export const GATEWAYHISTORY_FAILED = "GATEWAYHISTORY_FAILED";
export const RESET_GATEWAYHISTORY = "RESET_GATEWAYHISTORY";
export const LOADING_GATEWAYHISTORY = "LOADING_GATEWAYHISTORY";
export const NETWORK_ERROR_GATEWAYHISTORY = "NETWORK_ERROR_GATEWAYHISTORY";

export const UPDATEGATEWAYACCOUNT_SUCCESS = "UPDATEGATEWAYACCOUNT_SUCCESS";
export const UPDATEGATEWAYACCOUNT_FAILED = "UPDATEGATEWAYACCOUNT_FAILED";
export const RESET_UPDATEGATEWAYACCOUNT = "RESET_UPDATEGATEWAYACCOUNT";
export const LOADING_UPDATEGATEWAYACCOUNT = "LOADING_UPDATEGATEWAYACCOUNT";
export const NETWORK_ERROR_UPDATEGATEWAYACCOUNT =
  "NETWORK_ERROR_UPDATEGATEWAYACCOUNT";

export const ADDGATEWAYACCOUNT_SUCCESS = "ADDGATEWAYACCOUNT_SUCCESS";
export const ADDGATEWAYACCOUNT_FAILED = "ADDGATEWAYACCOUNT_FAILED";
export const RESET_ADDGATEWAYACCOUNT = "RESET_ADDGATEWAYACCOUNT";
export const LOADING_ADDGATEWAYACCOUNT = "LOADING_ADDGATEWAYACCOUNT";
export const NETWORK_ERROR_ADDGATEWAYACCOUNT =
  "NETWORK_ERROR_ADDGATEWAYACCOUNT";

export const ADDCHARGEMASTER_SUCCESS = "ADDCHARGEMASTER_SUCCESS";
export const ADDCHARGEMASTER_FAILED = "ADDCHARGEMASTER_FAILED";
export const RESET_ADDCHARGEMASTER = "RESET_ADDCHARGEMASTER";
export const LOADING_ADDCHARGEMASTER = "LOADING_ADDCHARGEMASTER";
export const NETWORK_ERROR_ADDCHARGEMASTER = "NETWORK_ERROR_ADDCHARGEMASTER";

export const EDITCHARGEMASTER_SUCCESS = "EDITCHARGEMASTER_SUCCESS";
export const EDITCHARGEMASTER_FAILED = "EDITCHARGEMASTER_FAILED";
export const RESET_EDITCHARGEMASTER = "RESET_EDITCHARGEMASTER";
export const LOADING_EDITCHARGEMASTER = "LOADING_EDITCHARGEMASTER";
export const NETWORK_ERROR_EDITCHARGEMASTER = "NETWORK_ERROR_EDITCHARGEMASTER";

export const DEALERCASHLIFTINGLIST_SUCCESS = "DEALERCASHLIFTINGLIST_SUCCESS";
export const DEALERCASHLIFTINGLIST_FAILED = "DEALERCASHLIFTINGLIST_FAILED";
export const RESET_DEALERCASHLIFTINGLIST = "RESET_DEALERCASHLIFTINGLIST";
export const LOADING_DEALERCASHLIFTINGLIST = "LOADING_DEALERCASHLIFTINGLIST";
export const NETWORK_ERROR_DEALERCASHLIFTINGLIST =
  "NETWORK_ERROR_DEALERCASHLIFTINGLIST";

export const DEALERREQCASHLIFTING_SUCCESS = "DEALERREQCASHLIFTING_SUCCESS";
export const DEALERREQCASHLIFTING_FAILED = "DEALERREQCASHLIFTING_FAILED";
export const RESET_DEALERREQCASHLIFTING = "RESET_DEALERREQCASHLIFTING";
export const LOADING_DEALERREQCASHLIFTING = "LOADING_DEALERREQCASHLIFTING";
export const NETWORK_ERROR_DEALERREQCASHLIFTING =
  "NETWORK_ERROR_DEALERREQCASHLIFTING";

export const DEALERBANKNAME_SUCCESS = "DEALERBANKNAME_SUCCESS";
export const DEALERBANKNAME_FAILED = "DEALERBANKNAME_FAILED";
export const RESET_DEALERBANKNAME = "RESET_DEALERBANKNAME";
export const LOADING_DEALERBANKNAME = "LOADING_DEALERBANKNAME";
export const NETWORK_ERROR_DEALERBANKNAME = "NETWORK_ERROR_DEALERBANKNAME";

export const DEALERBRANCHNAME_SUCCESS = "DEALERBRANCHNAME_SUCCESS";
export const DEALERBRANCHNAME_FAILED = "DEALERBRANCHNAME_FAILED";
export const RESET_DEALERBRANCHNAME = "RESET_DEALERBRANCHNAME";
export const LOADING_DEALERBRANCHNAME = "LOADING_DEALERBRANCHNAME";
export const NETWORK_ERROR_DEALERBRANCHNAME = "NETWORK_ERROR_DEALERBRANCHNAME";

export const DEALERWITHDRAWEMONEYLIST_SUCCESS =
  "DEALERWITHDRAWEMONEYLIST_SUCCESS";
export const DEALERWITHDRAWEMONEYLIST_FAILED =
  "DEALERWITHDRAWEMONEYLIST_FAILED";
export const RESET_DEALERWITHDRAWEMONEYLIST = "RESET_DEALERWITHDRAWEMONEYLIST";
export const LOADING_DEALERWITHDRAWEMONEYLIST =
  "LOADING_DEALERWITHDRAWEMONEYLIST";
export const NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST =
  "NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST";

export const DEALERREQWITHDRAWEMONEY_SUCCESS =
  "DEALERREQWITHDRAWEMONEY_SUCCESS";
export const DEALERREQWITHDRAWEMONEY_FAILED = "DEALERREQWITHDRAWEMONEY_FAILED";
export const RESET_DEALERREQWITHDRAWEMONEY = "RESET_DEALERREQWITHDRAWEMONEY";
export const LOADING_DEALERREQWITHDRAWEMONEY =
  "LOADING_DEALERREQWITHDRAWEMONEY";
export const NETWORK_ERROR_DEALERREQWITHDRAWEMONEY =
  "NETWORK_ERROR_DEALERREQWITHDRAWEMONEY";

export const DEALERGETUSERMASTERLIST_SUCCESS =
  "DEALERGETUSERMASTERLIST_SUCCESS";
export const DEALERGETUSERMASTERLIST_FAILED = "DEALERGETUSERMASTERLIST_FAILED";
export const RESET_DEALERGETUSERMASTERLIST = "RESET_DEALERGETUSERMASTERLIST";
export const LOADING_DEALERGETUSERMASTERLIST =
  "LOADING_DEALERGETUSERMASTERLIST";
export const NETWORK_ERROR_DEALERGETUSERMASTERLIST =
  "NETWORK_ERROR_DEALERGETUSERMASTERLIST";

export const DEALERVIEWUSERMASTER_SUCCESS = "DEALERVIEWUSERMASTER_SUCCESS";
export const DEALERVIEWUSERMASTER_FAILED = "DEALERVIEWUSERMASTER_FAILED";
export const RESET_DEALERVIEWUSERMASTER = "RESET_DEALERVIEWUSERMASTER";
export const LOADING_DEALERVIEWUSERMASTER = "LOADING_DEALERVIEWUSERMASTER";
export const NETWORK_ERROR_DEALERVIEWUSERMASTER =
  "NETWORK_ERROR_DEALERVIEWUSERMASTER";

export const GET_VOUCHER_WIRE_MANAGER_SUCCESS =
  "GET_VOUCHER_WIRE_MANAGER_SUCCESS";
export const GET_VOUCHER_WIRE_MANAGER_FAILED =
  "GET_VOUCHER_WIRE_MANAGER_FAILED";
export const NETWORK_ERROR_VOUCHER_WIRE_MANAGER =
  "NETWORK_ERROR_VOUCHER_WIRE_MANAGER";
export const LOADING_GET_VOUCHER_WIRE_MANAGER =
  "LOADING_GET_VOUCHER_WIRE_MANAGER";
export const RESET_GET_VOUCHER_WIRE_MANAGER = "RESET_GET_VOUCHER_WIRE_MANAGER";

export const UPDATE_ADD_VOUCHER_WIRE_SUCCESS =
  "UPDATE_ADD_VOUCHER_WIRE_SUCCESS";
export const UPDATE_ADD_VOUCHER_WIRE_FAILED = "UPDATE_ADD_VOUCHER_WIRE_FAILED";
export const NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE =
  "NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE";
export const LOADING_UPDATE_ADD_VOUCHER_WIRE =
  "LOADING_UPDATE_ADD_VOUCHER_WIRE";
export const RESET_UPDATE_ADD_VOUCHER_WIRE = "RESET_UPDATE_ADD_VOUCHER_WIRE";

export const GET_ACCOUNT_ID_LIST_SUCCESS = "GET_ACCOUNT_ID_LIST_SUCCESS";
export const GET_ACCOUNT_ID_LIST_FAILED = "GET_ACCOUNT_ID_LIST_FAILED";
export const NETWORK_ERROR_GET_ACCOUNT_ID_LIST =
  "NETWORK_ERROR_GET_ACCOUNT_ID_LIST";
export const LOADING_GET_ACCOUNT_ID_LIST = "LOADING_GET_ACCOUNT_ID_LIST";
export const RESET_GET_ACCOUNT_ID_LIST = "RESET_GET_ACCOUNT_ID_LIST";

export const DEALERADDEDITUSERMASTER_SUCCESS =
  "DEALERADDEDITUSERMASTER_SUCCESS";
export const DEALERADDEDITUSERMASTER_FAILED = "DEALERADDEDITUSERMASTER_FAILED";
export const RESET_DEALERADDEDITUSERMASTER = "RESET_DEALERADDEDITUSERMASTER";
export const LOADING_DEALERADDEDITUSERMASTER =
  "LOADING_DEALERADDEDITUSERMASTER";
export const NETWORK_ERROR_DEALERADDEDITUSERMASTER =
  "NETWORK_ERROR_DEALERADDEDITUSERMASTER";

export const DEALERDELETEUSERMASTER_SUCCESS = "DEALERDELETEUSERMASTER_SUCCESS";
export const DEALERDELETEUSERMASTER_FAILED = "DEALERDELETEUSERMASTER_FAILED";
export const RESET_DEALERDELETEUSERMASTER = "RESET_DEALERDELETEUSERMASTER";
export const LOADING_DEALERDELETEUSERMASTER = "LOADING_DEALERDELETEUSERMASTER";
export const NETWORK_ERROR_DEALERDELETEUSERMASTER =
  "NETWORK_ERROR_DEALERDELETEUSERMASTER";

export const DEALERBLOCKUNBLOCKUSER_SUCCESS = "DEALERBLOCKUNBLOCKUSER_SUCCESS";
export const DEALERBLOCKUNBLOCKUSER_FAILED = "DEALERBLOCKUNBLOCKUSER_FAILED";
export const RESET_DEALERBLOCKUNBLOCKUSER = "RESET_DEALERBLOCKUNBLOCKUSER";
export const LOADING_DEALERBLOCKUNBLOCKUSER = "LOADING_DEALERBLOCKUNBLOCKUSER";
export const NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER =
  "NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER";

export const DEALERACCOUNTNUMBER_SUCCESS = "DEALERACCOUNTNUMBER_SUCCESS";
export const DEALERACCOUNTNUMBER_FAILED = "DEALERACCOUNTNUMBER_FAILED";
export const RESET_DEALERACCOUNTNUMBER = "RESET_DEALERACCOUNTNUMBER";
export const LOADING_DEALERACCOUNTNUMBER = "LOADING_DEALERACCOUNTNUMBER";
export const NETWORK_ERROR_DEALERACCOUNTNUMBER =
  "NETWORK_ERROR_DEALERACCOUNTNUMBER";

//Bank Module Starts

//Bank Master

export const BANKMASTERLIST_SUCCESS = "BANKMASTERLIST_SUCCESS";
export const BANKMASTERLIST_FAILED = "BANKMASTERLIST_FAILED";
export const RESET_BANKMASTERLIST = "RESET_BANKMASTERLIST";
export const LOADING_BANKMASTERLIST = "LOADING_BANKMASTERLIST";
export const BANKMASTERLIST_NETWORKERROR = "BANKMASTERLIST_NETWORKERROR";

export const BANKMASTER_ADDUPDATE_SUCCESS = "BANKMASTER_ADDUPDATE_SUCCESS";
export const BANKMASTER_ADDUPDATE_FAILED = "BANKMASTER_ADDUPDATE_FAILED";
export const RESET_BANKMASTER_ADDUPDATE = "RESET_BANKMASTER_ADDUPDATE";
export const LOADING_BANKMASTER_ADDUPDATE = "LOADING_BANKMASTER_ADDUPDATE";
export const BANKMASTER_ADDUPDATE_NETWORKERROR =
  "BANKMASTER_ADDUPDATE_NETWORKERROR";

export const BANKMASTERVIEW_SUCCESS = "BANKMASTERVIEW_SUCCESS";
export const BANKMASTERVIEW_FAILED = "BANKMASTERVIEW_FAILED";
export const RESET_BANKMASTERVIEW = "RESET_BANKMASTERVIEW";
export const LOADING_BANKMASTERVIEW = "LOADING_BANKMASTERVIEW";
export const BANKMASTERVIEW_NETWORKERROR = "BANKMASTERVIEW_NETWORKERROR";

export const BANKNAMELIST_SUCCESS = "BANKNAMELIST_SUCCESS";
export const BANKNAMELIST_FAILED = "BANKNAMELIST_FAILED";
export const RESET_BANKNAMELIST = "RESET_BANKNAMELIST";
export const LOADING_BANKNAMELIST = "LOADING_BANKNAMELIST";
export const BANKNAMELIST_NETWORKERROR = "BANKNAMELIST_NETWORKERROR";

export const BANKBRANCHLIST_SUCCESS = "BANKBRANCHLIST_SUCCESS";
export const BANKBRANCHLIST_FAILED = "BANKBRANCHLIST_FAILED";
export const RESET_BANKBRANCHLIST = "RESET_BANKBRANCHLIST";
export const LOADING_BANKBRANCHLIST = "LOADING_BANKBRANCHLIST";
export const BANKBRANCHLIST_NETWORKERROR = "BANKBRANCHLIST_NETWORKERROR";

export const BANKDISTRICTLIST_SUCCESS = "BANKDISTRICTLIST_SUCCESS";
export const BANKDISTRICTLIST_FAILED = "BANKDISTRICTLIST_FAILED";
export const RESET_BANKDISTRICTLIST = "RESET_BANKDISTRICTLIST";
export const LOADING_BANKDISTRICTLIST = "LOADING_BANKDISTRICTLIST";
export const BANKDISTRICTLIST_NETWORKERROR = "BANKDISTRICTLIST_NETWORKERROR";

//Withdraw E Money

export const WITHDRAWEMONEYLIST_SUCCESS = "WITHDRAWEMONEYLIST_SUCCESS";
export const WITHDRAWEMONEYLIST_FAILED = "WITHDRAWEMONEYLIST_FAILED";
export const RESET_WITHDRAWEMONEYLIST = "RESET_WITHDRAWEMONEYLIST";
export const LOADING_WITHDRAWEMONEYLIST = "LOADING_WITHDRAWEMONEYLIST";
export const WITHDRAWEMONEYLIST_NETWORKERROR =
  "WITHDRAWEMONEYLIST_NETWORKERROR";

export const WITHDRAWEMONEY_APPROVEREJECT_SUCCESS =
  "WITHDRAWEMONEY_APPROVEREJECT_SUCCESS";
export const WITHDRAWEMONEY_APPROVEREJECT_FAILED =
  "WITHDRAWEMONEY_APPROVEREJECT_FAILED";
export const RESET_WITHDRAWEMONEY_APPROVEREJECT =
  "RESET_WITHDRAWEMONEY_APPROVEREJECT";
export const LOADING_WITHDRAWEMONEY_APPROVEREJECT =
  "LOADING_WITHDRAWEMONEY_APPROVEREJECT";
export const WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR =
  "WITHDRAWEMONEY_APPROVEREJECT_NETWORKERROR";

//Cash Lifting

export const CASHLIFTINGLIST_SUCCESS = "CASHLIFTINGLIST_SUCCESS";
export const CASHLIFTINGLIST_FAILED = "CASHLIFTINGLIST_FAILED";
export const RESET_CASHLIFTINGLIST = "RESET_CASHLIFTINGLIST";
export const LOADING_CASHLIFTINGLIST = "LOADING_CASHLIFTINGLIST";
export const CASHLIFTINGLIST_NETWORKERROR = "CASHLIFTINGLIST_NETWORKERROR";

export const CASHLIFTINGLIST_APPROVEREJECT_SUCCESS =
  "CASHLIFTINGLIST_APPROVEREJECT_SUCCESS";
export const CASHLIFTINGLIST_APPROVEREJECT_FAILED =
  "CASHLIFTINGLIST_APPROVEREJECT_FAILED";
export const RESET_CASHLIFTINGLIST_APPROVEREJECT =
  "RESET_CASHLIFTINGLIST_APPROVEREJECT";
export const LOADING_CASHLIFTINGLIST_APPROVEREJECT =
  "LOADING_CASHLIFTINGLIST_APPROVEREJECT";
export const CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR =
  "CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR";

//User Management

export const GETUSERDETAILLIST_SUCCESS = "GETUSERDETAILLIST_SUCCESS";
export const GETUSERDETAILLIST_FAILED = "GETUSERDETAILLIST_FAILED";
export const RESET_GETUSERDETAILLIST = "RESET_GETUSERDETAILLIST";
export const LOADING_GETUSERDETAILLIST = "LOADING_GETUSERDETAILLIST";
export const GETUSERDETAILLIST_NETWORKERROR = "GETUSERDETAILLIST_NETWORKERROR";

export const ADDUPDATE_USERDETAILS_SUCCESS = "ADDUPDATE_USERDETAILS_SUCCESS";
export const ADDUPDATE_USERDETAILS_FAILED = "ADDUPDATE_USERDETAILS_FAILED";
export const RESET_ADDUPDATE_USERDETAILS = "RESET_ADDUPDATE_USERDETAILS";
export const LOADING_ADDUPDATE_USERDETAILS = "LOADING_ADDUPDATE_USERDETAILS";
export const ADDUPDATE_USERDETAILS_NETWORKERROR =
  "ADDUPDATE_USERDETAILS_NETWORKERROR";

export const DELETE_USERDETAILS_SUCCESS = "DELETE_USERDETAILS_SUCCESS";
export const DELETE_USERDETAILS_FAILED = "DELETE_USERDETAILS_FAILED";
export const RESET_DELETE_USERDETAILS = "RESET_DELETE_USERDETAILS";
export const LOADING_DELETE_USERDETAILS = "LOADING_DELETE_USERDETAILS";
export const DELETE_USERDETAILS_NETWORKERROR =
  "DELETE_USERDETAILS_NETWORKERROR";

export const BLOCK_USERDETAILS_SUCCESS = "BLOCK_USERDETAILS_SUCCESS";
export const BLOCK_USERDETAILS_FAILED = "BLOCK_USERDETAILS_FAILED";
export const RESET_BLOCK_USERDETAILS = "RESET_BLOCK_USERDETAILS";
export const LOADING_BLOCK_USERDETAILS = "LOADING_BLOCK_USERDETAILS";
export const BLOCK_USERDETAILS_NETWORKERROR = "BLOCK_USERDETAILS_NETWORKERROR";

export const BANK_ROLELIST_SUCCESS = "BANK_ROLELIST_SUCCESS";
export const BANK_ROLELIST_FAILED = "BANK_ROLELIST_FAILED";
export const RESET_BANK_ROLELIST = "RESET_BANK_ROLELIST";
export const LOADING_BANK_ROLELIST = "LOADING_BANK_ROLELIST";
export const BANK_ROLELIST_NETWORKERROR = "BANK_ROLELIST_NETWORKERROR";

export const VIEWUSERDETAILS_SUCCESS = "VIEWUSERDETAILS_SUCCESS";
export const VIEWUSERDETAILS_FAILED = "VIEWUSERDETAILS_FAILED";
export const RESET_VIEWUSERDETAILS = "RESET_VIEWUSERDETAILS";
export const LOADING_VIEWUSERDETAILS_ = "LOADING_VIEWUSERDETAILS_";
export const VIEWUSERDETAILS_NETWORKERROR = "VIEWUSERDETAILS_NETWORKERROR";

//Bank Module Ends

//Partner Bank Master Start

export const COUNTRYLISTPARTNER_SUCCESS = "COUNTRYLISTPARTNER_SUCCESS";
export const COUNTRYLISTPARTNER_FAILED = "COUNTRYLISTPARTNER_FAILED";
export const RESET_COUNTRYLISTPARTNER = "RESET_COUNTRYLISTPARTNER";
export const LOADING_COUNTRYLISTPARTNER = "LOADING_COUNTRYLISTPARTNER";
export const NETWORK_ERROR_COUNTRYLISTPARTNER =
  "NETWORK_ERROR_COUNTRYLISTPARTNER";

export const ADDNEWBANKINPARTNER_SUCCESS = "ADDNEWBANKINPARTNER_SUCCESS";
export const ADDNEWBANKINPARTNER_FAILED = "ADDNEWBANKINPARTNER_FAILED";
export const RESET_ADDNEWBANKINPARTNER = "RESET_ADDNEWBANKINPARTNER";
export const LOADING_ADDNEWBANKINPARTNER = "LOADING_ADDNEWBANKINPARTNER";
export const NETWORK_ERROR_ADDNEWBANKINPARTNER =
  "NETWORK_ERROR_ADDNEWBANKINPARTNER";

export const GETMAPPINGBANKALLLIST_SUCCESS = "GETMAPPINGBANKALLLIST_SUCCESS";
export const GETMAPPINGBANKALLLIST_FAILED = "GETMAPPINGBANKALLLIST_FAILED";
export const RESET_GETMAPPINGBANKALLLIST = "RESET_GETMAPPINGBANKALLLIST";
export const LOADING_GETMAPPINGBANKALLLIST = "LOADING_GETMAPPINGBANKALLLIST";
export const NETWORK_ERROR_GETMAPPINGBANKALLLIST =
  "NETWORK_ERROR_GETMAPPINGBANKALLLIST";

export const DELETEBANKMAPPINGFORPARTNER_SUCCESS =
  "DELETEBANKMAPPINGFORPARTNER_SUCCESS";
export const DELETEBANKMAPPINGFORPARTNER_FAILED =
  "DELETEBANKMAPPINGFORPARTNER_FAILED";
export const RESET_DELETEBANKMAPPINGFORPARTNER =
  "RESET_DELETEBANKMAPPINGFORPARTNER";
export const LOADING_DELETEBANKMAPPINGFORPARTNER =
  "LOADING_DELETEBANKMAPPINGFORPARTNER";
export const NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER =
  "NETWORK_ERROR_DELETEBANKMAPPINGFORPARTNER";

export const GETMAPPINGBANKNAMELIST_SUCCESS = "GETMAPPINGBANKNAMELIST_SUCCESS";
export const GETMAPPINGBANKNAMELIST_FAILED = "GETMAPPINGBANKNAMELIST_FAILED";
export const RESET_GETMAPPINGBANKNAMELIST = "RESET_GETMAPPINGBANKNAMELIST";
export const LOADING_GETMAPPINGBANKNAMELIST = "LOADING_GETMAPPINGBANKNAMELIST";
export const NETWORK_ERROR_GETMAPPINGBANKNAMELIST =
  "NETWORK_ERROR_GETMAPPINGBANKNAMELIST";

export const BANKLISTFORPARTNER_SUCCESS = "BANKLISTFORPARTNER_SUCCESS";
export const BANKLISTFORPARTNER_FAILED = "BANKLISTFORPARTNER_FAILED";
export const RESET_BANKLISTFORPARTNER = "RESET_BANKLISTFORPARTNER";
export const LOADING_BANKLISTFORPARTNER = "LOADING_BANKLISTFORPARTNER";
export const NETWORK_ERROR_BANKLISTFORPARTNER =
  "NETWORK_ERROR_BANKLISTFORPARTNER";

export const MAPPINGBANKFORPARTNER_SUCCESS = "MAPPINGBANKFORPARTNER_SUCCESS";
export const MAPPINGBANKFORPARTNER_FAILED = "MAPPINGBANKFORPARTNER_FAILED";
export const RESET_MAPPINGBANKFORPARTNER = "RESET_MAPPINGBANKFORPARTNER";
export const LOADING_MAPPINGBANKFORPARTNER = "LOADING_MAPPINGBANKFORPARTNER";
export const NETWORK_ERROR_MAPPINGBANKFORPARTNER =
  "NETWORK_ERROR_MAPPINGBANKFORPARTNER";

//partner -> Wallet management ->Wallet transaction
export const GETUSERNAMECONTACTSUGGESTION_SUCCESS =
  "GETUSERNAMECONTACTSUGGESTION_SUCCESS";
export const GETUSERNAMECONTACTSUGGESTION_FAILED =
  "GETUSERNAMECONTACTSUGGESTION_FAILED";
export const RESET_GETUSERNAMECONTACTSUGGESTION =
  "RESET_GETUSERNAMECONTACTSUGGESTION";
export const LOADING_GETUSERNAMECONTACTSUGGESTION =
  "LOADING_GETUSERNAMECONTACTSUGGESTION";
export const NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION =
  "NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTION";

export const TRANSACTIONSUBTYPES_SUCCESS = "TRANSACTIONSUBTYPES_SUCCESS";
export const TRANSACTIONSUBTYPES_FAILED = "TRANSACTIONSUBTYPES_FAILED";
export const RESET_TRANSACTIONSUBTYPES = "RESET_TRANSACTIONSUBTYPES";
export const LOADING_TRANSACTIONSUBTYPES = "LOADING_TRANSACTIONSUBTYPES";
export const NETWORK_ERROR_TRANSACTIONSUBTYPES =
  "NETWORK_ERROR_TRANSACTIONSUBTYPES";

//Admin --> Transaction management --> Transaction

export const GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS =
  "GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS";
export const GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED =
  "GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED";
export const RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN =
  "RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN";
export const LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN =
  "LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN";
export const NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN =
  "NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN";

export const GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS =
  "GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS";
export const GETCUSTOMERIDANDNAMELISTADMIN_FAILED =
  "GETCUSTOMERIDANDNAMELISTADMIN_FAILED";
export const RESET_GETCUSTOMERIDANDNAMELISTADMIN =
  "RESET_GETCUSTOMERIDANDNAMELISTADMIN";
export const LOADING_GETCUSTOMERIDANDNAMELISTADMIN =
  "LOADING_GETCUSTOMERIDANDNAMELISTADMIN";
export const NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN =
  "NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN";

//Partner--> Refund
export const GETTRANSACTIONLISTREFUND_SUCCESS =
  "GETTRANSACTIONLISTREFUND_SUCCESS";
export const GETTRANSACTIONLISTREFUND_FAILED =
  "GETTRANSACTIONLISTREFUND_FAILED";
export const RESET_GETTRANSACTIONLISTREFUND = "RESET_GETTRANSACTIONLISTREFUND";
export const LOADING_GETTRANSACTIONLISTREFUND =
  "LOADING_GETTRANSACTIONLISTREFUND";
export const NETWORK_ERROR_GETTRANSACTIONLISTREFUND =
  "NETWORK_ERROR_GETTRANSACTIONLISTREFUND";

//Partner --->Add Notification
export const ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS =
  "ADDUPDATENOTIFICATIONCONFIGPARTNER_SUCCESS";
export const ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED =
  "ADDUPDATENOTIFICATIONCONFIGPARTNER_FAILED";
export const RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER =
  "RESET_ADDUPDATENOTIFICATIONCONFIGPARTNER";
export const LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER =
  "LOADING_ADDUPDATENOTIFICATIONCONFIGPARTNER";
export const NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER =
  "NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGPARTNER";

export const GETNOTIFICATIONCONFIGPARTNER_SUCCESS =
  "GETNOTIFICATIONCONFIGPARTNER_SUCCESS";
export const GETNOTIFICATIONCONFIGPARTNER_FAILED =
  "GETNOTIFICATIONCONFIGPARTNER_FAILED";
export const RESET_GETNOTIFICATIONCONFIGPARTNER =
  "RESET_GETNOTIFICATIONCONFIGPARTNER";
export const LOADING_GETNOTIFICATIONCONFIGPARTNER =
  "LOADING_GETNOTIFICATIONCONFIGPARTNER";
export const NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER =
  "NETWORK_ERROR_GETNOTIFICATIONCONFIGPARTNER";

//Admin Interface ---> Push Notification getNotificationConfigAdmin
//Partner --->Transaction mgmt. Refund
export const GETREFUNDPARTNER_SUCCESS = "GETREFUNDPARTNER_SUCCESS";
export const GETREFUNDPARTNER_FAILED = "GETREFUNDPARTNER_FAILED";
export const RESET_GETREFUNDPARTNER = "RESET_GETREFUNDPARTNER";
export const LOADING_GETREFUNDPARTNER = "LOADING_GETREFUNDPARTNER";
export const NETWORK_ERROR_GETREFUNDPARTNER = "NETWORK_ERROR_GETREFUNDPARTNER";

// Partner ---> Transaction mgmt. Get Chargeback List
export const GETCHARGEBACKLIST_SUCCESS = "GETCHARGEBACKLIST_SUCCESS";
export const GETCHARGEBACKLIST_FAILED = "GETCHARGEBACKLIST_FAILED";
export const RESET_GETCHARGEBACKLIST = "RESET_GETCHARGEBACKLIST";
export const LOADING_GETCHARGEBACKLIST = "LOADING_GETCHARGEBACKLIST";
export const NETWORK_ERROR_GETCHARGEBACKLIST = "NETWORK_ERROR_GETCHARGEBACKLIST";
 

// Partner ---> Transaction mgmt. Update Chargeback
export const UPDATECHARGEBACK_SUCCESS = "UPDATECHARGEBACK_SUCCESS";
export const UPDATECHARGEBACK_FAILED = "UPDATECHARGEBACK_FAILED";
export const RESET_UPDATECHARGEBACK = "RESET_UPDATECHARGEBACK";
export const LOADING_UPDATECHARGEBACK = "LOADING_UPDATECHARGEBACK";
export const NETWORK_ERROR_UPDATECHARGEBACK = "NETWORK_ERROR_UPDATECHARGEBACK";

// uploadToGenerateLink Types
export const UPLOAD_TO_GENERATE_LINK_REQUEST = 'UPLOAD_TO_GENERATE_LINK_REQUEST';
export const UPLOAD_TO_GENERATE_LINK_SUCCESS = 'UPLOAD_TO_GENERATE_LINK_SUCCESS';
export const UPLOAD_TO_GENERATE_LINK_FAILURE = 'UPLOAD_TO_GENERATE_LINK_FAILURE';
export const RESET_UPLOAD_TO_GENERATE_LINK    = 'RESET_UPLOAD_TO_GENERATE_LINK';
 

export const ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS =
  "ADDUPDATENOTIFICATIONCONFIGADMIN_SUCCESS";
export const ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED =
  "ADDUPDATENOTIFICATIONCONFIGADMIN_FAILED";
export const RESET_ADDUPDATENOTIFICATIONCONFIGADMIN =
  "RESET_ADDUPDATENOTIFICATIONCONFIGADMIN";
export const LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN =
  "LOADING_ADDUPDATENOTIFICATIONCONFIGADMIN";
export const NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN =
  "NETWORK_ERROR_ADDUPDATENOTIFICATIONCONFIGADMIN";

export const GETNOTIFICATIONCONFIGADMIN_SUCCESS =
  "GETNOTIFICATIONCONFIGADMIN_SUCCESS";
export const GETNOTIFICATIONCONFIGADMIN_FAILED =
  "GETNOTIFICATIONCONFIGADMIN_FAILED";
export const RESET_GETNOTIFICATIONCONFIGADMIN =
  "RESET_GETNOTIFICATIONCONFIGADMIN";
export const LOADING_GETNOTIFICATIONCONFIGADMIN =
  "LOADING_GETNOTIFICATIONCONFIGADMIN";
export const NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN =
  "NETWORK_ERROR_GETNOTIFICATIONCONFIGADMIN";
// End Admin Interface ---> Push Notification

//ADMIN INTERFCAE-CONFIGURATION(ADD)
export const GETUPDATECONFIGURATIONADMIN_SUCCESS =
  "GETUPDATECONFIGURATIONADMIN_SUCCESS";
export const GETUPDATECONFIGURATIONADMIN_FAILED =
  "GETUPDATECONFIGURATIONADMIN_FAILED";
export const RESET_GETUPDATECONFIGURATIONADMIN =
  "RESET_GETUPDATECONFIGURATIONADMIN";
export const LOADING_GETUPDATECONFIGURATIONADMIN =
  "LOADING_GETUPDATECONFIGURATIONADMIN";
export const NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN =
  "NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN";
// END INTERFECE-CONFIGURATION-----------------------------------------------------------------------

// ADMIN VIEW CONFIGURATION
export const GETVIEWCONGIGURATIONLISTADMIN_SUCCESS =
  "GETVIEWCONGIGURATIONLISTADMIN_SUCCESS";
export const GETVIEWCONGIGURATIONLISTADMIN_FAILED =
  "GETVIEWCONGIGURATIONLISTADMIN_FAILED";
export const RESET_GETVIEWCONGIGURATIONLISTADMIN =
  "RESET_GETVIEWCONGIGURATIONLISTADMIN";
export const LOADING_GETVIEWCONGIGURATIONLISTADMIN =
  "LOADING_GETVIEWCONGIGURATIONLISTADMIN";
export const NETWORK_GETVIEWCONGIGURATIONLISTADMIN =
  "NETWORK_GETVIEWCONGIGURATIONLISTADMIN";
// END INTERFECE-CONFIGURATION-----------------------------------------------------------------------

//ADMIN COMMON CONFIGURATION
export const GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS =
  "GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS";
export const GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED =
  "GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED";
export const RESET_GETCOMMONCONFIGURATIONDETAILSADMIN =
  "RESET_GETCOMMONCONFIGURATIONDETAILSADMIN";
export const LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN =
  "LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN";
export const NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN =
  "NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN";
//END ADMIN COMMON CONFIGURATION ----------------------------------------------------------------------

// GET  UPDATE COMMON CONFIGURATON--------------------------------------------------------------------------

export const GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS =
  "GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS";
export const GETUPDATECOMMOMCONFDETAILSADMIN_FAILED =
  "GETUPDATECOMMOMCONFDETAILSADMIN_FAILED";
export const RESET_GETUPDATECOMMOMCONFDETAILSADMIN =
  "RESET_GETUPDATECOMMOMCONFDETAILSADMIN";
export const LOADING_GETUPDATECOMMOMCONFDETAILSADMIN =
  "LOADING_GETUPDATECOMMOMCONFDETAILSADMIN";
export const NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN =
  "NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN";
// END UPDATE COMMON CONFIGURATON-------------------------------------------------------------------------------

//Partner Interface --> Transaction mgmty-->Inquiry

export const GETINQUIRY_SUCCESS = "GETINQUIRY_SUCCESS";
export const GETINQUIRY_FAILED = "GETINQUIRY_FAILED";
export const RESET_GETINQUIRY = "RESET_GETINQUIRY";
export const LOADING_GETINQUIRY = "LOADING_GETINQUIRY";
export const NETWORK_ERROR_GETINQUIRY = "NETWORK_ERROR_GETINQUIRY";

//ADMIN Interface --> Transaction mgmty-->Inquiry

export const GETINQUIRYADMIN_SUCCESS = "GETINQUIRYADMIN_SUCCESS";
export const GETINQUIRYADMIN_FAILED = "GETINQUIRYADMIN_FAILED";
export const RESET_GETINQUIRYADMIN = "RESET_GETINQUIRYADMIN";
export const LOADING_GETINQUIRYADMIN = "LOADING_GETINQUIRYADMIN";
export const NETWORK_ERROR_GETINQUIRYADMIN = "NETWORK_ERROR_GETINQUIRYADMIN";

//ADMIN Interface --> Transaction mgmty-->Update Inquiry
export const UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS =
  "UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS";
export const UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED =
  "UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED";
export const RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN =
  "RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN";
export const LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN =
  "LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN";
export const NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN =
  "NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN";

//Admin Interface -->Wallet mgmt -->Wallet Transaction
export const UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS =
  "UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS";
export const UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED =
  "UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED";
export const RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN =
  "RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN";
export const LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN =
  "LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN";
export const NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN =
  "NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN";

//Partner Interface -->transaction management --> update status
export const UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS =
  "UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS";
export const UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED =
  "UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED";
export const RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER =
  "RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER";
export const LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER =
  "LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER";
export const NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER =
  "NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER";

//Partner Interface -->Wallet mgmt -->Wallet Transaction
export const UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS =
  "UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS";
export const UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED =
  "UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED";
export const RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER =
  "RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER";
export const LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER =
  "LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER";
export const NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER =
  "NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER";

//Admin Interface -->Wallet mgmt --> Get Refund Details
export const GETREFUNDDETAILSADMIN_SUCCESS = "GETREFUNDDETAILSADMIN_SUCCESS";
export const GETREFUNDDETAILSADMIN_FAILED = "GETREFUNDDETAILSADMIN_FAILED";
export const RESET_GETREFUNDDETAILSADMIN = "RESET_GETREFUNDDETAILSADMIN";
export const LOADING_GETREFUNDDETAILSADMIN = "LOADING_GETREFUNDDETAILSADMIN";
export const NETWORK_ERROR_GETREFUNDDETAILSADMIN =
  "NETWORK_ERROR_GETREFUNDDETAILSADMIN";

//Admin Interface -->Wallet mgmt --> Get Refund Details
export const GETREFUNDDETAILSPARTNER_SUCCESS =
  "GETREFUNDDETAILSPARTNER_SUCCESS";
export const GETREFUNDDETAILSPARTNER_FAILED = "GETREFUNDDETAILSPARTNER_FAILED";
export const RESET_GETREFUNDDETAILSPARTNER = "RESET_GETREFUNDDETAILSPARTNER";
export const LOADING_GETREFUNDDETAILSPARTNER =
  "LOADING_GETREFUNDDETAILSPARTNER";
export const NETWORK_ERROR_GETREFUNDDETAILSPARTNER =
  "NETWORK_ERROR_GETREFUNDDETAILSPARTNER";

// Admin Interface --> Owner mgmt --> addOrUpdateBusinessNatureSubCategory

export const ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS =
  "ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS";
export const ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED =
  "ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED";
export const RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN =
  "RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN";
export const LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN =
  "LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN";
export const NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN =
  "NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN";

// Admin Interface --> Owner mgmt --> getBusinessNatureSubCategoryList

export const GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS =
  "GETBUSINESSNATURESUBCATEGORYLISTADMIN_SUCCESS";
export const GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED =
  "GETBUSINESSNATURESUBCATEGORYLISTADMIN_FAILED";
export const RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN =
  "RESET_GETBUSINESSNATURESUBCATEGORYLISTADMIN";
export const LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN =
  "LOADING_GETBUSINESSNATURESUBCATEGORYLISTADMIN";
export const NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN =
  "NETWORK_ERROR_GETBUSINESSNATURESUBCATEGORYLISTADMIN";

//Admin Interface ---> Settings-->LanguageMaster (editMappingLanguageList)
export const EDITMAPPINGLANGUAGELISTADMIN_SUCCESS =
  "EDITMAPPINGLANGUAGELISTADMIN_SUCCESS";
export const EDITMAPPINGLANGUAGELISTADMIN_FAILED =
  "EDITMAPPINGLANGUAGELISTADMIN_FAILED";
export const RESET_EDITMAPPINGLANGUAGELISTADMIN =
  "RESET_EDITMAPPINGLANGUAGELISTADMIN";
export const LOADING_EDITMAPPINGLANGUAGELISTADMIN =
  "LOADING_EDITMAPPINGLANGUAGELISTADMIN";
export const NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN =
  "NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN";

// PATNER INTERFACE => Account Management => Add Legal Entity

export const BUSINESSNATURESUBCATEGORYTYPE_SUCCESS =
  "BUSINESSNATURESUBCATEGORYTYPE_SUCCESS";
export const BUSINESSNATURESUBCATEGORYTYPE_FAILED =
  "BUSINESSNATURESUBCATEGORYTYPE_FAILED";
export const RESET_BUSINESSNATURESUBCATEGORYTYPE =
  "RESET_BUSINESSNATURESUBCATEGORYTYPE";
export const LOADING_BUSINESSNATURESUBCATEGORYTYPE =
  "LOADING_BUSINESSNATURESUBCATEGORYTYPE";
export const NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE =
  "NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE";
//Partner Interface--> KYC Configuration -->KYC LEVEL
export const UPDATEKYCLABELPARTNER_SUCCESS = "UPDATEKYCLABELPARTNER_SUCCESS";
export const UPDATEKYCLABELPARTNER_FAILED = "UPDATEKYCLABELPARTNER_FAILED";
export const RESET_UPDATEKYCLABELPARTNER = "RESET_UPDATEKYCLABELPARTNER";
export const LOADING_UPDATEKYCLABELPARTNER = "LOADING_UPDATEKYCLABELPARTNER";
export const NETWORK_ERROR_UPDATEKYCLABELPARTNER =
  "NETWORK_ERROR_UPDATEKYCLABELPARTNER";

export const GETKYCLABELPARTNER_SUCCESS = "GETKYCLABELPARTNER_SUCCESS";
export const GETKYCLABELPARTNER_FAILED = "GETKYCLABELPARTNER_FAILED";
export const RESET_GETKYCLABELPARTNER = "RESET_GETKYCLABELPARTNER";
export const LOADING_GETKYCLABELPARTNER = "LOADING_GETKYCLABELPARTNER";
export const NETWORK_ERROR_GETKYCLABELPARTNER = "NETWORK_ERROR_GETKYCLABELPARTNER";

//Admin-Gateway management--
export const GETWAYLISTADMIN_SUCCESS = "GETWAYLISTADMIN_SUCCESS";
export const GETWAYLISTADMIN_FAILED = "GETWAYLISTADMIN_FAILED";
export const RESET_GETWAYLISTADMIN = "RESET_GETWAYLISTADMIN";
export const LOADING_GETWAYLISTADMIN = "LOADING_GETWAYLISTADMIN";
export const NETWORK_ERROR_GETWAYLISTADMIN = "NETWORK_ERROR_GETWAYLISTADMIN";

export const GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS =
  "GETCUSTOMERIDANDNAMEADMINLIST_SUCCESS";
export const GETCUSTOMERIDANDNAMEADMINLIST_FAILED =
  "GETCUSTOMERIDANDNAMEADMINLIST_FAILED";
export const RESET_GETCUSTOMERIDANDNAMEADMINLIST = "RESET_GETCUSTOMERIDANDNAMEADMINLIST";
export const LOADING_GETCUSTOMERIDANDNAMEADMINLIST =
  "LOADING_GETCUSTOMERIDANDNAMEADMINLIST";
export const NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST =
  "NETWORK_ERROR_GETCUSTOMERIDANDNAMEADMINLIST";


///------------------------------///////////////////////////  

// export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS = "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS";
// export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED = "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED";
// export const RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
// export const LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
// export const NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
///------------------------------///////////////////////////  Admin-Transfer Type- Transfer type Mapping compare

export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS = "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS";
export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED = "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED";
export const RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
export const LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
export const NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE = "NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";

///-----Admin--Country Master--CountryMappingCompare----
export const ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS = "ADMIN_COUNTRY_MAPPING_COMPARE_SUCCESS";
export const ADMIN_COUNTRY_MAPPING_COMPARE_FAILED = "ADMIN_COUNTRY_MAPPING_COMPARE_FAILED";
export const RESET_ADMIN_COUNTRY_MAPPING_COMPARE = "RESET_ADMIN_COUNTRY_MAPPING_COMPARE";
export const LOADING_ADMIN_COUNTRY_MAPPING_COMPARE = "LOADING_ADMIN_COUNTRY_MAPPING_COMPARE";
export const NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE = "NETWORK_ERROR_ADMIN_COUNTRY_MAPPING_COMPARE";








// export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS =
//   "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_SUCCESS";
// export const ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED =
//   "ADMIN_TRANSFER_TYPE_MAPPING_COMPARE_FAILED";
// export const RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE =
//   "RESET_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
// export const LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE =
//   "LOADING_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";
// export const NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE =
//   "NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING_COMPARE";


// SMS  PROVIDER>> ADMIN=>SETTING=>SMS_PROVIDER
export const ADDUPDATESMSPROVIDER_SUCCESS = "ADDUPDATESMSPROVIDER_SUCCESS";
export const ADDUPDATESMSPROVIDER_FAILED = "ADDUPDATESMSPROVIDER_SUCCESS";
export const RESET_ADDUPDATESMSPROVIDER = "RESET_ADDUPDATESMSPROVIDER";
export const LOADING_ADDUPDATESMSPROVIDER = "LOADING_ADDUPDATESMSPROVIDER";
export const NETWORK_ERROR_ADDUPDATESMSPROVIDER = "NETWORK_ERROR_ADDUPDATESMSPROVIDER";


export const GETSMSPROVIDER_SUCCESS = "GETSMSPROVIDER_SUCCESS";
export const GETSMSPROVIDER_FAILED = "GETSMSPROVIDER_FAILED";
export const RESET_GETSMSPROVIDER = "RESET_GETSMSPROVIDER";
export const LOADING_GETSMSPROVIDER = "LOADING_GETSMSPROVIDER";
export const NETWORK_GETSMSPROVIDER = "NETWORK_GETSMSPROVIDER";

export const GETSMSPROVIDERDROPDOWN_SUCCESS = "GETSMSPROVIDERDROPDOWN_SUCCESS";
export const GETSMSPROVIDERDROPDOWN_FAILED = "GETSMSPROVIDERDROPDOWN_FAILED";
export const RESET_GETSMSPROVIDERDROPDOWN = "RESET_GETSMSPROVIDERDROPDOWN";
export const LOADING_GETSMSPROVIDERDROPDOWN = "LOADING_GETSMSPROVIDERDROPDOWN";
export const NETWORK_GETSMSPROVIDERDROPDOWN = "NETWORK_GETSMSPROVIDERDROPDOWN";


//Partner-Wallet mgmt-Wallet Transaction:-Accordion
export const GETWALLETTRANSACTIONLISTBYID_SUCCESS = "GETWALLETTRANSACTIONLISTBYID_SUCCESS";
export const GETWALLETTRANSACTIONLISTBYID_FAILED = "GETWALLETTRANSACTIONLISTBYID_FAILED";
export const RESET_GETWALLETTRANSACTIONLISTBYID = "RESET_GETWALLETTRANSACTIONLISTBYID";
export const LOADING_GETWALLETTRANSACTIONLISTBYID = "LOADING_GETWALLETTRANSACTIONLISTBYID";
export const NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID = "NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID";


//Partner-Transaction mgmt--Transaction--Bulk update
export const BULKUPDATESTATUSPARTNER_SUCCESS = "BULKUPDATESTATUSPARTNER_SUCCESS";
export const BULKUPDATESTATUSPARTNER_FAILED = "BULKUPDATESTATUSPARTNER_FAILED";
export const RESET_BULKUPDATESTATUSPARTNER = "RESET_BULKUPDATESTATUSPARTNER";
export const LOADING_BULKUPDATESTATUSPARTNER = "LOADING_BULKUPDATESTATUSPARTNER";
export const NETWORK_ERROR_BULKUPDATESTATUSPARTNER = "NETWORK_ERROR_BULKUPDATESTATUSPARTNER";
// 'ADMIN-WALLET MGMT-WALLET TRANSACTION:-ACCORDION'//
export const ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS = "ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS";
export const ADMINGETWALLETTRANSACTIONLISTBYID_FAILED = "ADMINGETWALLETTRANSACTIONLISTBYID_FAILED";
export const RESET_GETWALLETTRANSACTIONLISTBYIDADMIN = "RESET_GETWALLETTRANSACTIONLISTBYIDADMIN";
export const LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN = "LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN";
export const NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN = "NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN";

// -----------------USER ACTIVITY LOG-------------------------------- //

export const GETUSERACTIVITYLOG_SUCCESS = "GETUSERACTIVITYLOG_SUCCESS";
export const GETUSERACTIVITYLOG_FAILED = "GETUSERACTIVITYLOG_FAILED";
export const RESET_GETUSERACTIVITYLOG = "RESET_GETUSERACTIVITYLOG";
export const LOADING_GETUSERACTIVITYLOG = "LOADING_GETUSERACTIVITYLOG";
export const NETWORK_GETUSERACTIVITYLOG = "NETWORK_GETUSERACTIVITYLOG";

// MODULE NAME && LIST //
export const GETMODULENAMELIST_SUCCESS = "GETMODULENAMELIST_SUCCESS";
export const GETMODULENAMELIST_FAILED = "GETMODULENAMELIST_FAILED";
export const RESET_GETMODULENAMELIST = "RESET_GETMODULENAMELIST";
export const LOADING_GETMODULENAMELIST = "LOADING_GETMODULENAMELIST";
export const NETWORK_GETMODULENAMELIST = "NETWORK_GETMODULENAMELIST";

// ---------------------------------------------------------------------
//Wallet mgmt--wallet transaction--getFeeDetailsById
export const GETFEEDETAILSBYID_SUCCESS= "GETFEEDETAILSBYID_SUCCESS";
export const GETFEEDETAILSBYID_FAILED = "GETFEEDETAILSBYID_FAILED";
export const RESET_GETFEEDETAILSBYID = "RESET_GETFEEDETAILSBYID";
export const LOADING_GETFEEDETAILSBYID  = "LOADING_GETFEEDETAILSBYID";
export const NETWORK_ERROR_GETFEEDETAILSBYID = "NETWORK_ERROR_GETFEEDETAILSBYID";


//settings -activity tracker -> getsubmodulenamelist

export const GETSUBMODULENAMELIST_SUCCESS = "GETSUBMODULENAMELIST_SUCCESS";
export const GETSUBMODULENAMELIST_FAILED = "GETSUBMODULENAMELIST_FAILED";
export const RESET_GETSUBMODULENAMELIST = "RESET_GETSUBMODULENAMELIST";
export const LOADING_GETSUBMODULENAMELIST = "LOADING_GETSUBMODULENAMELIST";
export const NETWORK_ERROR_GETSUBMODULENAMELIST = "NETWORK_ERROR_GETSUBMODULENAMELIST";


export const SET_THEME = "SET_THEME";

//VerifyQrCode OTP
export const VERIFYQRCODEOTP_SUCCESS = "VERIFYQRCODEOTP_SUCCESS";
export const VERIFYQRCODEOTP_FAILED = "VERIFYQRCODEOTP_FAILED";
export const RESET_VERIFYQRCODEOTP = "RESET_VERIFYQRCODEOTP";
export const LOADING_VERIFYQRCODEOTP = "LOADING_VERIFYQRCODEOTP";
export const NETWORK_ERROR_VERIFYQRCODEOTP = "NETWORK_ERROR_VERIFYQRCODEOTP";


//Admin--User Mgmt
export const ADDUPDATESUBADMINMGMT_SUCCESS = "ADDUPDATESUBADMINMGMT_SUCCESS";
export const ADDUPDATESUBADMINMGMT_FAILED = "ADDUPDATESUBADMINMGMT_FAILED";
export const RESET_ADDUPDATESUBADMINMGMT = "RESET_ADDUPDATESUBADMINMGMT";
export const LOADING_ADDUPDATESUBADMINMGMT = "LOADING_ADDUPDATESUBADMINMGMT";
export const NETWORK_ERROR_ADDUPDATESUBADMINMGMT = "NETWORK_ERROR_ADDUPDATESUBADMINMGMT";

export const GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS = "GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS";
export const GETSUBADMINMANAGEMENTLISTADMIN_FAILED = "GETSUBADMINMANAGEMENTLISTADMIN_FAILED";
export const RESET_GETSUBADMINMANAGEMENTLISTADMIN = "RESET_GETSUBADMINMANAGEMENTLISTADMIN";
export const LOADING_GETSUBADMINMANAGEMENTLISTADMIN = "LOADING_GETSUBADMINMANAGEMENTLISTADMIN";
export const NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN = "NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN";

export const VIEWSUBADMINMGMTLISTADMIN_SUCCESS = "VIEWSUBADMINMGMTLISTADMIN_SUCCESS";
export const VIEWSUBADMINMGMTLISTADMIN_FAILED = "VIEWSUBADMINMGMTLISTADMIN_FAILED";
export const RESET_VIEWSUBADMINMGMTLISTADMIN = "RESET_VIEWSUBADMINMGMTLISTADMIN";
export const LOADING_VIEWSUBADMINMGMTLISTADMIN = "LOADING_VIEWSUBADMINMGMTLISTADMIN";
export const NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN = "NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN";

export const GETDELETEMANAGEMENTLISTADMIN_SUCCESS = "GETDELETEMANAGEMENTLISTADMIN_SUCCESS";
export const GETDELETEMANAGEMENTLISTADMIN_FAILED = "GETDELETEMANAGEMENTLISTADMIN_FAILED";
export const RESET_GETDELETEMANAGEMENTLISTADMIN = "RESET_GETDELETEMANAGEMENTLISTADMIN";
export const LOADING_GETDELETEMANAGEMENTLISTADMIN = "LOADING_GETDELETEMANAGEMENTLISTADMIN";
export const NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN = "NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN";

export const BLOCKUNBLOCKSUBADMINLIST_SUCCESS = "BLOCKUNBLOCKSUBADMINLIST_SUCCESS";
export const BLOCKUNBLOCKSUBADMINLIST_FAILED = "BLOCKUNBLOCKSUBADMINLIST_FAILED";
export const RESET_BLOCKUNBLOCKSUBADMINLIST = "RESET_BLOCKUNBLOCKSUBADMINLIST";
export const LOADING_BLOCKUNBLOCKSUBADMINLIST = "LOADING_BLOCKUNBLOCKSUBADMINLIST";
export const NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST = "NETWORK_ERROR_BLOCKUNBLOCKSUBADMINLIST";

//Admin-User Mgmt-->Module Allocation
export const MODULEMASTERLISTFORADMIN_SUCCESS = "MODULEMASTERLISTFORADMIN_SUCCESS";
export const MODULEMASTERLISTFORADMIN_FAILED = "MODULEMASTERLISTFORADMIN_FAILED";
export const RESET_MODULEMASTERLISTFORADMIN = "RESET_MODULEMASTERLISTFORADMIN";
export const LOADING_MODULEMASTERLISTFORADMIN = "LOADING_MODULEMASTERLISTFORADMIN";
export const NETWORK_ERROR_MODULEMASTERLISTFORADMIN = "NETWORK_ERROR_MODULEMASTERLISTFORADMIN";

export const ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS = "ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS";
export const ADDORUPDATEMODULEMASTERFORADMIN_FAILED = "ADDORUPDATEMODULEMASTERFORADMIN_FAILED";
export const RESET_ADDORUPDATEMODULEMASTERFORADMIN = "RESET_ADDORUPDATEMODULEMASTERFORADMIN";
export const LOADING_ADDORUPDATEMODULEMASTERFORADMIN = "LOADING_ADDORUPDATEMODULEMASTERFORADMIN";
export const NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN = "NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN";

export const ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS = "ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS";
export const ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED = "ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED";
export const RESET_ADDORUPDATESUBMODULEMASTERFORADMIN = "RESET_ADDORUPDATESUBMODULEMASTERFORADMIN";
export const LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN = "LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN";
export const NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN = "NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN";

export const GETSUBMODULEMASTERFORADMIN_SUCCESS = "GETSUBMODULEMASTERFORADMIN_SUCCESS";
export const GETSUBMODULEMASTERFORADMIN_FAILED = "GETSUBMODULEMASTERFORADMIN_FAILED";
export const RESET_GETSUBMODULEMASTERFORADMIN = "RESET_GETSUBMODULEMASTERFORADMIN";
export const LOADING_GETSUBMODULEMASTERFORADMIN = "LOADING_GETSUBMODULEMASTERFORADMIN";
export const NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN = "NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN";


//Admin:-Settings-->Module allocation
export const GETSUBADMINDETAILSLISTS_SUCCESS = "GETSUBADMINDETAILSLISTS_SUCCESS";
export const GETSUBADMINDETAILSLISTS_FAILED = "GETSUBADMINDETAILSLISTS_FAILED";
export const RESET_GETSUBADMINDETAILSLISTS = "RESET_GETSUBADMINDETAILSLISTS";
export const LOADING_GETSUBADMINDETAILSLISTS = "LOADING_GETSUBADMINDETAILSLISTS";
export const NETWORK_ERROR_GETSUBADMINDETAILSLISTS = "NETWORK_ERROR_GETSUBADMINDETAILSLISTS";

export const GETMODULEALLOCATIONLISTFORADMIN_SUCCESS = "GETMODULEALLOCATIONLISTFORADMIN_SUCCESS";
export const GETMODULEALLOCATIONLISTFORADMIN_FAILED = "GETMODULEALLOCATIONLISTFORADMIN_FAILED";
export const RESET_GETMODULEALLOCATIONLISTFORADMIN = "RESET_GETMODULEALLOCATIONLISTFORADMIN";
export const LOADING_GETMODULEALLOCATIONLISTFORADMIN = "LOADING_GETMODULEALLOCATIONLISTFORADMIN";
export const NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN = "NETWORK_ERROR_GETMODULEALLOCATIONLISTFORADMIN";

export const GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS = "GETALLOCATEDMODULELISTFORSUBADMIN_SUCCESS";
export const GETALLOCATEDMODULELISTFORSUBADMIN_FAILED = "GETALLOCATEDMODULELISTFORSUBADMIN_FAILED";
export const RESET_GETALLOCATEDMODULELISTFORSUBADMIN = "RESET_GETALLOCATEDMODULELISTFORSUBADMIN";
export const LOADING_GETALLOCATEDMODULELISTFORSUBADMIN = "LOADING_GETALLOCATEDMODULELISTFORSUBADMIN";
export const NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN = "NETWORK_ERROR_GETALLOCATEDMODULELISTFORSUBADMIN";

export const UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS = "UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS";
export const UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED = "UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED";
export const RESET_UPDATEMODULEALLOCATIONLISTFORADMIN = "RESET_UPDATEMODULEALLOCATIONLISTFORADMIN";
export const LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN = "LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN";
export const NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN = "NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN";


export const GETMAPPEDLISTFORADMIN_SUCCESS = "GETMAPPEDLISTFORADMIN_SUCCESS";
export const GETMAPPEDLISTFORADMIN_FAILED = "GETMAPPEDLISTFORADMIN_FAILED";
export const RESET_GETMAPPEDLISTFORADMIN = "RESET_GETMAPPEDLISTFORADMIN";
export const LOADING_GETMAPPEDLISTFORADMIN = " LOADING_GETMAPPEDLISTFORADMIN";
export const NETWORK_ERROR_GETMAPPEDLISTFORADMIN = "NETWORK_ERROR_GETMAPPEDLISTFORADMIN";


//IBAN Provider Mgmt
export const GETPROVIDERTYPE_SUCCESS = "GETPROVIDERTYPE_SUCCESS";
export const GETPROVIDERTYPE_FAILED = "GETPROVIDERTYPE_FAILED";
export const RESET_GETPROVIDERTYPE = "RESET_GETPROVIDERTYPE";
export const LOADING_GETPROVIDERTYPE = "LOADING_GETPROVIDERTYPE";
export const NETWORK_ERROR_GETPROVIDERTYPE = "NETWORK_ERROR_GETPROVIDERTYPE";

export const ADDIBANPROVIDER_SUCCESS = "ADDIBANPROVIDER_SUCCESS";
export const ADDIBANPROVIDER_FAILED = "ADDIBANPROVIDER_FAILED";
export const RESET_ADDIBANPROVIDER = "RESET_ADDIBANPROVIDER";
export const LOADING_ADDIBANPROVIDER = "LOADING_ADDIBANPROVIDER";
export const NETWORK_ERROR_ADDIBANPROVIDER = "NETWORK_ERROR_ADDIBANPROVIDER";


export const GETPROVIDERNAME_SUCCESS = "GETPROVIDERNAME_SUCCESS";
export const GETPROVIDERNAME_FAILED = "GETPROVIDERNAME_FAILED";
export const RESET_GETPROVIDERNAME = "RESET_GETPROVIDERNAME";
export const LOADING_GETPROVIDERNAME = "LOADING_GETPROVIDERNAME";
export const NETWORK_ERROR_GETPROVIDERNAME = "NETWORK_ERROR_GETPROVIDERNAME";

export const GETPROVIDERSADMIN_SUCCESS = "GETPROVIDERSADMIN_SUCCESS";
export const GETPROVIDERSADMIN_FAILED = "GETPROVIDERSADMIN_FAILED";
export const RESET_GETPROVIDERSADMIN = "RESET_GETPROVIDERSADMIN";
export const LOADING_GETPROVIDERSADMIN = "LOADING_GETPROVIDERSADMIN";
export const NETWORK_ERROR_GETPROVIDERSADMIN = "NETWORK_ERROR_GETPROVIDERSADMIN";

export const MAPIBANPROVIDER_SUCCESS = "MAPIBANPROVIDER_SUCCESS";
export const MAPIBANPROVIDER_FAILED = "MAPIBANPROVIDER_FAILED";
export const RESET_MAPIBANPROVIDER = "RESET_MAPIBANPROVIDER";
export const LOADING_MAPIBANPROVIDER = "LOADING_MAPIBANPROVIDER";
export const NETWORK_ERROR_MAPIBANPROVIDER = "NETWORK_ERROR_MAPIBANPROVIDER";

export const GETIBANPROVIDERLIST_SUCCESS = "GETIBANPROVIDERLIST_SUCCESS";
export const GETIBANPROVIDERLIST_FAILED = "GETIBANPROVIDERLIST_FAILED";
export const RESET_GETIBANPROVIDERLIST = "RESET_GETIBANPROVIDERLIST";
export const LOADING_GETIBANPROVIDERLIST = "LOADING_GETIBANPROVIDERLIST";
export const NETWORK_ERROR_GETIBANPROVIDERLIST = "NETWORK_ERROR_GETIBANPROVIDERLIST";

//Account mgmt--Customer banks
export const UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS =
  "UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS";
export const UPDATEORADDCUSTOMERBANKDETAILS_FAILED =
  "UPDATEORADDCUSTOMERBANKDETAILS_FAILED";
export const RESET_UPDATEORADDCUSTOMERBANKDETAILS =
  "RESET_UPDATEORADDCUSTOMERBANKDETAILS";
export const LOADING_UPDATEORADDCUSTOMERBANKDETAILS =
  "LOADING_UPDATEORADDCUSTOMERBANKDETAILS";
export const NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS =
  "NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS";

export const GETCUSTOMERBANKDETAILS_SUCCESS = "GETCUSTOMERBANKDETAILS_SUCCESS";
export const GETCUSTOMERBANKDETAILS_FAILED = "GETCUSTOMERBANKDETAILS_FAILED";
export const RESET_GETCUSTOMERBANKDETAILS = "RESET_GETCUSTOMERBANKDETAILS";
export const LOADING_GETCUSTOMERBANKDETAILS = "LOADING_GETCUSTOMERBANKDETAILS";
export const NETWORK_ERROR_GETCUSTOMERBANKDETAILS = "NETWORK_ERROR_GETCUSTOMERBANKDETAILS";  

export const GETVIEWCUSTOMERBANKDETAILS_SUCCESS =
  "GETVIEWCUSTOMERBANKDETAILS_SUCCESS";
export const GETVIEWCUSTOMERBANKDETAILS_FAILED =
  "GETVIEWCUSTOMERBANKDETAILS_FAILED";
export const RESET_GETVIEWCUSTOMERBANKDETAILS =
  "RESET_GETVIEWCUSTOMERBANKDETAILS";
export const LOADING_GETVIEWCUSTOMERBANKDETAILS =
  " LOADING_GETVIEWCUSTOMERBANKDETAILS";
export const NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS =
  "NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS";


  //Settlement Report for Partner
export const CREATESETTLEMENTREPORTPARTNER_SUCCESS = "CREATESETTLEMENTREPORTPARTNER_SUCCESS";
export const CREATESETTLEMENTREPORTPARTNER_FAILED = "CREATESETTLEMENTREPORTPARTNER_FAILED";
export const RESET_CREATESETTLEMENTREPORTPARTNER = "RESET_CREATESETTLEMENTREPORTPARTNER";
export const LOADING_CREATESETTLEMENTREPORTPARTNER = "LOADING_CREATESETTLEMENTREPORTPARTNER";
export const NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER = "NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER";

export const GETSETTLEMENTREPORTPARTNER_SUCCESS = "GETSETTLEMENTREPORTPARTNER_SUCCESS";
export const GETSETTLEMENTREPORTPARTNER_FAILED = "GETSETTLEMENTREPORTPARTNER_FAILED";
export const RESET_GETSETTLEMENTREPORTPARTNER = "RESET_GETSETTLEMENTREPORTPARTNER";
export const LOADING_GETSETTLEMENTREPORTPARTNER = "LOADING_GETSETTLEMENTREPORTPARTNER";
export const NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER = "NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER";

export const DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS = "DOWNLOADSETTLEMENTREPORTPARTNER_SUCCESS";
export const DOWNLOADSETTLEMENTREPORTPARTNER_FAILED = "DOWNLOADSETTLEMENTREPORTPARTNER_FAILED";
export const RESET_DOWNLOADSETTLEMENTREPORTPARTNER = "RESET_DOWNLOADSETTLEMENTREPORTPARTNER";
export const LOADING_DOWNLOADSETTLEMENTREPORTPARTNER = "LOADING_DOWNLOADSETTLEMENTREPORTPARTNER";
export const NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER = "NETWORK_ERROR_DOWNLOADSETTLEMENTREPORTPARTNER";















